var items = {
  "block.minecraft.acacia_button": "ปุ่มไม้อะเคเซีย",
  "block.minecraft.acacia_door": "ประตูไม้อะเคเซีย",
  "block.minecraft.acacia_fence": "รั้วไม้อะเคเซีย",
  "block.minecraft.acacia_fence_gate": "ประตูรั้วไม้อะเคเซีย",
  "block.minecraft.acacia_hanging_sign": "ป้ายแขวนไม้อะเคเซีย",
  "block.minecraft.acacia_leaves": "ใบไม้อะเคเซีย",
  "block.minecraft.acacia_log": "ท่อนไม้อะเคเซีย",
  "block.minecraft.acacia_planks": "ไม้กระดานอะเคเซีย",
  "block.minecraft.acacia_pressure_plate": "แป้นเหยียบไม้อะเคเซีย",
  "block.minecraft.acacia_sapling": "ต้นอ่อนไม้อะเคเซีย",
  "block.minecraft.acacia_shelf": "ชั้นวางไม้อะเคเซีย",
  "block.minecraft.acacia_sign": "ป้ายไม้อะเคเซีย",
  "block.minecraft.acacia_slab": "แผ่นไม้อะเคเซีย",
  "block.minecraft.acacia_stairs": "บันไดไม้อะเคเซีย",
  "block.minecraft.acacia_trapdoor": "ประตูกับดักไม้อะเคเซีย",
  "block.minecraft.acacia_wall_hanging_sign": "ป้ายแขวนไม้อะเคเซียติดผนัง",
  "block.minecraft.acacia_wall_sign": "ป้ายไม้อะเคเซียติดผนัง",
  "block.minecraft.acacia_wood": "ไม้อะเคเซีย",
  "block.minecraft.activator_rail": "รางจุดชนวน",
  "block.minecraft.air": "อากาศ",
  "block.minecraft.allium": "ดอกอัลเลียม",
  "block.minecraft.amethyst_block": "บล็อกแอเมทิสต์",
  "block.minecraft.amethyst_cluster": "กระจุกแอเมทิสต์",
  "block.minecraft.ancient_debris": "เศษแร่โบราณ",
  "block.minecraft.andesite": "หินแอนดีไซต์",
  "block.minecraft.andesite_slab": "แผ่นหินแอนดีไซต์",
  "block.minecraft.andesite_stairs": "บันไดหินแอนดีไซต์",
  "block.minecraft.andesite_wall": "กำแพงหินแอนดีไซต์",
  "block.minecraft.anvil": "ทั่ง",
  "block.minecraft.attached_melon_stem": "ลำต้นแตงโมแนบติด",
  "block.minecraft.attached_pumpkin_stem": "ลำต้นฟักทองแนบติด",
  "block.minecraft.azalea": "กุหลาบพันปี",
  "block.minecraft.azalea_leaves": "ใบกุหลาบพันปี",
  "block.minecraft.azure_bluet": "ดอกแอเชอร์บลูเอ็ต",
  "block.minecraft.bamboo": "ไม้ไผ่",
  "block.minecraft.bamboo_block": "บล็อกไม้ไผ่",
  "block.minecraft.bamboo_button": "ปุ่มไม้ไผ่",
  "block.minecraft.bamboo_door": "ประตูไม้ไผ่",
  "block.minecraft.bamboo_fence": "รั้วไม้ไผ่",
  "block.minecraft.bamboo_fence_gate": "ประตูรั้วไม้ไผ่",
  "block.minecraft.bamboo_hanging_sign": "ป้ายแบบแขวนไม้ไผ่",
  "block.minecraft.bamboo_mosaic": "ไม้ไผ่สาน",
  "block.minecraft.bamboo_mosaic_slab": "แผ่นไม้ไผ่สาน",
  "block.minecraft.bamboo_mosaic_stairs": "บันไดไม้ไผ่สาน",
  "block.minecraft.bamboo_planks": "ไม้กระดานไผ่",
  "block.minecraft.bamboo_pressure_plate": "แป้นเหยียบไม้ไผ่",
  "block.minecraft.bamboo_sapling": "หน่อไม้",
  "block.minecraft.bamboo_shelf": "ชั้นวางไม้ไผ่",
  "block.minecraft.bamboo_sign": "ป้ายไม้ไผ่",
  "block.minecraft.bamboo_slab": "แผ่นไม้ไผ่",
  "block.minecraft.bamboo_stairs": "บันไดไม้ไผ่",
  "block.minecraft.bamboo_trapdoor": "ประตูกับดักไม้ไผ่",
  "block.minecraft.bamboo_wall_hanging_sign": "ป้ายแขวนไม้ไผ่ติดผนัง",
  "block.minecraft.bamboo_wall_sign": "ป้ายไม้ไผ่ติดผนัง",
  "block.minecraft.banner.base.black": "สีดำทั้งผืน",
  "block.minecraft.banner.base.blue": "สีน้ำเงินทั้งผืน",
  "block.minecraft.banner.base.brown": "สีน้ำตาลทั้งผืน",
  "block.minecraft.banner.base.cyan": "สีฟ้าครามทั้งผืน",
  "block.minecraft.banner.base.gray": "สีเทาทั้งผืน",
  "block.minecraft.banner.base.green": "สีเขียวทั้งผืน",
  "block.minecraft.banner.base.light_blue": "สีฟ้าทั้งผืน",
  "block.minecraft.banner.base.light_gray": "สีเทาอ่อนทั้งผืน",
  "block.minecraft.banner.base.lime": "สีเขียวอ่อนทั้งผืน",
  "block.minecraft.banner.base.magenta": "สีบานเย็นทั้งผืน",
  "block.minecraft.banner.base.orange": "สีส้มทั้งผืน",
  "block.minecraft.banner.base.pink": "สีชมพูทั้งผืน",
  "block.minecraft.banner.base.purple": "สีม่วงทั้งผืน",
  "block.minecraft.banner.base.red": "สีแดงทั้งผืน",
  "block.minecraft.banner.base.white": "สีขาวทั้งผืน",
  "block.minecraft.banner.base.yellow": "สีเหลืองทั้งผืน",
  "block.minecraft.banner.border.black": "ขอบสีดำ",
  "block.minecraft.banner.border.blue": "ขอบสีน้ำเงิน",
  "block.minecraft.banner.border.brown": "ขอบสีน้ำตาล",
  "block.minecraft.banner.border.cyan": "ขอบสีฟ้าคราม",
  "block.minecraft.banner.border.gray": "ขอบสีเทา",
  "block.minecraft.banner.border.green": "ขอบสีเขียว",
  "block.minecraft.banner.border.light_blue": "ขอบสีฟ้า",
  "block.minecraft.banner.border.light_gray": "ขอบสีเทาอ่อน",
  "block.minecraft.banner.border.lime": "ขอบสีเขียวอ่อน",
  "block.minecraft.banner.border.magenta": "ขอบสีบานเย็น",
  "block.minecraft.banner.border.orange": "ขอบสีส้ม",
  "block.minecraft.banner.border.pink": "ขอบสีชมพู",
  "block.minecraft.banner.border.purple": "ขอบสีม่วง",
  "block.minecraft.banner.border.red": "ขอบสีแดง",
  "block.minecraft.banner.border.white": "ขอบสีขาว",
  "block.minecraft.banner.border.yellow": "ขอบสีเหลือง",
  "block.minecraft.banner.bricks.black": "ลายอิฐสีดำ",
  "block.minecraft.banner.bricks.blue": "ลายอิฐสีน้ำเงิน",
  "block.minecraft.banner.bricks.brown": "ลายอิฐสีน้ำตาล",
  "block.minecraft.banner.bricks.cyan": "ลายอิฐสีฟ้าคราม",
  "block.minecraft.banner.bricks.gray": "ลายอิฐสีเทา",
  "block.minecraft.banner.bricks.green": "ลายอิฐสีเขียว",
  "block.minecraft.banner.bricks.light_blue": "ลายอิฐสีฟ้า",
  "block.minecraft.banner.bricks.light_gray": "ลายอิฐสีเทาอ่อน",
  "block.minecraft.banner.bricks.lime": "ลายอิฐสีเขียวอ่อน",
  "block.minecraft.banner.bricks.magenta": "ลายอิฐสีบานเย็น",
  "block.minecraft.banner.bricks.orange": "ลายอิฐสีส้ม",
  "block.minecraft.banner.bricks.pink": "ลายอิฐสีชมพู",
  "block.minecraft.banner.bricks.purple": "ลายอิฐสีม่วง",
  "block.minecraft.banner.bricks.red": "ลายอิฐสีแดง",
  "block.minecraft.banner.bricks.white": "ลายอิฐสีขาว",
  "block.minecraft.banner.bricks.yellow": "ลายอิฐสีเหลือง",
  "block.minecraft.banner.circle.black": "วงกลมสีดำ",
  "block.minecraft.banner.circle.blue": "วงกลมสีน้ำเงิน",
  "block.minecraft.banner.circle.brown": "วงกลมสีน้ำตาล",
  "block.minecraft.banner.circle.cyan": "วงกลมสีฟ้าคราม",
  "block.minecraft.banner.circle.gray": "วงกลมสีเทา",
  "block.minecraft.banner.circle.green": "วงกลมสีเขียว",
  "block.minecraft.banner.circle.light_blue": "วงกลมสีฟ้า",
  "block.minecraft.banner.circle.light_gray": "วงกลมสีเทาอ่อน",
  "block.minecraft.banner.circle.lime": "วงกลมสีเขียวอ่อน",
  "block.minecraft.banner.circle.magenta": "วงกลมสีบานเย็น",
  "block.minecraft.banner.circle.orange": "วงกลมสีส้ม",
  "block.minecraft.banner.circle.pink": "วงกลมสีชมพู",
  "block.minecraft.banner.circle.purple": "วงกลมสีม่วง",
  "block.minecraft.banner.circle.red": "วงกลมสีแดง",
  "block.minecraft.banner.circle.white": "วงกลมสีขาว",
  "block.minecraft.banner.circle.yellow": "วงกลมสีเหลือง",
  "block.minecraft.banner.creeper.black": "ตราสัญลักษณ์ครีปเปอร์สีดำ",
  "block.minecraft.banner.creeper.blue": "ตราสัญลักษณ์ครีปเปอร์สีน้ำเงิน",
  "block.minecraft.banner.creeper.brown": "ตราสัญลักษณ์ครีปเปอร์สีน้ำตาล",
  "block.minecraft.banner.creeper.cyan": "ตราสัญลักษณ์ครีปเปอร์สีฟ้าคราม",
  "block.minecraft.banner.creeper.gray": "ตราสัญลักษณ์ครีปเปอร์สีเทา",
  "block.minecraft.banner.creeper.green": "ตราสัญลักษณ์ครีปเปอร์สีเขียว",
  "block.minecraft.banner.creeper.light_blue": "ตราสัญลักษณ์ครีปเปอร์สีฟ้า",
  "block.minecraft.banner.creeper.light_gray": "ตราสัญลักษณ์ครีปเปอร์สีเทาอ่อน",
  "block.minecraft.banner.creeper.lime": "ตราสัญลักษณ์ครีปเปอร์สีเขียวอ่อน",
  "block.minecraft.banner.creeper.magenta": "ตราสัญลักษณ์ครีปเปอร์สีบานเย็น",
  "block.minecraft.banner.creeper.orange": "ตราสัญลักษณ์ครีปเปอร์สีส้ม",
  "block.minecraft.banner.creeper.pink": "ตราสัญลักษณ์ครีปเปอร์สีชมพู",
  "block.minecraft.banner.creeper.purple": "ตราสัญลักษณ์ครีปเปอร์สีม่วง",
  "block.minecraft.banner.creeper.red": "ตราสัญลักษณ์ครีปเปอร์สีแดง",
  "block.minecraft.banner.creeper.white": "ตราสัญลักษณ์ครีปเปอร์สีขาว",
  "block.minecraft.banner.creeper.yellow": "ตราสัญลักษณ์ครีปเปอร์สีเหลือง",
  "block.minecraft.banner.cross.black": "กางเขนไขว้สีดำ",
  "block.minecraft.banner.cross.blue": "กางเขนไขว้สีน้ำเงิน",
  "block.minecraft.banner.cross.brown": "กางเขนไขว้สีน้ำตาล",
  "block.minecraft.banner.cross.cyan": "กางเขนไขว้สีฟ้าคราม",
  "block.minecraft.banner.cross.gray": "กางเขนไขว้สีเทา",
  "block.minecraft.banner.cross.green": "กางเขนไขว้สีเขียว",
  "block.minecraft.banner.cross.light_blue": "กางเขนไขว้สีฟ้า",
  "block.minecraft.banner.cross.light_gray": "กางเขนไขว้สีเทาอ่อน",
  "block.minecraft.banner.cross.lime": "กางเขนไขว้สีเขียวอ่อน",
  "block.minecraft.banner.cross.magenta": "กางเขนไขว้สีบานเย็น",
  "block.minecraft.banner.cross.orange": "กางเขนไขว้สีส้ม",
  "block.minecraft.banner.cross.pink": "กางเขนไขว้สีชมพู",
  "block.minecraft.banner.cross.purple": "กางเขนไขว้สีม่วง",
  "block.minecraft.banner.cross.red": "กางเขนไขว้สีแดง",
  "block.minecraft.banner.cross.white": "กางเขนไขว้สีขาว",
  "block.minecraft.banner.cross.yellow": "กางเขนไขว้สีเหลือง",
  "block.minecraft.banner.curly_border.black": "ขอบหยิกสีดำ",
  "block.minecraft.banner.curly_border.blue": "ขอบหยิกสีน้ำเงิน",
  "block.minecraft.banner.curly_border.brown": "ขอบหยิกสีน้ำตาล",
  "block.minecraft.banner.curly_border.cyan": "ขอบหยิกสีฟ้าคราม",
  "block.minecraft.banner.curly_border.gray": "ขอบหยิกสีเทา",
  "block.minecraft.banner.curly_border.green": "ขอบหยิกสีเขียว",
  "block.minecraft.banner.curly_border.light_blue": "ขอบหยิกสีฟ้า",
  "block.minecraft.banner.curly_border.light_gray": "ขอบหยิกสีเทาอ่อน",
  "block.minecraft.banner.curly_border.lime": "ขอบหยิกสีเขียวอ่อน",
  "block.minecraft.banner.curly_border.magenta": "ขอบหยิกสีบานเย็น",
  "block.minecraft.banner.curly_border.orange": "ขอบหยิกสีส้ม",
  "block.minecraft.banner.curly_border.pink": "ขอบหยิกสีชมพู",
  "block.minecraft.banner.curly_border.purple": "ขอบหยิกสีม่วง",
  "block.minecraft.banner.curly_border.red": "ขอบหยิกสีแดง",
  "block.minecraft.banner.curly_border.white": "ขอบหยิกสีขาว",
  "block.minecraft.banner.curly_border.yellow": "ขอบหยิกสีเหลือง",
  "block.minecraft.banner.diagonal_left.black": "ทแยงมุมซ้ายสีดำ",
  "block.minecraft.banner.diagonal_left.blue": "ทแยงมุมซ้ายสีน้ำเงิน",
  "block.minecraft.banner.diagonal_left.brown": "ทแยงมุมซ้ายสีน้ำตาล",
  "block.minecraft.banner.diagonal_left.cyan": "ทแยงมุมซ้ายสีฟ้าคราม",
  "block.minecraft.banner.diagonal_left.gray": "ทแยงมุมซ้ายสีเทา",
  "block.minecraft.banner.diagonal_left.green": "ทแยงมุมซ้ายสีเขียว",
  "block.minecraft.banner.diagonal_left.light_blue": "ทแยงมุมซ้ายสีฟ้า",
  "block.minecraft.banner.diagonal_left.light_gray": "ทแยงมุมซ้ายสีเทาอ่อน",
  "block.minecraft.banner.diagonal_left.lime": "ทแยงมุมซ้ายสีเขียวอ่อน",
  "block.minecraft.banner.diagonal_left.magenta": "ทแยงมุมซ้ายสีบานเย็น",
  "block.minecraft.banner.diagonal_left.orange": "ทแยงมุมซ้ายสีส้ม",
  "block.minecraft.banner.diagonal_left.pink": "ทแยงมุมซ้ายสีชมพู",
  "block.minecraft.banner.diagonal_left.purple": "ทแยงมุมซ้ายสีม่วง",
  "block.minecraft.banner.diagonal_left.red": "ทแยงมุมซ้ายสีแดง",
  "block.minecraft.banner.diagonal_left.white": "ทแยงมุมซ้ายสีขาว",
  "block.minecraft.banner.diagonal_left.yellow": "ทแยงมุมซ้ายสีเหลือง",
  "block.minecraft.banner.diagonal_right.black": "ทแยงมุมขวาสีดำ",
  "block.minecraft.banner.diagonal_right.blue": "ทแยงมุมขวาสีน้ำเงิน",
  "block.minecraft.banner.diagonal_right.brown": "ทแยงมุมขวาสีน้ำตาล",
  "block.minecraft.banner.diagonal_right.cyan": "ทแยงมุมขวาสีฟ้าคราม",
  "block.minecraft.banner.diagonal_right.gray": "ทแยงมุมขวาสีเทา",
  "block.minecraft.banner.diagonal_right.green": "ทแยงมุมขวาสีเขียว",
  "block.minecraft.banner.diagonal_right.light_blue": "ทแยงมุมขวาสีฟ้า",
  "block.minecraft.banner.diagonal_right.light_gray": "ทแยงมุมขวาสีเทาอ่อน",
  "block.minecraft.banner.diagonal_right.lime": "ทแยงมุมขวาสีเขียวอ่อน",
  "block.minecraft.banner.diagonal_right.magenta": "ทแยงมุมขวาสีบานเย็น",
  "block.minecraft.banner.diagonal_right.orange": "ทแยงมุมขวาสีส้ม",
  "block.minecraft.banner.diagonal_right.pink": "ทแยงมุมขวาสีชมพู",
  "block.minecraft.banner.diagonal_right.purple": "ทแยงมุมขวาสีม่วง",
  "block.minecraft.banner.diagonal_right.red": "ทแยงมุมขวาสีแดง",
  "block.minecraft.banner.diagonal_right.white": "ทแยงมุมขวาสีขาว",
  "block.minecraft.banner.diagonal_right.yellow": "ทแยงมุมขวาสีเหลือง",
  "block.minecraft.banner.diagonal_up_left.black": "ทแยงมุมซ้ายล่างสีดำ",
  "block.minecraft.banner.diagonal_up_left.blue": "ทแยงมุมซ้ายล่างสีน้ำเงิน",
  "block.minecraft.banner.diagonal_up_left.brown": "ทแยงมุมซ้ายล่างสีน้ำตาล",
  "block.minecraft.banner.diagonal_up_left.cyan": "ทแยงมุมซ้ายล่างสีฟ้าคราม",
  "block.minecraft.banner.diagonal_up_left.gray": "ทแยงมุมซ้ายล่างสีเทา",
  "block.minecraft.banner.diagonal_up_left.green": "ทแยงมุมซ้ายล่างสีเขียว",
  "block.minecraft.banner.diagonal_up_left.light_blue": "ทแยงมุมซ้ายล่างสีฟ้า",
  "block.minecraft.banner.diagonal_up_left.light_gray": "ทแยงมุมซ้ายล่างสีเทาอ่อน",
  "block.minecraft.banner.diagonal_up_left.lime": "ทแยงมุมซ้ายล่างสีเขียวอ่อน",
  "block.minecraft.banner.diagonal_up_left.magenta": "ทแยงมุมซ้ายล่างสีบานเย็น",
  "block.minecraft.banner.diagonal_up_left.orange": "ทแยงมุมซ้ายล่างสีส้ม",
  "block.minecraft.banner.diagonal_up_left.pink": "ทแยงมุมซ้ายล่างสีชมพู",
  "block.minecraft.banner.diagonal_up_left.purple": "ทแยงมุมซ้ายล่างสีม่วง",
  "block.minecraft.banner.diagonal_up_left.red": "ทแยงมุมซ้ายล่างสีแดง",
  "block.minecraft.banner.diagonal_up_left.white": "ทแยงมุมซ้ายล่างสีขาว",
  "block.minecraft.banner.diagonal_up_left.yellow": "ทแยงมุมซ้ายล่างสีเหลือง",
  "block.minecraft.banner.diagonal_up_right.black": "ทแยงมุมขวาล่างสีดำ",
  "block.minecraft.banner.diagonal_up_right.blue": "ทแยงมุมขวาล่างสีน้ำเงิน",
  "block.minecraft.banner.diagonal_up_right.brown": "ทแยงมุมขวาล่างสีน้ำตาล",
  "block.minecraft.banner.diagonal_up_right.cyan": "ทแยงมุมขวาล่างสีฟ้าคราม",
  "block.minecraft.banner.diagonal_up_right.gray": "ทแยงมุมขวาล่างสีเทา",
  "block.minecraft.banner.diagonal_up_right.green": "ทแยงมุมขวาล่างสีเขียว",
  "block.minecraft.banner.diagonal_up_right.light_blue": "ทแยงมุมขวาล่างสีฟ้า",
  "block.minecraft.banner.diagonal_up_right.light_gray": "ทแยงมุมขวาล่างสีเทาอ่อน",
  "block.minecraft.banner.diagonal_up_right.lime": "ทแยงมุมขวาล่างสีเขียวอ่อน",
  "block.minecraft.banner.diagonal_up_right.magenta": "ทแยงมุมขวาล่างสีบานเย็น",
  "block.minecraft.banner.diagonal_up_right.orange": "ทแยงมุมขวาล่างสีส้ม",
  "block.minecraft.banner.diagonal_up_right.pink": "ทแยงมุมขวาล่างสีชมพู",
  "block.minecraft.banner.diagonal_up_right.purple": "ทแยงมุมขวาล่างสีม่วง",
  "block.minecraft.banner.diagonal_up_right.red": "ทแยงมุมขวาล่างสีแดง",
  "block.minecraft.banner.diagonal_up_right.white": "ทแยงมุมขวาล่างสีขาว",
  "block.minecraft.banner.diagonal_up_right.yellow": "ทแยงมุมขวาล่างสีเหลือง",
  "block.minecraft.banner.flow.black": "ไหลวนสีดำ",
  "block.minecraft.banner.flow.blue": "ไหลวนสีน้ำเงิน",
  "block.minecraft.banner.flow.brown": "ไหลวนสีน้ำตาล",
  "block.minecraft.banner.flow.cyan": "ไหลวนสีฟ้าคราม",
  "block.minecraft.banner.flow.gray": "ไหลวนสีเทา",
  "block.minecraft.banner.flow.green": "ไหลวนสีเขียว",
  "block.minecraft.banner.flow.light_blue": "ไหลวนสีฟ้า",
  "block.minecraft.banner.flow.light_gray": "ไหลวนสีเทาอ่อน",
  "block.minecraft.banner.flow.lime": "ไหลวนสีเขียวอ่อน",
  "block.minecraft.banner.flow.magenta": "ไหลวนสีบานเย็น",
  "block.minecraft.banner.flow.orange": "ไหลวนสีส้ม",
  "block.minecraft.banner.flow.pink": "ไหลวนสีชมพู",
  "block.minecraft.banner.flow.purple": "ไหลวนสีม่วง",
  "block.minecraft.banner.flow.red": "ไหลวนสีแดง",
  "block.minecraft.banner.flow.white": "ไหลวนสีขาว",
  "block.minecraft.banner.flow.yellow": "ไหลวนสีเหลือง",
  "block.minecraft.banner.flower.black": "ตราสัญลักษณ์ดอกไม้สีดำ",
  "block.minecraft.banner.flower.blue": "ตราสัญลักษณ์ดอกไม้สีน้ำเงิน",
  "block.minecraft.banner.flower.brown": "ตราสัญลักษณ์ดอกไม้สีน้ำตาล",
  "block.minecraft.banner.flower.cyan": "ตราสัญลักษณ์ดอกไม้สีฟ้าคราม",
  "block.minecraft.banner.flower.gray": "ตราสัญลักษณ์ดอกไม้สีเทา",
  "block.minecraft.banner.flower.green": "ตราสัญลักษณ์ดอกไม้สีเขียว",
  "block.minecraft.banner.flower.light_blue": "ตราสัญลักษณ์ดอกไม้สีฟ้า",
  "block.minecraft.banner.flower.light_gray": "ตราสัญลักษณ์ดอกไม้สีเทาอ่อน",
  "block.minecraft.banner.flower.lime": "ตราสัญลักษณ์ดอกไม้สีเขียวอ่อน",
  "block.minecraft.banner.flower.magenta": "ตราสัญลักษณ์ดอกไม้สีบานเย็น",
  "block.minecraft.banner.flower.orange": "ตราสัญลักษณ์ดอกไม้สีส้ม",
  "block.minecraft.banner.flower.pink": "ตราสัญลักษณ์ดอกไม้สีชมพู",
  "block.minecraft.banner.flower.purple": "ตราสัญลักษณ์ดอกไม้สีม่วง",
  "block.minecraft.banner.flower.red": "ตราสัญลักษณ์ดอกไม้สีแดง",
  "block.minecraft.banner.flower.white": "ตราสัญลักษณ์ดอกไม้สีขาว",
  "block.minecraft.banner.flower.yellow": "ตราสัญลักษณ์ดอกไม้สีเหลือง",
  "block.minecraft.banner.globe.black": "ลูกโลกสีดำ",
  "block.minecraft.banner.globe.blue": "ลูกโลกสีน้ำเงิน",
  "block.minecraft.banner.globe.brown": "ลูกโลกสีน้ำตาล",
  "block.minecraft.banner.globe.cyan": "ลูกโลกสีฟ้าคราม",
  "block.minecraft.banner.globe.gray": "ลูกโลกสีเทา",
  "block.minecraft.banner.globe.green": "ลูกโลกสีเขียว",
  "block.minecraft.banner.globe.light_blue": "ลูกโลกสีฟ้า",
  "block.minecraft.banner.globe.light_gray": "ลูกโลกสีเทาอ่อน",
  "block.minecraft.banner.globe.lime": "ลูกโลกสีเขียวอ่อน",
  "block.minecraft.banner.globe.magenta": "ลูกโลกสีบานเย็น",
  "block.minecraft.banner.globe.orange": "ลูกโลกสีส้ม",
  "block.minecraft.banner.globe.pink": "ลูกโลกสีชมพู",
  "block.minecraft.banner.globe.purple": "ลูกโลกสีม่วง",
  "block.minecraft.banner.globe.red": "ลูกโลกสีแดง",
  "block.minecraft.banner.globe.white": "ลูกโลกสีขาว",
  "block.minecraft.banner.globe.yellow": "ลูกโลกสีเหลือง",
  "block.minecraft.banner.gradient.black": "ไล่ระดับสีดำ",
  "block.minecraft.banner.gradient.blue": "ไล่ระดับสีน้ำเงิน",
  "block.minecraft.banner.gradient.brown": "ไล่ระดับสีน้ำตาล",
  "block.minecraft.banner.gradient.cyan": "ไล่ระดับสีฟ้าคราม",
  "block.minecraft.banner.gradient.gray": "ไล่ระดับสีเทา",
  "block.minecraft.banner.gradient.green": "ไล่ระดับสีเขียว",
  "block.minecraft.banner.gradient.light_blue": "ไล่ระดับสีฟ้า",
  "block.minecraft.banner.gradient.light_gray": "ไล่ระดับสีเทาอ่อน",
  "block.minecraft.banner.gradient.lime": "ไล่ระดับสีเขียวอ่อน",
  "block.minecraft.banner.gradient.magenta": "ไล่ระดับสีบานเย็น",
  "block.minecraft.banner.gradient.orange": "ไล่ระดับสีส้ม",
  "block.minecraft.banner.gradient.pink": "ไล่ระดับสีชมพู",
  "block.minecraft.banner.gradient.purple": "ไล่ระดับสีม่วง",
  "block.minecraft.banner.gradient.red": "ไล่ระดับสีแดง",
  "block.minecraft.banner.gradient.white": "ไล่ระดับสีขาว",
  "block.minecraft.banner.gradient.yellow": "ไล่ระดับสีเหลือง",
  "block.minecraft.banner.gradient_up.black": "ไล่ระดับจากฐานสีดำ",
  "block.minecraft.banner.gradient_up.blue": "ไล่ระดับจากฐานสีน้ำเงิน",
  "block.minecraft.banner.gradient_up.brown": "ไล่ระดับจากฐานสีน้ำตาล",
  "block.minecraft.banner.gradient_up.cyan": "ไล่ระดับจากฐานสีฟ้าคราม",
  "block.minecraft.banner.gradient_up.gray": "ไล่ระดับจากฐานสีเทา",
  "block.minecraft.banner.gradient_up.green": "ไล่ระดับจากฐานสีเขียว",
  "block.minecraft.banner.gradient_up.light_blue": "ไล่ระดับจากฐานสีฟ้า",
  "block.minecraft.banner.gradient_up.light_gray": "ไล่ระดับจากฐานสีเทาอ่อน",
  "block.minecraft.banner.gradient_up.lime": "ไล่ระดับจากฐานสีเขียวอ่อน",
  "block.minecraft.banner.gradient_up.magenta": "ไล่ระดับจากฐานสีบานเย็น",
  "block.minecraft.banner.gradient_up.orange": "ไล่ระดับจากฐานสีส้ม",
  "block.minecraft.banner.gradient_up.pink": "ไล่ระดับจากฐานสีชมพู",
  "block.minecraft.banner.gradient_up.purple": "ไล่ระดับจากฐานสีม่วง",
  "block.minecraft.banner.gradient_up.red": "ไล่ระดับจากฐานสีแดง",
  "block.minecraft.banner.gradient_up.white": "ไล่ระดับจากฐานสีขาว",
  "block.minecraft.banner.gradient_up.yellow": "ไล่ระดับจากฐานสีเหลือง",
  "block.minecraft.banner.guster.black": "ลมกระโชกสีดำ",
  "block.minecraft.banner.guster.blue": "ลมกระโชกสีน้ำเงิน",
  "block.minecraft.banner.guster.brown": "ลมกระโชกสีน้ำตาล",
  "block.minecraft.banner.guster.cyan": "ลมกระโชกสีฟ้าคราม",
  "block.minecraft.banner.guster.gray": "ลมกระโชกสีเทา",
  "block.minecraft.banner.guster.green": "ลมกระโชกสีเขียว",
  "block.minecraft.banner.guster.light_blue": "ลมกระโชกสีฟ้า",
  "block.minecraft.banner.guster.light_gray": "ลมกระโชกสีเทาอ่อน",
  "block.minecraft.banner.guster.lime": "ลมกระโชกสีเขียวอ่อน",
  "block.minecraft.banner.guster.magenta": "ลมกระโชกสีบานเย็น",
  "block.minecraft.banner.guster.orange": "ลมกระโชกสีส้ม",
  "block.minecraft.banner.guster.pink": "ลมกระโชกสีชมพู",
  "block.minecraft.banner.guster.purple": "ลมกระโชกสีม่วง",
  "block.minecraft.banner.guster.red": "ลมกระโชกสีแดง",
  "block.minecraft.banner.guster.white": "ลมกระโชกสีขาว",
  "block.minecraft.banner.guster.yellow": "ลมกระโชกสีเหลือง",
  "block.minecraft.banner.half_horizontal.black": "ครึ่งบนสีดำ",
  "block.minecraft.banner.half_horizontal.blue": "ครึ่งบนสีน้ำเงิน",
  "block.minecraft.banner.half_horizontal.brown": "ครึ่งบนสีน้ำตาล",
  "block.minecraft.banner.half_horizontal.cyan": "ครึ่งบนสีฟ้าคราม",
  "block.minecraft.banner.half_horizontal.gray": "ครึ่งบนสีเทา",
  "block.minecraft.banner.half_horizontal.green": "ครึ่งบนสีเขียว",
  "block.minecraft.banner.half_horizontal.light_blue": "ครึ่งบนสีฟ้า",
  "block.minecraft.banner.half_horizontal.light_gray": "ครึ่งบนสีเทาอ่อน",
  "block.minecraft.banner.half_horizontal.lime": "ครึ่งบนสีเขียวอ่อน",
  "block.minecraft.banner.half_horizontal.magenta": "ครึ่งบนสีบานเย็น",
  "block.minecraft.banner.half_horizontal.orange": "ครึ่งบนสีส้ม",
  "block.minecraft.banner.half_horizontal.pink": "ครึ่งบนสีชมพู",
  "block.minecraft.banner.half_horizontal.purple": "ครึ่งบนสีม่วง",
  "block.minecraft.banner.half_horizontal.red": "ครึ่งบนสีแดง",
  "block.minecraft.banner.half_horizontal.white": "ครึ่งบนสีขาว",
  "block.minecraft.banner.half_horizontal.yellow": "ครึ่งบนสีเหลือง",
  "block.minecraft.banner.half_horizontal_bottom.black": "ครึ่งล่างสีดำ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "ครึ่งล่างสีน้ำเงิน",
  "block.minecraft.banner.half_horizontal_bottom.brown": "ครึ่งล่างสีน้ำตาล",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "ครึ่งล่างสีฟ้าคราม",
  "block.minecraft.banner.half_horizontal_bottom.gray": "ครึ่งล่างสีเทา",
  "block.minecraft.banner.half_horizontal_bottom.green": "ครึ่งล่างสีเขียว",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "ครึ่งล่างสีฟ้า",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "ครึ่งล่างสีเทาอ่อน",
  "block.minecraft.banner.half_horizontal_bottom.lime": "ครึ่งล่างสีเขียวอ่อน",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "ครึ่งล่างสีบานเย็น",
  "block.minecraft.banner.half_horizontal_bottom.orange": "ครึ่งล่างสีส้ม",
  "block.minecraft.banner.half_horizontal_bottom.pink": "ครึ่งล่างสีชมพู",
  "block.minecraft.banner.half_horizontal_bottom.purple": "ครึ่งล่างสีม่วง",
  "block.minecraft.banner.half_horizontal_bottom.red": "ครึ่งล่างสีแดง",
  "block.minecraft.banner.half_horizontal_bottom.white": "ครึ่งล่างสีขาว",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "ครึ่งล่างสีเหลือง",
  "block.minecraft.banner.half_vertical.black": "ครึ่งซ้ายสีดำ",
  "block.minecraft.banner.half_vertical.blue": "ครึ่งซ้ายสีน้ำเงิน",
  "block.minecraft.banner.half_vertical.brown": "ครึ่งซ้ายสีน้ำตาล",
  "block.minecraft.banner.half_vertical.cyan": "ครึ่งซ้ายสีฟ้าคราม",
  "block.minecraft.banner.half_vertical.gray": "ครึ่งซ้ายสีเทา",
  "block.minecraft.banner.half_vertical.green": "ครึ่งซ้ายสีเขียว",
  "block.minecraft.banner.half_vertical.light_blue": "ครึ่งซ้ายสีฟ้า",
  "block.minecraft.banner.half_vertical.light_gray": "ครึ่งซ้ายสีเทาอ่อน",
  "block.minecraft.banner.half_vertical.lime": "ครึ่งซ้ายสีเขียวอ่อน",
  "block.minecraft.banner.half_vertical.magenta": "ครึ่งซ้ายสีบานเย็น",
  "block.minecraft.banner.half_vertical.orange": "ครึ่งซ้ายสีส้ม",
  "block.minecraft.banner.half_vertical.pink": "ครึ่งซ้ายสีชมพู",
  "block.minecraft.banner.half_vertical.purple": "ครึ่งซ้ายสีม่วง",
  "block.minecraft.banner.half_vertical.red": "ครึ่งซ้ายสีแดง",
  "block.minecraft.banner.half_vertical.white": "ครึ่งซ้ายสีขาว",
  "block.minecraft.banner.half_vertical.yellow": "ครึ่งซ้ายสีเหลือง",
  "block.minecraft.banner.half_vertical_right.black": "ครึ่งขวาสีดำ",
  "block.minecraft.banner.half_vertical_right.blue": "ครึ่งขวาสีน้ำเงิน",
  "block.minecraft.banner.half_vertical_right.brown": "ครึ่งขวาสีน้ำตาล",
  "block.minecraft.banner.half_vertical_right.cyan": "ครึ่งขวาสีฟ้าคราม",
  "block.minecraft.banner.half_vertical_right.gray": "ครึ่งขวาสีเทา",
  "block.minecraft.banner.half_vertical_right.green": "ครึ่งขวาสีเขียว",
  "block.minecraft.banner.half_vertical_right.light_blue": "ครึ่งขวาสีฟ้า",
  "block.minecraft.banner.half_vertical_right.light_gray": "ครึ่งขวาสีเทาอ่อน",
  "block.minecraft.banner.half_vertical_right.lime": "ครึ่งขวาสีเขียวอ่อน",
  "block.minecraft.banner.half_vertical_right.magenta": "ครึ่งขวาสีบานเย็น",
  "block.minecraft.banner.half_vertical_right.orange": "ครึ่งขวาสีส้ม",
  "block.minecraft.banner.half_vertical_right.pink": "ครึ่งขวาสีชมพู",
  "block.minecraft.banner.half_vertical_right.purple": "ครึ่งขวาสีม่วง",
  "block.minecraft.banner.half_vertical_right.red": "ครึ่งขวาสีแดง",
  "block.minecraft.banner.half_vertical_right.white": "ครึ่งขวาสีขาว",
  "block.minecraft.banner.half_vertical_right.yellow": "ครึ่งขวาสีเหลือง",
  "block.minecraft.banner.mojang.black": "สิ่งสีดำ",
  "block.minecraft.banner.mojang.blue": "สิ่งสีน้ำเงิน",
  "block.minecraft.banner.mojang.brown": "สิ่งสีน้ำตาล",
  "block.minecraft.banner.mojang.cyan": "สิ่งสีฟ้าคราม",
  "block.minecraft.banner.mojang.gray": "สิ่งสีเทา",
  "block.minecraft.banner.mojang.green": "สิ่งสีเขียว",
  "block.minecraft.banner.mojang.light_blue": "สิ่งสีฟ้า",
  "block.minecraft.banner.mojang.light_gray": "สิ่งสีเทาอ่อน",
  "block.minecraft.banner.mojang.lime": "สิ่งสีเขียวอ่อน",
  "block.minecraft.banner.mojang.magenta": "สิ่งสีบานเย็น",
  "block.minecraft.banner.mojang.orange": "สิ่งสีส้ม",
  "block.minecraft.banner.mojang.pink": "สิ่งสีชมพู",
  "block.minecraft.banner.mojang.purple": "สิ่งสีม่วง",
  "block.minecraft.banner.mojang.red": "สิ่งสีแดง",
  "block.minecraft.banner.mojang.white": "สิ่งสีขาว",
  "block.minecraft.banner.mojang.yellow": "สิ่งสีเหลือง",
  "block.minecraft.banner.piglin.black": "จมูกหมูสีดำ",
  "block.minecraft.banner.piglin.blue": "จมูกหมูสีน้ำเงิน",
  "block.minecraft.banner.piglin.brown": "จมูกหมูสีน้ำตาล",
  "block.minecraft.banner.piglin.cyan": "จมูกหมูสีฟ้าคราม",
  "block.minecraft.banner.piglin.gray": "จมูกหมูสีเทา",
  "block.minecraft.banner.piglin.green": "จมูกหมูสีเขียว",
  "block.minecraft.banner.piglin.light_blue": "จมูกหมูสีฟ้า",
  "block.minecraft.banner.piglin.light_gray": "จมูกหมูสีเทาอ่อน",
  "block.minecraft.banner.piglin.lime": "จมูกหมูสีเขียวอ่อน",
  "block.minecraft.banner.piglin.magenta": "จมูกหมูสีบานเย็น",
  "block.minecraft.banner.piglin.orange": "จมูกหมูสีส้ม",
  "block.minecraft.banner.piglin.pink": "จมูกหมูสีชมพู",
  "block.minecraft.banner.piglin.purple": "จมูกหมูสีม่วง",
  "block.minecraft.banner.piglin.red": "จมูกหมูสีแดง",
  "block.minecraft.banner.piglin.white": "จมูกหมูสีขาว",
  "block.minecraft.banner.piglin.yellow": "จมูกหมูสีเหลือง",
  "block.minecraft.banner.rhombus.black": "ข้าวหลามตัดสีดำ",
  "block.minecraft.banner.rhombus.blue": "ข้าวหลามตัดสีน้ำเงิน",
  "block.minecraft.banner.rhombus.brown": "ข้าวหลามตัดสีน้ำตาล",
  "block.minecraft.banner.rhombus.cyan": "ข้าวหลามตัดสีฟ้าคราม",
  "block.minecraft.banner.rhombus.gray": "ข้าวหลามตัดสีเทา",
  "block.minecraft.banner.rhombus.green": "ข้าวหลามตัดสีเขียว",
  "block.minecraft.banner.rhombus.light_blue": "ข้าวหลามตัดสีฟ้า",
  "block.minecraft.banner.rhombus.light_gray": "ข้าวหลามตัดสีเทาอ่อน",
  "block.minecraft.banner.rhombus.lime": "ข้าวหลามตัดสีเขียวอ่อน",
  "block.minecraft.banner.rhombus.magenta": "ข้าวหลามตัดสีบานเย็น",
  "block.minecraft.banner.rhombus.orange": "ข้าวหลามตัดสีส้ม",
  "block.minecraft.banner.rhombus.pink": "ข้าวหลามตัดสีชมพู",
  "block.minecraft.banner.rhombus.purple": "ข้าวหลามตัดสีม่วง",
  "block.minecraft.banner.rhombus.red": "ข้าวหลามตัดสีแดง",
  "block.minecraft.banner.rhombus.white": "ข้าวหลามตัดสีขาว",
  "block.minecraft.banner.rhombus.yellow": "ข้าวหลามตัดสีเหลือง",
  "block.minecraft.banner.skull.black": "ตราสัญลักษณ์กะโหลกสีดำ",
  "block.minecraft.banner.skull.blue": "ตราสัญลักษณ์กะโหลกสีน้ำเงิน",
  "block.minecraft.banner.skull.brown": "ตราสัญลักษณ์กะโหลกสีน้ำตาล",
  "block.minecraft.banner.skull.cyan": "ตราสัญลักษณ์กระโหลกสีฟ้าคราม",
  "block.minecraft.banner.skull.gray": "ตราสัญลักษณ์กะโหลกสีเทา",
  "block.minecraft.banner.skull.green": "ตราสัญลักษณ์กะโหลกสีเขียว",
  "block.minecraft.banner.skull.light_blue": "ตราสัญลักษณ์กระโหลกสีฟ้า",
  "block.minecraft.banner.skull.light_gray": "ตราสัญลักษณ์กะโหลกสีเทาอ่อน",
  "block.minecraft.banner.skull.lime": "ตราสัญลักษณ์กะโหลกสีเขียวอ่อน",
  "block.minecraft.banner.skull.magenta": "ตราสัญลักษณ์กะโหลกสีบานเย็น",
  "block.minecraft.banner.skull.orange": "ตราสัญลักษณ์กะโหลกสีส้ม",
  "block.minecraft.banner.skull.pink": "ตราสัญลักษณ์กะโหลกสีชมพู",
  "block.minecraft.banner.skull.purple": "ตราสัญลักษณ์กะโหลกสีม่วง",
  "block.minecraft.banner.skull.red": "ตราสัญลักษณ์กะโหลกสีแดง",
  "block.minecraft.banner.skull.white": "ตราสัญลักษณ์กะโหลกสีขาว",
  "block.minecraft.banner.skull.yellow": "ตราสัญลักษณ์กะโหลกสีเหลือง",
  "block.minecraft.banner.small_stripes.black": "ริ้วสีดำ",
  "block.minecraft.banner.small_stripes.blue": "ริ้วสีน้ำเงิน",
  "block.minecraft.banner.small_stripes.brown": "ริ้วสีน้ำตาล",
  "block.minecraft.banner.small_stripes.cyan": "ริ้วสีฟ้าคราม",
  "block.minecraft.banner.small_stripes.gray": "ริ้วสีเทา",
  "block.minecraft.banner.small_stripes.green": "ริ้วสีเขียว",
  "block.minecraft.banner.small_stripes.light_blue": "ริ้วสีฟ้า",
  "block.minecraft.banner.small_stripes.light_gray": "ริ้วสีเทาอ่อน",
  "block.minecraft.banner.small_stripes.lime": "ริ้วสีเขียวอ่อน",
  "block.minecraft.banner.small_stripes.magenta": "ริ้วสีบานเย็น",
  "block.minecraft.banner.small_stripes.orange": "ริ้วสีส้ม",
  "block.minecraft.banner.small_stripes.pink": "ริ้วสีชมพู",
  "block.minecraft.banner.small_stripes.purple": "ริ้วสีม่วง",
  "block.minecraft.banner.small_stripes.red": "ริ้วสีแดง",
  "block.minecraft.banner.small_stripes.white": "ริ้วสีขาว",
  "block.minecraft.banner.small_stripes.yellow": "ริ้วสีเหลือง",
  "block.minecraft.banner.square_bottom_left.black": "ฐานตัดซ้ายล่างสีดำ",
  "block.minecraft.banner.square_bottom_left.blue": "ฐานตัดซ้ายล่างสีน้ำเงิน",
  "block.minecraft.banner.square_bottom_left.brown": "ฐานตัดซ้ายล่างสีน้ำตาล",
  "block.minecraft.banner.square_bottom_left.cyan": "ฐานตัดซ้ายล่างสีฟ้าคราม",
  "block.minecraft.banner.square_bottom_left.gray": "ฐานตัดซ้ายล่างสีเทา",
  "block.minecraft.banner.square_bottom_left.green": "ฐานตัดซ้ายล่างสีเขียว",
  "block.minecraft.banner.square_bottom_left.light_blue": "ฐานตัดซ้ายล่างสีฟ้า",
  "block.minecraft.banner.square_bottom_left.light_gray": "ฐานตัดซ้ายล่างสีเทาอ่อน",
  "block.minecraft.banner.square_bottom_left.lime": "ฐานตัดซ้ายล่างสีเขียวอ่อน",
  "block.minecraft.banner.square_bottom_left.magenta": "ฐานตัดซ้ายล่างสีบานเย็น",
  "block.minecraft.banner.square_bottom_left.orange": "ฐานตัดซ้ายล่างสีส้ม",
  "block.minecraft.banner.square_bottom_left.pink": "ฐานตัดซ้ายล่างสีชมพู",
  "block.minecraft.banner.square_bottom_left.purple": "ฐานตัดซ้ายล่างสีม่วง",
  "block.minecraft.banner.square_bottom_left.red": "ฐานตัดซ้ายล่างสีแดง",
  "block.minecraft.banner.square_bottom_left.white": "ฐานตัดซ้ายล่างสีขาว",
  "block.minecraft.banner.square_bottom_left.yellow": "ฐานตัดซ้ายล่างสีเหลือง",
  "block.minecraft.banner.square_bottom_right.black": "ฐานตัดขวาล่างสีดำ",
  "block.minecraft.banner.square_bottom_right.blue": "ฐานตัดขวาล่างสีน้ำเงิน",
  "block.minecraft.banner.square_bottom_right.brown": "ฐานตัดขวาล่างสีน้ำตาล",
  "block.minecraft.banner.square_bottom_right.cyan": "ฐานตัดขวาล่างสีฟ้าคราม",
  "block.minecraft.banner.square_bottom_right.gray": "ฐานตัดขวาล่างสีเทา",
  "block.minecraft.banner.square_bottom_right.green": "ฐานตัดขวาล่างสีเขียว",
  "block.minecraft.banner.square_bottom_right.light_blue": "ฐานตัดขวาล่างสีฟ้า",
  "block.minecraft.banner.square_bottom_right.light_gray": "ฐานตัดขวาล่างสีเทาอ่อน",
  "block.minecraft.banner.square_bottom_right.lime": "ฐานตัดขวาล่างสีเขียวอ่อน",
  "block.minecraft.banner.square_bottom_right.magenta": "ฐานตัดขวาล่างสีบานเย็น",
  "block.minecraft.banner.square_bottom_right.orange": "ฐานตัดขวาล่างสีส้ม",
  "block.minecraft.banner.square_bottom_right.pink": "ฐานตัดขวาล่างสีชมพู",
  "block.minecraft.banner.square_bottom_right.purple": "ฐานตัดขวาล่างสีม่วง",
  "block.minecraft.banner.square_bottom_right.red": "ฐานตัดขวาล่างสีแดง",
  "block.minecraft.banner.square_bottom_right.white": "ฐานตัดขวาล่างสีขาว",
  "block.minecraft.banner.square_bottom_right.yellow": "ฐานตัดขวาล่างสีเหลือง",
  "block.minecraft.banner.square_top_left.black": "มุมซ้ายบนสีดำ",
  "block.minecraft.banner.square_top_left.blue": "มุมซ้ายบนสีน้ำเงิน",
  "block.minecraft.banner.square_top_left.brown": "มุมซ้ายบนสีน้ำตาล",
  "block.minecraft.banner.square_top_left.cyan": "มุมซ้ายบนสีฟ้าคราม",
  "block.minecraft.banner.square_top_left.gray": "มุมซ้ายบนสีเทา",
  "block.minecraft.banner.square_top_left.green": "มุมซ้ายบนสีเขียว",
  "block.minecraft.banner.square_top_left.light_blue": "มุมซ้ายบนสีฟ้า",
  "block.minecraft.banner.square_top_left.light_gray": "มุมซ้ายบนสีเทาอ่อน",
  "block.minecraft.banner.square_top_left.lime": "มุมซ้ายบนสีเขียวอ่อน",
  "block.minecraft.banner.square_top_left.magenta": "มุมซ้ายบนสีบานเย็น",
  "block.minecraft.banner.square_top_left.orange": "มุมซ้ายบนสีส้ม",
  "block.minecraft.banner.square_top_left.pink": "มุมซ้ายบนสีชมพู",
  "block.minecraft.banner.square_top_left.purple": "มุมซ้ายบนสีม่วง",
  "block.minecraft.banner.square_top_left.red": "มุมซ้ายบนสีแดง",
  "block.minecraft.banner.square_top_left.white": "มุมซ้ายบนสีขาว",
  "block.minecraft.banner.square_top_left.yellow": "มุมซ้ายบนสีเหลือง",
  "block.minecraft.banner.square_top_right.black": "มุมขวาบนสีดำ",
  "block.minecraft.banner.square_top_right.blue": "มุมขวาบนสีน้ำเงิน",
  "block.minecraft.banner.square_top_right.brown": "มุมขวาบนสีน้ำตาล",
  "block.minecraft.banner.square_top_right.cyan": "มุมขวาบนสีฟ้าคราม",
  "block.minecraft.banner.square_top_right.gray": "มุมขวาบนสีเทา",
  "block.minecraft.banner.square_top_right.green": "มุมขวาบนสีเขียว",
  "block.minecraft.banner.square_top_right.light_blue": "มุมขวาบนสีฟ้า",
  "block.minecraft.banner.square_top_right.light_gray": "มุมขวาบนสีเทาอ่อน",
  "block.minecraft.banner.square_top_right.lime": "มุมขวาบนสีเขียวอ่อน",
  "block.minecraft.banner.square_top_right.magenta": "มุมขวาบนสีบานเย็น",
  "block.minecraft.banner.square_top_right.orange": "มุมขวาบนสีส้ม",
  "block.minecraft.banner.square_top_right.pink": "มุมขวาบนสีชมพู",
  "block.minecraft.banner.square_top_right.purple": "มุมขวาบนสีม่วง",
  "block.minecraft.banner.square_top_right.red": "มุมขวาบนสีแดง",
  "block.minecraft.banner.square_top_right.white": "มุมขวาบนสีขาว",
  "block.minecraft.banner.square_top_right.yellow": "มุมขวาบนสีเหลือง",
  "block.minecraft.banner.straight_cross.black": "กางเขนสีดำ",
  "block.minecraft.banner.straight_cross.blue": "กางเขนสีน้ำเงิน",
  "block.minecraft.banner.straight_cross.brown": "กางเขนสีน้ำตาล",
  "block.minecraft.banner.straight_cross.cyan": "กางเขนสีฟ้าคราม",
  "block.minecraft.banner.straight_cross.gray": "กางเขนสีเทา",
  "block.minecraft.banner.straight_cross.green": "กางเขนสีเขียว",
  "block.minecraft.banner.straight_cross.light_blue": "กางเขนสีฟ้า",
  "block.minecraft.banner.straight_cross.light_gray": "กางเขนสีเทาอ่อน",
  "block.minecraft.banner.straight_cross.lime": "กางเขนสีเขียวอ่อน",
  "block.minecraft.banner.straight_cross.magenta": "กางเขนสีบานเย็น",
  "block.minecraft.banner.straight_cross.orange": "กางเขนสีส้ม",
  "block.minecraft.banner.straight_cross.pink": "กางเขนสีชมพู",
  "block.minecraft.banner.straight_cross.purple": "กางเขนสีม่วง",
  "block.minecraft.banner.straight_cross.red": "กางเขนสีแดง",
  "block.minecraft.banner.straight_cross.white": "กางเขนสีขาว",
  "block.minecraft.banner.straight_cross.yellow": "กางเขนสีเหลือง",
  "block.minecraft.banner.stripe_bottom.black": "ฐานสีดำ",
  "block.minecraft.banner.stripe_bottom.blue": "ฐานสีน้ำเงิน",
  "block.minecraft.banner.stripe_bottom.brown": "ฐานสีน้ำตาล",
  "block.minecraft.banner.stripe_bottom.cyan": "ฐานสีฟ้าคราม",
  "block.minecraft.banner.stripe_bottom.gray": "ฐานสีเทา",
  "block.minecraft.banner.stripe_bottom.green": "ฐานสีเขียว",
  "block.minecraft.banner.stripe_bottom.light_blue": "ฐานสีฟ้า",
  "block.minecraft.banner.stripe_bottom.light_gray": "ฐานสีเทาอ่อน",
  "block.minecraft.banner.stripe_bottom.lime": "ฐานสีเขียวอ่อน",
  "block.minecraft.banner.stripe_bottom.magenta": "ฐานสีบานเย็น",
  "block.minecraft.banner.stripe_bottom.orange": "ฐานสีส้ม",
  "block.minecraft.banner.stripe_bottom.pink": "ฐานสีชมพู",
  "block.minecraft.banner.stripe_bottom.purple": "ฐานสีม่วง",
  "block.minecraft.banner.stripe_bottom.red": "ฐานสีแดง",
  "block.minecraft.banner.stripe_bottom.white": "ฐานสีขาว",
  "block.minecraft.banner.stripe_bottom.yellow": "ฐานสีเหลือง",
  "block.minecraft.banner.stripe_center.black": "แถบกลางแนวตั้งสีดำ",
  "block.minecraft.banner.stripe_center.blue": "แถบกลางแนวตั้งสีน้ำเงิน",
  "block.minecraft.banner.stripe_center.brown": "แถบกลางแนวตั้งสีน้ำตาล",
  "block.minecraft.banner.stripe_center.cyan": "แถบกลางแนวตั้งสีฟ้าคราม",
  "block.minecraft.banner.stripe_center.gray": "แถบกลางแนวตั้งสีเทา",
  "block.minecraft.banner.stripe_center.green": "แถบกลางแนวตั้งสีเขียว",
  "block.minecraft.banner.stripe_center.light_blue": "แถบขวางสีฟ้า",
  "block.minecraft.banner.stripe_center.light_gray": "แถบขวางสีเทาอ่อน",
  "block.minecraft.banner.stripe_center.lime": "แถบกลางแนวตั้งสีเขียวอ่อน",
  "block.minecraft.banner.stripe_center.magenta": "แถบกลางแนวตั้งสีบานเย็น",
  "block.minecraft.banner.stripe_center.orange": "แถบกลางแนวตั้งสีส้ม",
  "block.minecraft.banner.stripe_center.pink": "แถบกลางแนวตั้งสีชมพู",
  "block.minecraft.banner.stripe_center.purple": "แถบกลางแนวตั้งสีม่วง",
  "block.minecraft.banner.stripe_center.red": "แถบกลางแนวตั้งสีแดง",
  "block.minecraft.banner.stripe_center.white": "แถบกลางแนวตั้งสีขาว",
  "block.minecraft.banner.stripe_center.yellow": "แถบกลางแนวตั้งสีเหลือง",
  "block.minecraft.banner.stripe_downleft.black": "แถบทแยงซ้ายสีดำ",
  "block.minecraft.banner.stripe_downleft.blue": "แถบทแยงซ้ายสีน้ำเงิน",
  "block.minecraft.banner.stripe_downleft.brown": "แถบทแยงซ้ายสีน้ำตาล",
  "block.minecraft.banner.stripe_downleft.cyan": "แถบทแยงซ้ายสีฟ้าคราม",
  "block.minecraft.banner.stripe_downleft.gray": "แถบทแยงซ้ายสีเทา",
  "block.minecraft.banner.stripe_downleft.green": "แถบทแยงซ้ายสีเขียว",
  "block.minecraft.banner.stripe_downleft.light_blue": "แถบทแยงซ้ายสีฟ้า",
  "block.minecraft.banner.stripe_downleft.light_gray": "แถบทแยงซ้ายสีเทาอ่อน",
  "block.minecraft.banner.stripe_downleft.lime": "แถบทแยงซ้ายสีเขียวอ่อน",
  "block.minecraft.banner.stripe_downleft.magenta": "แถบทแยงซ้ายสีบานเย็น",
  "block.minecraft.banner.stripe_downleft.orange": "แถบทแยงซ้ายสีส้ม",
  "block.minecraft.banner.stripe_downleft.pink": "แถบทแยงซ้ายสีชมพู",
  "block.minecraft.banner.stripe_downleft.purple": "แถบทแยงซ้ายสีม่วง",
  "block.minecraft.banner.stripe_downleft.red": "แถบทแยงซ้ายสีแดง",
  "block.minecraft.banner.stripe_downleft.white": "แถบทแยงซ้ายสีขาว",
  "block.minecraft.banner.stripe_downleft.yellow": "แถบทแยงซ้ายสีเหลือง",
  "block.minecraft.banner.stripe_downright.black": "แถบทแยงขวาสีดำ",
  "block.minecraft.banner.stripe_downright.blue": "แถบทแยงขวาสีน้ำเงิน",
  "block.minecraft.banner.stripe_downright.brown": "แถบทแยงขวาสีน้ำตาล",
  "block.minecraft.banner.stripe_downright.cyan": "แถบทแยงขวาสีฟ้าคราม",
  "block.minecraft.banner.stripe_downright.gray": "แถบทแยงขวาสีเทา",
  "block.minecraft.banner.stripe_downright.green": "แถบทแยงขวาสีเขียว",
  "block.minecraft.banner.stripe_downright.light_blue": "แถบทแยงขวาสีฟ้า",
  "block.minecraft.banner.stripe_downright.light_gray": "แถบทแยงขวาสีเทาอ่อน",
  "block.minecraft.banner.stripe_downright.lime": "แถบทแยงขวาสีเขียวอ่อน",
  "block.minecraft.banner.stripe_downright.magenta": "แถบทแยงขวาสีบานเย็น",
  "block.minecraft.banner.stripe_downright.orange": "แถบทแยงขวาสีส้ม",
  "block.minecraft.banner.stripe_downright.pink": "แถบทแยงขวาสีชมพู",
  "block.minecraft.banner.stripe_downright.purple": "แถบทแยงขวาสีม่วง",
  "block.minecraft.banner.stripe_downright.red": "แถบทแยงขวาสีแดง",
  "block.minecraft.banner.stripe_downright.white": "แถบทแยงขวาสีขาว",
  "block.minecraft.banner.stripe_downright.yellow": "แถบทแยงขวาสีเหลือง",
  "block.minecraft.banner.stripe_left.black": "แถบซ้ายสีดำ",
  "block.minecraft.banner.stripe_left.blue": "แถบซ้ายสีน้ำเงิน",
  "block.minecraft.banner.stripe_left.brown": "แถบซ้ายสีน้ำตาล",
  "block.minecraft.banner.stripe_left.cyan": "แถบซ้ายสีฟ้าคราม",
  "block.minecraft.banner.stripe_left.gray": "แถบซ้ายสีเทา",
  "block.minecraft.banner.stripe_left.green": "แถบซ้ายสีเขียว",
  "block.minecraft.banner.stripe_left.light_blue": "แถบซ้ายสีฟ้า",
  "block.minecraft.banner.stripe_left.light_gray": "แถบซ้ายสีเทาอ่อน",
  "block.minecraft.banner.stripe_left.lime": "แถบซ้ายสีเขียวอ่อน",
  "block.minecraft.banner.stripe_left.magenta": "แถบซ้ายสีบานเย็น",
  "block.minecraft.banner.stripe_left.orange": "แถบซ้ายสีส้ม",
  "block.minecraft.banner.stripe_left.pink": "แถบซ้ายสีชมพู",
  "block.minecraft.banner.stripe_left.purple": "แถบซ้ายสีม่วง",
  "block.minecraft.banner.stripe_left.red": "แถบซ้ายสีแดง",
  "block.minecraft.banner.stripe_left.white": "แถบซ้ายสีขาว",
  "block.minecraft.banner.stripe_left.yellow": "แถบซ้ายสีเหลือง",
  "block.minecraft.banner.stripe_middle.black": "แถบขวางสีดำ",
  "block.minecraft.banner.stripe_middle.blue": "แถบขวางสีน้ำเงิน",
  "block.minecraft.banner.stripe_middle.brown": "แถบขวางสีน้ำตาล",
  "block.minecraft.banner.stripe_middle.cyan": "แถบขวางสีฟ้าคราม",
  "block.minecraft.banner.stripe_middle.gray": "แถบขวางสีเทา",
  "block.minecraft.banner.stripe_middle.green": "แถบขวางสีเขียว",
  "block.minecraft.banner.stripe_middle.light_blue": "แถบขวางสีฟ้า",
  "block.minecraft.banner.stripe_middle.light_gray": "แถบขวางสีเทาอ่อน",
  "block.minecraft.banner.stripe_middle.lime": "แถบขวางสีเขียวอ่อน",
  "block.minecraft.banner.stripe_middle.magenta": "แถบขวางสีบานเย็น",
  "block.minecraft.banner.stripe_middle.orange": "แถบขวางสีส้ม",
  "block.minecraft.banner.stripe_middle.pink": "แถบขวางสีชมพู",
  "block.minecraft.banner.stripe_middle.purple": "แถบขวางสีม่วง",
  "block.minecraft.banner.stripe_middle.red": "แถบขวางสีแดง",
  "block.minecraft.banner.stripe_middle.white": "แถบขวางสีขาว",
  "block.minecraft.banner.stripe_middle.yellow": "แถบขวางสีเหลือง",
  "block.minecraft.banner.stripe_right.black": "แถบขวาสีดำ",
  "block.minecraft.banner.stripe_right.blue": "แถบขวาสีน้ำเงิน",
  "block.minecraft.banner.stripe_right.brown": "แถบขวาสีน้ำตาล",
  "block.minecraft.banner.stripe_right.cyan": "แถบขวาสีฟ้าคราม",
  "block.minecraft.banner.stripe_right.gray": "แถบขวาสีเทา",
  "block.minecraft.banner.stripe_right.green": "แถบขวาสีเขียว",
  "block.minecraft.banner.stripe_right.light_blue": "แถบขวาสีฟ้า",
  "block.minecraft.banner.stripe_right.light_gray": "แถบขวาสีเทาอ่อน",
  "block.minecraft.banner.stripe_right.lime": "แถบขวาสีเขียวอ่อน",
  "block.minecraft.banner.stripe_right.magenta": "แถบขวาสีบานเย็น",
  "block.minecraft.banner.stripe_right.orange": "แถบขวาสีส้ม",
  "block.minecraft.banner.stripe_right.pink": "แถบขวาสีชมพู",
  "block.minecraft.banner.stripe_right.purple": "แถบขวาสีม่วง",
  "block.minecraft.banner.stripe_right.red": "แถบขวาสีแดง",
  "block.minecraft.banner.stripe_right.white": "แถบขวาสีขาว",
  "block.minecraft.banner.stripe_right.yellow": "แถบขวาสีเหลือง",
  "block.minecraft.banner.stripe_top.black": "แถบบนสีดำ",
  "block.minecraft.banner.stripe_top.blue": "แถบบนสีน้ำเงิน",
  "block.minecraft.banner.stripe_top.brown": "แถบบนสีน้ำตาล",
  "block.minecraft.banner.stripe_top.cyan": "แถบบนสีฟ้าคราม",
  "block.minecraft.banner.stripe_top.gray": "แถบบนสีเทา",
  "block.minecraft.banner.stripe_top.green": "แถบบนสีเขียว",
  "block.minecraft.banner.stripe_top.light_blue": "แถบบนสีฟ้า",
  "block.minecraft.banner.stripe_top.light_gray": "แถบบนสีเทาอ่อน",
  "block.minecraft.banner.stripe_top.lime": "แถบบนสีเขียวอ่อน",
  "block.minecraft.banner.stripe_top.magenta": "แถบบนสีบานเย็น",
  "block.minecraft.banner.stripe_top.orange": "แถบบนสีส้ม",
  "block.minecraft.banner.stripe_top.pink": "แถบบนสีชมพู",
  "block.minecraft.banner.stripe_top.purple": "แถบบนสีม่วง",
  "block.minecraft.banner.stripe_top.red": "แถบบนสีแดง",
  "block.minecraft.banner.stripe_top.white": "แถบบนสีขาว",
  "block.minecraft.banner.stripe_top.yellow": "แถบบนสีเหลือง",
  "block.minecraft.banner.triangle_bottom.black": "สามเหลี่ยมล่างสีดำ",
  "block.minecraft.banner.triangle_bottom.blue": "สามเหลี่ยมล่างสีน้ำเงิน",
  "block.minecraft.banner.triangle_bottom.brown": "สามเหลี่ยมล่างสีน้ำตาล",
  "block.minecraft.banner.triangle_bottom.cyan": "สามเหลี่ยมล่างสีฟ้าคราม",
  "block.minecraft.banner.triangle_bottom.gray": "สามเหลี่ยมล่างสีเทา",
  "block.minecraft.banner.triangle_bottom.green": "สามเหลี่ยมล่างสีเขียว",
  "block.minecraft.banner.triangle_bottom.light_blue": "สามเหลี่ยมล่างสีฟ้า",
  "block.minecraft.banner.triangle_bottom.light_gray": "สามเหลี่ยมล่างสีเทาอ่อน",
  "block.minecraft.banner.triangle_bottom.lime": "สามเหลี่ยมล่างสีเขียวอ่อน",
  "block.minecraft.banner.triangle_bottom.magenta": "สามเหลี่ยมล่างสีบานเย็น",
  "block.minecraft.banner.triangle_bottom.orange": "สามเหลี่ยมล่างสีส้ม",
  "block.minecraft.banner.triangle_bottom.pink": "สามเหลี่ยมล่างสีชมพู",
  "block.minecraft.banner.triangle_bottom.purple": "สามเหลี่ยมล่างสีม่วง",
  "block.minecraft.banner.triangle_bottom.red": "สามเหลี่ยมล่างสีแดง",
  "block.minecraft.banner.triangle_bottom.white": "สามเหลี่ยมล่างสีขาว",
  "block.minecraft.banner.triangle_bottom.yellow": "สามเหลี่ยมล่างสีเหลือง",
  "block.minecraft.banner.triangle_top.black": "สามเหลี่ยมบนสีดำ",
  "block.minecraft.banner.triangle_top.blue": "สามเหลี่ยมบนสีน้ำเงิน",
  "block.minecraft.banner.triangle_top.brown": "สามเหลี่ยมบนสีน้ำตาล",
  "block.minecraft.banner.triangle_top.cyan": "สามเหลี่ยมบนสีฟ้าคราม",
  "block.minecraft.banner.triangle_top.gray": "สามเหลี่ยมบนสีเทา",
  "block.minecraft.banner.triangle_top.green": "สามเหลี่ยมบนสีเขียว",
  "block.minecraft.banner.triangle_top.light_blue": "สามเหลี่ยมบนสีฟ้า",
  "block.minecraft.banner.triangle_top.light_gray": "สามเหลี่ยมบนสีเทาอ่อน",
  "block.minecraft.banner.triangle_top.lime": "สามเหลี่ยมบนสีเขียวอ่อน",
  "block.minecraft.banner.triangle_top.magenta": "สามเหลี่ยมบนสีบานเย็น",
  "block.minecraft.banner.triangle_top.orange": "สามเหลี่ยมบนสีส้ม",
  "block.minecraft.banner.triangle_top.pink": "สามเหลี่ยมบนสีชมพู",
  "block.minecraft.banner.triangle_top.purple": "สามเหลี่ยมบนสีม่วง",
  "block.minecraft.banner.triangle_top.red": "สามเหลี่ยมบนสีแดง",
  "block.minecraft.banner.triangle_top.white": "สามเหลี่ยมบนสีขาว",
  "block.minecraft.banner.triangle_top.yellow": "สามเหลี่ยมบนสีเหลือง",
  "block.minecraft.banner.triangles_bottom.black": "ฐานฟันเลื่อยสีดำ",
  "block.minecraft.banner.triangles_bottom.blue": "ฐานฟันเลื่อยสีน้ำเงิน",
  "block.minecraft.banner.triangles_bottom.brown": "ฐานฟันเลื่อยสีน้ำตาล",
  "block.minecraft.banner.triangles_bottom.cyan": "ฐานฟันเลื่อยสีฟ้าคราม",
  "block.minecraft.banner.triangles_bottom.gray": "ฐานฟันเลื่อยสีเทา",
  "block.minecraft.banner.triangles_bottom.green": "ฐานฟันเลื่อยสีเขียว",
  "block.minecraft.banner.triangles_bottom.light_blue": "ฐานฟันเลื่อยสีฟ้า",
  "block.minecraft.banner.triangles_bottom.light_gray": "ฐานฟันเลื่อยสีเทาอ่อน",
  "block.minecraft.banner.triangles_bottom.lime": "ฐานฟันเลื่อยสีเขียวอ่อน",
  "block.minecraft.banner.triangles_bottom.magenta": "ฐานฟันเลื่อยสีบานเย็น",
  "block.minecraft.banner.triangles_bottom.orange": "ฐานฟันเลื่อยสีส้ม",
  "block.minecraft.banner.triangles_bottom.pink": "ฐานฟันเลื่อยสีชมพู",
  "block.minecraft.banner.triangles_bottom.purple": "ฐานฟันเลื่อยสีม่วง",
  "block.minecraft.banner.triangles_bottom.red": "ฐานฟันเลื่อยสีแดง",
  "block.minecraft.banner.triangles_bottom.white": "ฐานฟันเลื่อยสีขาว",
  "block.minecraft.banner.triangles_bottom.yellow": "ฐานฟันเลื่อยสีเหลือง",
  "block.minecraft.banner.triangles_top.black": "ฟันเลื่อยบนสีดำ",
  "block.minecraft.banner.triangles_top.blue": "ฟันเลื่อยบนสีน้ำเงิน",
  "block.minecraft.banner.triangles_top.brown": "ฟันเลื่อยบนสีน้ำตาล",
  "block.minecraft.banner.triangles_top.cyan": "ฟันเลื่อยบนสีฟ้าคราม",
  "block.minecraft.banner.triangles_top.gray": "ฟันเลื่อยบนสีเทา",
  "block.minecraft.banner.triangles_top.green": "ฟันเลื่อยบนสีเขียว",
  "block.minecraft.banner.triangles_top.light_blue": "ฟันเลื่อยบนสีฟ้า",
  "block.minecraft.banner.triangles_top.light_gray": "ฟันเลื่อยบนสีเทาอ่อน",
  "block.minecraft.banner.triangles_top.lime": "ฟันเลื่อยบนสีเขียวอ่อน",
  "block.minecraft.banner.triangles_top.magenta": "ฟันเลื่อยบนสีบานเย็น",
  "block.minecraft.banner.triangles_top.orange": "ฟันเลื่อยบนสีส้ม",
  "block.minecraft.banner.triangles_top.pink": "ฟันเลื่อยบนสีชมพู",
  "block.minecraft.banner.triangles_top.purple": "ฟันเลื่อยบนสีม่วง",
  "block.minecraft.banner.triangles_top.red": "ฟันเลื่อยบนสีแดง",
  "block.minecraft.banner.triangles_top.white": "ฟันเลื่อยบนสีขาว",
  "block.minecraft.banner.triangles_top.yellow": "ฟันเลื่อยบนสีเหลือง",
  "block.minecraft.barrel": "ถังบาร์เรล",
  "block.minecraft.barrier": "บาร์เรียร์",
  "block.minecraft.basalt": "หินบะซอลต์",
  "block.minecraft.beacon": "ดวงประทีป",
  "block.minecraft.beacon.primary": "พลังขั้นปฐมภูมิ",
  "block.minecraft.beacon.secondary": "พลังขั้นทุติยภูมิ",
  "block.minecraft.bed.no_sleep": "คุณสามารถนอนได้เฉพาะในเวลากลางคืนหรือช่วงพายุฝนฟ้าคะนอง",
  "block.minecraft.bed.not_safe": "คุณยังไม่สามารถนอนได้ เพราะมีมอนสเตอร์อยู่ใกล้ ๆ",
  "block.minecraft.bed.obstructed": "เตียงนี้ถูกกีดขวาง",
  "block.minecraft.bed.occupied": "เตียงนี้ถูกยึดครองอยู่",
  "block.minecraft.bed.too_far_away": "คุณยังไม่สามารถนอนได้ เพราะเตียงอยู่ห่างเกินไป",
  "block.minecraft.bedrock": "หินดาน",
  "block.minecraft.bee_nest": "รังผึ้ง",
  "block.minecraft.beehive": "กล่องรังผึ้ง",
  "block.minecraft.beetroots": "บีตรูต",
  "block.minecraft.bell": "ระฆัง",
  "block.minecraft.big_dripleaf": "ใบหยาดใหญ่",
  "block.minecraft.big_dripleaf_stem": "ลำต้นใบหยาดใหญ่",
  "block.minecraft.birch_button": "ปุ่มไม้เบิร์ช",
  "block.minecraft.birch_door": "ประตูไม้เบิร์ช",
  "block.minecraft.birch_fence": "รั้วไม้เบิร์ช",
  "block.minecraft.birch_fence_gate": "ประตูรั้วไม้เบิร์ช",
  "block.minecraft.birch_hanging_sign": "ป้ายแขวนไม้เบิร์ช",
  "block.minecraft.birch_leaves": "ใบไม้เบิร์ช",
  "block.minecraft.birch_log": "ท่อนไม้เบิร์ช",
  "block.minecraft.birch_planks": "ไม้กระดานเบิร์ช",
  "block.minecraft.birch_pressure_plate": "แป้นเหยียบไม้เบิร์ช",
  "block.minecraft.birch_sapling": "ต้นอ่อนไม้เบิร์ช",
  "block.minecraft.birch_shelf": "ชั้นวางไม้เบิร์ช",
  "block.minecraft.birch_sign": "ป้ายไม้เบิร์ช",
  "block.minecraft.birch_slab": "แผ่นไม้เบิร์ช",
  "block.minecraft.birch_stairs": "บันไดไม้เบิร์ช",
  "block.minecraft.birch_trapdoor": "ประตูกับดักไม้เบิร์ช",
  "block.minecraft.birch_wall_hanging_sign": "ป้ายแขวนไม้เบิร์ชติดผนัง",
  "block.minecraft.birch_wall_sign": "ป้ายไม้เบิร์ชติดผนัง",
  "block.minecraft.birch_wood": "ไม้เบิร์ช",
  "block.minecraft.black_banner": "ธงสีดำ",
  "block.minecraft.black_bed": "เตียงสีดำ",
  "block.minecraft.black_candle": "เทียนสีดำ",
  "block.minecraft.black_candle_cake": "เค้กพร้อมเทียนสีดำ",
  "block.minecraft.black_carpet": "พรมสีดำ",
  "block.minecraft.black_concrete": "คอนกรีตสีดำ",
  "block.minecraft.black_concrete_powder": "ผงคอนกรีตสีดำ",
  "block.minecraft.black_glazed_terracotta": "ดินเผาเคลือบสีดำ",
  "block.minecraft.black_shulker_box": "กล่องชัลเกอร์สีดำ",
  "block.minecraft.black_stained_glass": "กระจกสีดำ",
  "block.minecraft.black_stained_glass_pane": "แผ่นกระจกสีดำ",
  "block.minecraft.black_terracotta": "ดินเผาสีดำ",
  "block.minecraft.black_wool": "ขนแกะสีดำ",
  "block.minecraft.blackstone": "หินดำ",
  "block.minecraft.blackstone_slab": "แผ่นหินดำ",
  "block.minecraft.blackstone_stairs": "บันไดหินดำ",
  "block.minecraft.blackstone_wall": "กำแพงหินดำ",
  "block.minecraft.blast_furnace": "เตาหลอม",
  "block.minecraft.blue_banner": "ธงสีน้ำเงิน",
  "block.minecraft.blue_bed": "เตียงสีน้ำเงิน",
  "block.minecraft.blue_candle": "เทียนสีน้ำเงิน",
  "block.minecraft.blue_candle_cake": "เค้กพร้อมเทียนสีน้ำเงิน",
  "block.minecraft.blue_carpet": "พรมสีน้ำเงิน",
  "block.minecraft.blue_concrete": "คอนกรีตสีน้ำเงิน",
  "block.minecraft.blue_concrete_powder": "ผงคอนกรีตสีน้ำเงิน",
  "block.minecraft.blue_glazed_terracotta": "ดินเผาเคลือบสีน้ำเงิน",
  "block.minecraft.blue_ice": "น้ำแข็งน้ำเงิน",
  "block.minecraft.blue_orchid": "กล้วยไม้น้ำเงิน",
  "block.minecraft.blue_shulker_box": "กล่องชัลเกอร์สีน้ำเงิน",
  "block.minecraft.blue_stained_glass": "กระจกสีน้ำเงิน",
  "block.minecraft.blue_stained_glass_pane": "แผ่นกระจกสีน้ำเงิน",
  "block.minecraft.blue_terracotta": "ดินเผาสีน้ำเงิน",
  "block.minecraft.blue_wool": "ขนแกะสีน้ำเงิน",
  "block.minecraft.bone_block": "บล็อกกระดูก",
  "block.minecraft.bookshelf": "ชั้นหนังสือ",
  "block.minecraft.brain_coral": "ปะการังสมอง",
  "block.minecraft.brain_coral_block": "บล็อกปะการังสมอง",
  "block.minecraft.brain_coral_fan": "ปะการังสมองรูปพัด",
  "block.minecraft.brain_coral_wall_fan": "ปะการังสมองรูปพัดติดผนัง",
  "block.minecraft.brewing_stand": "แท่นปรุงยา",
  "block.minecraft.brick_slab": "แผ่นอิฐ",
  "block.minecraft.brick_stairs": "บันไดอิฐ",
  "block.minecraft.brick_wall": "กำแพงอิฐ",
  "block.minecraft.bricks": "บล็อกอิฐ",
  "block.minecraft.brown_banner": "ธงสีน้ำตาล",
  "block.minecraft.brown_bed": "เตียงสีน้ำตาล",
  "block.minecraft.brown_candle": "เทียนสีน้ำตาล",
  "block.minecraft.brown_candle_cake": "เค้กพร้อมเทียนสีน้ำตาล",
  "block.minecraft.brown_carpet": "พรมสีน้ำตาล",
  "block.minecraft.brown_concrete": "คอนกรีตสีน้ำตาล",
  "block.minecraft.brown_concrete_powder": "ผงคอนกรีตสีน้ำตาล",
  "block.minecraft.brown_glazed_terracotta": "ดินเผาเคลือบสีน้ำตาล",
  "block.minecraft.brown_mushroom": "เห็ดน้ำตาล",
  "block.minecraft.brown_mushroom_block": "บล็อกเห็ดน้ำตาล",
  "block.minecraft.brown_shulker_box": "กล่องชัลเกอร์สีน้ำตาล",
  "block.minecraft.brown_stained_glass": "กระจกสีน้ำตาล",
  "block.minecraft.brown_stained_glass_pane": "แผ่นกระจกสีน้ำตาล",
  "block.minecraft.brown_terracotta": "ดินเผาสีน้ำตาล",
  "block.minecraft.brown_wool": "ขนแกะสีน้ำตาล",
  "block.minecraft.bubble_column": "ฟองแนวตั้ง",
  "block.minecraft.bubble_coral": "ปะการังฟอง",
  "block.minecraft.bubble_coral_block": "บล็อกปะการังฟอง",
  "block.minecraft.bubble_coral_fan": "ปะการังฟองรูปพัด",
  "block.minecraft.bubble_coral_wall_fan": "ปะการังฟองรูปพัดติดผนัง",
  "block.minecraft.budding_amethyst": "ต้นหน่อแอเมทิสต์",
  "block.minecraft.bush": "พุ่มไม้",
  "block.minecraft.cactus": "กระบองเพชร",
  "block.minecraft.cactus_flower": "ดอกกระบองเพชร",
  "block.minecraft.cake": "เค้ก",
  "block.minecraft.calcite": "หินแคลไซต์",
  "block.minecraft.calibrated_sculk_sensor": "ตัวรับรู้สกัลก์เทียบมาตรฐาน",
  "block.minecraft.campfire": "แคมป์ไฟ",
  "block.minecraft.candle": "เทียน",
  "block.minecraft.candle_cake": "เค้กพร้อมเทียน",
  "block.minecraft.carrots": "แคร์รอต",
  "block.minecraft.cartography_table": "โต๊ะทำแผนที่",
  "block.minecraft.carved_pumpkin": "ฟักทองแกะสลัก",
  "block.minecraft.cauldron": "หม้อปรุงยา",
  "block.minecraft.cave_air": "อากาศถ้ำ",
  "block.minecraft.cave_vines": "เถาวัลย์ถ้ำ",
  "block.minecraft.cave_vines_plant": "ต้นเถาวัลย์ถ้ำ",
  "block.minecraft.chain": "โซ่",
  "block.minecraft.chain_command_block": "บล็อกคำสั่งแบบลูกโซ่",
  "block.minecraft.cherry_button": "ปุ่มไม้ซากุระ",
  "block.minecraft.cherry_door": "ประตูไม้ซากุระ",
  "block.minecraft.cherry_fence": "รั้วไม้ซากุระ",
  "block.minecraft.cherry_fence_gate": "ประตูรั้วไม้ซากุระ",
  "block.minecraft.cherry_hanging_sign": "ป้ายแขวนไม้ซากุระ",
  "block.minecraft.cherry_leaves": "ใบไม้ซากุระ",
  "block.minecraft.cherry_log": "ท่อนไม้ซากุระ",
  "block.minecraft.cherry_planks": "ไม้กระดานซากุระ",
  "block.minecraft.cherry_pressure_plate": "แป้นเหยียบไม้ซากุระ",
  "block.minecraft.cherry_sapling": "ต้นอ่อนไม้ซากุระ",
  "block.minecraft.cherry_shelf": "ชั้นวางไม้ซากุระ",
  "block.minecraft.cherry_sign": "ป้ายไม้ซากุระ",
  "block.minecraft.cherry_slab": "แผ่นไม้ซากุระ",
  "block.minecraft.cherry_stairs": "บันไดไม้ซากุระ",
  "block.minecraft.cherry_trapdoor": "ประตูกับดักไม้ซากุระ",
  "block.minecraft.cherry_wall_hanging_sign": "ป้ายแขวนไม้ซากุระติดผนัง",
  "block.minecraft.cherry_wall_sign": "ป้ายไม้ซากุระติดผนัง",
  "block.minecraft.cherry_wood": "ไม้ซากุระ",
  "block.minecraft.chest": "หีบ",
  "block.minecraft.chipped_anvil": "ทั่งบิ่น",
  "block.minecraft.chiseled_bookshelf": "ชั้นหนังสือสลัก",
  "block.minecraft.chiseled_copper": "ทองแดงสลัก",
  "block.minecraft.chiseled_deepslate": "หินชนวนลึกสลัก",
  "block.minecraft.chiseled_nether_bricks": "บล็อกอิฐเนเธอร์สลัก",
  "block.minecraft.chiseled_polished_blackstone": "หินดำขัดสลัก",
  "block.minecraft.chiseled_quartz_block": "บล็อกควอตซ์สลัก",
  "block.minecraft.chiseled_red_sandstone": "หินทรายแดงสลัก",
  "block.minecraft.chiseled_resin_bricks": "บล็อกอิฐยางไม้สลัก",
  "block.minecraft.chiseled_sandstone": "หินทรายสลัก",
  "block.minecraft.chiseled_stone_bricks": "บล็อกอิฐหินสลัก",
  "block.minecraft.chiseled_tuff": "หินภูเขาไฟสลัก",
  "block.minecraft.chiseled_tuff_bricks": "บล็อกอิฐหินภูเขาไฟสลัก",
  "block.minecraft.chorus_flower": "ดอกคอรัส",
  "block.minecraft.chorus_plant": "ต้นคอรัส",
  "block.minecraft.clay": "ดินเหนียว",
  "block.minecraft.closed_eyeblossom": "ดอกดวงตาปิด",
  "block.minecraft.coal_block": "บล็อกถ่านหิน",
  "block.minecraft.coal_ore": "แร่ถ่านหิน",
  "block.minecraft.coarse_dirt": "ดินหยาบ",
  "block.minecraft.cobbled_deepslate": "หินชนวนลึกหยาบ",
  "block.minecraft.cobbled_deepslate_slab": "แผ่นหินชนวนลึกหยาบ",
  "block.minecraft.cobbled_deepslate_stairs": "บันไดหินชนวนลึกหยาบ",
  "block.minecraft.cobbled_deepslate_wall": "กำแพงหินชนวนลึกหยาบ",
  "block.minecraft.cobblestone": "หินหยาบ",
  "block.minecraft.cobblestone_slab": "แผ่นหินหยาบ",
  "block.minecraft.cobblestone_stairs": "บันไดหินหยาบ",
  "block.minecraft.cobblestone_wall": "กำแพงหินหยาบ",
  "block.minecraft.cobweb": "ใยแมงมุม",
  "block.minecraft.cocoa": "โกโก้",
  "block.minecraft.command_block": "บล็อกคำสั่ง",
  "block.minecraft.comparator": "ตัวเปรียบเทียบเรดสโตน",
  "block.minecraft.composter": "ถังหมักปุ๋ย",
  "block.minecraft.conduit": "ศิรา",
  "block.minecraft.copper_bars": "ลูกกรงทองแดง",
  "block.minecraft.copper_block": "บล็อกทองแดง",
  "block.minecraft.copper_bulb": "หลอดไฟทองแดง",
  "block.minecraft.copper_chain": "โซ่ทองแดง",
  "block.minecraft.copper_chest": "หีบทองแดง",
  "block.minecraft.copper_door": "ประตูทองแดง",
  "block.minecraft.copper_golem_statue": "รูปปั้นโกเลมทองแดง",
  "block.minecraft.copper_grate": "ตะแกรงทองแดง",
  "block.minecraft.copper_lantern": "โคมไฟทองแดง",
  "block.minecraft.copper_ore": "แร่ทองแดง",
  "block.minecraft.copper_torch": "คบเพลิงทองแดง",
  "block.minecraft.copper_trapdoor": "ประตูกับดักทองแดง",
  "block.minecraft.copper_wall_torch": "คบเพลิงทองแดงติดผนัง",
  "block.minecraft.cornflower": "คอร์นฟลาวเวอร์",
  "block.minecraft.cracked_deepslate_bricks": "บล็อกอิฐหินชนวนลึกร้าว",
  "block.minecraft.cracked_deepslate_tiles": "กระเบื้องหินชนวนลึกร้าว",
  "block.minecraft.cracked_nether_bricks": "บล็อกอิฐเนเธอร์ร้าว",
  "block.minecraft.cracked_polished_blackstone_bricks": "บล็อกอิฐหินดำขัดร้าว",
  "block.minecraft.cracked_stone_bricks": "บล็อกอิฐหินร้าว",
  "block.minecraft.crafter": "เครื่องคราฟต์",
  "block.minecraft.crafting_table": "โต๊ะคราฟต์",
  "block.minecraft.creaking_heart": "หัวใจครีกกิ้ง",
  "block.minecraft.creeper_head": "หัวครีปเปอร์",
  "block.minecraft.creeper_wall_head": "หัวครีปเปอร์ติดผนัง",
  "block.minecraft.crimson_button": "ปุ่มไม้สีเลือด",
  "block.minecraft.crimson_door": "ประตูไม้สีเลือด",
  "block.minecraft.crimson_fence": "รั้วไม้สีเลือด",
  "block.minecraft.crimson_fence_gate": "ประตูรั้วไม้สีเลือด",
  "block.minecraft.crimson_fungus": "เห็ดราสีเลือด",
  "block.minecraft.crimson_hanging_sign": "ป้ายแขวนไม้ป่าสีเลือด",
  "block.minecraft.crimson_hyphae": "เส้นใยเห็ดราสีเลือด",
  "block.minecraft.crimson_nylium": "กลุ่มใยราเนเธอร์สีเลือด",
  "block.minecraft.crimson_planks": "ไม้กระดานสีเลือด",
  "block.minecraft.crimson_pressure_plate": "แป้นเหยียบไม้สีเลือด",
  "block.minecraft.crimson_roots": "รากไม้สีเลือด",
  "block.minecraft.crimson_shelf": "ชั้นวางไม้สีเลือด",
  "block.minecraft.crimson_sign": "ป้ายไม้สีเลือด",
  "block.minecraft.crimson_slab": "แผ่นไม้สีเลือด",
  "block.minecraft.crimson_stairs": "บันไดไม้สีเลือด",
  "block.minecraft.crimson_stem": "ลำต้นสีเลือด",
  "block.minecraft.crimson_trapdoor": "ประตูกับดักไม้สีเลือด",
  "block.minecraft.crimson_wall_hanging_sign": "ป้ายแขวนไม้ป่าสีเลือดติดผนัง",
  "block.minecraft.crimson_wall_sign": "ป้ายไม้สีเลือดติดผนัง",
  "block.minecraft.crying_obsidian": "หินออบซิเดียนร้องไห้",
  "block.minecraft.cut_copper": "ทองแดงตัด",
  "block.minecraft.cut_copper_slab": "แผ่นทองแดงตัด",
  "block.minecraft.cut_copper_stairs": "บันไดทองแดงตัด",
  "block.minecraft.cut_red_sandstone": "หินทรายแดงตัด",
  "block.minecraft.cut_red_sandstone_slab": "แผ่นหินทรายแดงตัด",
  "block.minecraft.cut_sandstone": "หินทรายตัด",
  "block.minecraft.cut_sandstone_slab": "แผ่นหินทรายตัด",
  "block.minecraft.cyan_banner": "ธงสีฟ้าคราม",
  "block.minecraft.cyan_bed": "เตียงสีฟ้าคราม",
  "block.minecraft.cyan_candle": "เทียนสีฟ้าคราม",
  "block.minecraft.cyan_candle_cake": "เค้กพร้อมเทียนสีฟ้าคราม",
  "block.minecraft.cyan_carpet": "พรมสีฟ้าคราม",
  "block.minecraft.cyan_concrete": "คอนกรีตสีฟ้าคราม",
  "block.minecraft.cyan_concrete_powder": "ผงคอนกรีตสีฟ้าคราม",
  "block.minecraft.cyan_glazed_terracotta": "ดินเผาเคลือบสีฟ้าคราม",
  "block.minecraft.cyan_shulker_box": "กล่องชัลเกอร์สีฟ้าคราม",
  "block.minecraft.cyan_stained_glass": "กระจกสีฟ้าคราม",
  "block.minecraft.cyan_stained_glass_pane": "แผ่นกระจกสีฟ้าคราม",
  "block.minecraft.cyan_terracotta": "ดินเผาสีฟ้าคราม",
  "block.minecraft.cyan_wool": "ขนแกะสีฟ้าคราม",
  "block.minecraft.damaged_anvil": "ทั่งเสียหาย",
  "block.minecraft.dandelion": "ดอกแดนดิไลออน",
  "block.minecraft.dark_oak_button": "ปุ่มไม้โอ๊กดำ",
  "block.minecraft.dark_oak_door": "ประตูไม้โอ๊กดำ",
  "block.minecraft.dark_oak_fence": "รั้วไม้โอ๊กดำ",
  "block.minecraft.dark_oak_fence_gate": "ประตูรั้วไม้โอ๊กดำ",
  "block.minecraft.dark_oak_hanging_sign": "ป้ายแขวนไม้โอ๊กดำ",
  "block.minecraft.dark_oak_leaves": "ใบไม้โอ๊กดำ",
  "block.minecraft.dark_oak_log": "ท่อนไม้โอ๊กดำ",
  "block.minecraft.dark_oak_planks": "ไม้กระดานโอ๊กดำ",
  "block.minecraft.dark_oak_pressure_plate": "แป้นเหยียบไม้โอ๊กดำ",
  "block.minecraft.dark_oak_sapling": "ต้นอ่อนไม้โอ๊กดำ",
  "block.minecraft.dark_oak_shelf": "ชั้นวางไม้โอ๊กดำ",
  "block.minecraft.dark_oak_sign": "ป้ายไม้โอ๊กดำ",
  "block.minecraft.dark_oak_slab": "แผ่นไม้โอ๊กดำ",
  "block.minecraft.dark_oak_stairs": "บันไดไม้โอ๊กดำ",
  "block.minecraft.dark_oak_trapdoor": "ประตูกับดักไม้โอ๊กดำ",
  "block.minecraft.dark_oak_wall_hanging_sign": "ป้ายแขวนไม้โอ๊กดำติดผนัง",
  "block.minecraft.dark_oak_wall_sign": "ป้ายไม้โอ๊กดำติดผนัง",
  "block.minecraft.dark_oak_wood": "ไม้โอ๊กดำ",
  "block.minecraft.dark_prismarine": "พริสมารีนเข้ม",
  "block.minecraft.dark_prismarine_slab": "แผ่นพริสมารีนเข้ม",
  "block.minecraft.dark_prismarine_stairs": "บันไดพริสมารีนเข้ม",
  "block.minecraft.daylight_detector": "เครื่องตรวจจับแสงแดด",
  "block.minecraft.dead_brain_coral": "ปะการังสมองตาย",
  "block.minecraft.dead_brain_coral_block": "บล็อกปะการังสมองตาย",
  "block.minecraft.dead_brain_coral_fan": "ปะการังสมองรูปพัดตาย",
  "block.minecraft.dead_brain_coral_wall_fan": "ปะการังสมองรูปพัดตายติดผนัง",
  "block.minecraft.dead_bubble_coral": "ปะการังฟองตาย",
  "block.minecraft.dead_bubble_coral_block": "บล็อกปะการังฟองตาย",
  "block.minecraft.dead_bubble_coral_fan": "ปะการังฟองรูปพัดตาย",
  "block.minecraft.dead_bubble_coral_wall_fan": "ปะการังฟองรูปพัดตายติดผนัง",
  "block.minecraft.dead_bush": "พุ่มไม้แห้ง",
  "block.minecraft.dead_fire_coral": "ประการังไฟตาย",
  "block.minecraft.dead_fire_coral_block": "บล็อกปะการังไฟตาย",
  "block.minecraft.dead_fire_coral_fan": "ปะการังไฟรูปพัดตาย",
  "block.minecraft.dead_fire_coral_wall_fan": "ปะการังไฟรูปพัดตายติดผนัง",
  "block.minecraft.dead_horn_coral": "ปะการังเขาตาย",
  "block.minecraft.dead_horn_coral_block": "บล็อกปะการังเขาตาย",
  "block.minecraft.dead_horn_coral_fan": "ปะการังเขารูปพัดตาย",
  "block.minecraft.dead_horn_coral_wall_fan": "ปะการังเขารูปพัดตายติดผนัง",
  "block.minecraft.dead_tube_coral": "ปะการังหลอดตาย",
  "block.minecraft.dead_tube_coral_block": "บล็อกปะการังหลอดตาย",
  "block.minecraft.dead_tube_coral_fan": "ปะการังหลอดรูปพัดตาย",
  "block.minecraft.dead_tube_coral_wall_fan": "ปะการังหลอดรูปพัดตายติดผนัง",
  "block.minecraft.decorated_pot": "หม้อดินเผาตกแต่ง",
  "block.minecraft.deepslate": "หินชนวนลึก",
  "block.minecraft.deepslate_brick_slab": "แผ่นอิฐหินชนวนลึก",
  "block.minecraft.deepslate_brick_stairs": "บันไดอิฐหินชนวนลึก",
  "block.minecraft.deepslate_brick_wall": "กำแพงอิฐหินชนวนลึก",
  "block.minecraft.deepslate_bricks": "บล็อกอิฐหินชนวนลึก",
  "block.minecraft.deepslate_coal_ore": "แร่ถ่านหินในหินชนวนลึก",
  "block.minecraft.deepslate_copper_ore": "แร่ทองแดงในหินชนวนลึก",
  "block.minecraft.deepslate_diamond_ore": "แร่เพชรในหินชนวนลึก",
  "block.minecraft.deepslate_emerald_ore": "แร่มรกตในหินชนวนลึก",
  "block.minecraft.deepslate_gold_ore": "แร่ทองในหินชนวนลึก",
  "block.minecraft.deepslate_iron_ore": "แร่เหล็กในหินชนวนลึก",
  "block.minecraft.deepslate_lapis_ore": "แร่ลาพิสลาซูลีในหินชนวนลึก",
  "block.minecraft.deepslate_redstone_ore": "แร่เรดสโตนในหินชนวนลึก",
  "block.minecraft.deepslate_tile_slab": "แผ่นกระเบื้องหินชนวนลึก",
  "block.minecraft.deepslate_tile_stairs": "บันไดกระเบื้องหินชนวนลึก",
  "block.minecraft.deepslate_tile_wall": "กำแพงกระเบื้องหินชนวนลึก",
  "block.minecraft.deepslate_tiles": "กระเบื้องหินชนวนลึก",
  "block.minecraft.detector_rail": "รางตรวจจับ",
  "block.minecraft.diamond_block": "บล็อกเพชร",
  "block.minecraft.diamond_ore": "แร่เพชร",
  "block.minecraft.diorite": "หินไดออไรต์",
  "block.minecraft.diorite_slab": "แผ่นหินไดออไรต์",
  "block.minecraft.diorite_stairs": "บันไดหินไดออไรต์",
  "block.minecraft.diorite_wall": "กำแพงหินไดออไรต์",
  "block.minecraft.dirt": "ดิน",
  "block.minecraft.dirt_path": "ทางดิน",
  "block.minecraft.dispenser": "เครื่องยิง",
  "block.minecraft.dragon_egg": "ไข่มังกร",
  "block.minecraft.dragon_head": "หัวมังกร",
  "block.minecraft.dragon_wall_head": "หัวมังกรติดผนัง",
  "block.minecraft.dried_ghast": "แก๊สต์แห้งเฉา",
  "block.minecraft.dried_kelp_block": "บล็อกสาหร่ายทะเลแห้ง",
  "block.minecraft.dripstone_block": "บล็อกหินหยด",
  "block.minecraft.dropper": "เครื่องดรอป",
  "block.minecraft.emerald_block": "บล็อกมรกต",
  "block.minecraft.emerald_ore": "แร่มรกต",
  "block.minecraft.enchanting_table": "โต๊ะร่ายมนตร์",
  "block.minecraft.end_gateway": "ประตูทางผ่านเอนด์",
  "block.minecraft.end_portal": "ประตูมิติเอนด์",
  "block.minecraft.end_portal_frame": "กรอบประตูมิติเอนด์",
  "block.minecraft.end_rod": "แท่งเอนด์",
  "block.minecraft.end_stone": "หินเอนด์",
  "block.minecraft.end_stone_brick_slab": "แผ่นอิฐหินเอนด์",
  "block.minecraft.end_stone_brick_stairs": "บันไดอิฐหินเอนด์",
  "block.minecraft.end_stone_brick_wall": "กำแพงอิฐหินเอนด์",
  "block.minecraft.end_stone_bricks": "บล็อกอิฐหินเอนด์",
  "block.minecraft.ender_chest": "หีบเอนเดอร์",
  "block.minecraft.exposed_chiseled_copper": "ทองแดงสลักลอก",
  "block.minecraft.exposed_copper": "ทองแดงลอก",
  "block.minecraft.exposed_copper_bars": "ลูกกรงทองแดงลอก",
  "block.minecraft.exposed_copper_bulb": "หลอดไฟทองแดงลอก",
  "block.minecraft.exposed_copper_chain": "โซ่ทองแดงลอก",
  "block.minecraft.exposed_copper_chest": "หีบทองแดงลอก",
  "block.minecraft.exposed_copper_door": "ประตูทองแดงลอก",
  "block.minecraft.exposed_copper_golem_statue": "รูปปั้นโกเลมทองแดงลอก",
  "block.minecraft.exposed_copper_grate": "ตะแกรงทองแดงลอก",
  "block.minecraft.exposed_copper_lantern": "โคมไฟทองแดงลอก",
  "block.minecraft.exposed_copper_trapdoor": "ประตูกับดักทองแดงลอก",
  "block.minecraft.exposed_cut_copper": "ทองแดงตัดลอก",
  "block.minecraft.exposed_cut_copper_slab": "แผ่นทองแดงตัดลอก",
  "block.minecraft.exposed_cut_copper_stairs": "บันไดทองแดงตัดลอก",
  "block.minecraft.exposed_lightning_rod": "สายล่อฟ้าลอก",
  "block.minecraft.farmland": "บล็อกทำฟาร์ม",
  "block.minecraft.fern": "เฟิร์น",
  "block.minecraft.fire": "ไฟ",
  "block.minecraft.fire_coral": "ปะการังไฟ",
  "block.minecraft.fire_coral_block": "บล็อกปะการังไฟ",
  "block.minecraft.fire_coral_fan": "ปะการังไฟรูปพัด",
  "block.minecraft.fire_coral_wall_fan": "ปะการังไฟรูปพัดติดผนัง",
  "block.minecraft.firefly_bush": "พุ่มหิ่งห้อย",
  "block.minecraft.fletching_table": "โต๊ะทำธนู",
  "block.minecraft.flower_pot": "กระถางดอกไม้",
  "block.minecraft.flowering_azalea": "กุหลาบพันปีมีดอก",
  "block.minecraft.flowering_azalea_leaves": "ใบกุหลาบพันปีมีดอก",
  "block.minecraft.frogspawn": "ไข่กบ",
  "block.minecraft.frosted_ice": "น้ำแข็งเย็นจัด",
  "block.minecraft.furnace": "เตาเผา",
  "block.minecraft.gilded_blackstone": "หินดำฝังทอง",
  "block.minecraft.glass": "กระจก",
  "block.minecraft.glass_pane": "แผ่นกระจก",
  "block.minecraft.glow_lichen": "ไลเคนเรืองแสง",
  "block.minecraft.glowstone": "หินเรืองแสง",
  "block.minecraft.gold_block": "บล็อกทอง",
  "block.minecraft.gold_ore": "แร่ทอง",
  "block.minecraft.golden_dandelion": "ดอกแดนดิไลออนทอง",
  "block.minecraft.granite": "หินแกรนิต",
  "block.minecraft.granite_slab": "แผ่นหินแกรนิต",
  "block.minecraft.granite_stairs": "บันไดหินแกรนิต",
  "block.minecraft.granite_wall": "กำแพงหินแกรนิต",
  "block.minecraft.grass": "หญ้า",
  "block.minecraft.grass_block": "บล็อกหญ้า",
  "block.minecraft.gravel": "กรวด",
  "block.minecraft.gray_banner": "ธงสีเทา",
  "block.minecraft.gray_bed": "เตียงสีเทา",
  "block.minecraft.gray_candle": "เทียนสีเทา",
  "block.minecraft.gray_candle_cake": "เค้กพร้อมเทียนสีเทา",
  "block.minecraft.gray_carpet": "พรมสีเทา",
  "block.minecraft.gray_concrete": "คอนกรีตสีเทา",
  "block.minecraft.gray_concrete_powder": "ผงคอนกรีตสีเทา",
  "block.minecraft.gray_glazed_terracotta": "ดินเผาเคลือบสีเทา",
  "block.minecraft.gray_shulker_box": "กล่องชัลเกอร์สีเทา",
  "block.minecraft.gray_stained_glass": "กระจกสีเทา",
  "block.minecraft.gray_stained_glass_pane": "แผ่นกระจกสีเทา",
  "block.minecraft.gray_terracotta": "ดินเผาสีเทา",
  "block.minecraft.gray_wool": "ขนแกะสีเทา",
  "block.minecraft.green_banner": "ธงสีเขียว",
  "block.minecraft.green_bed": "เตียงสีเขียว",
  "block.minecraft.green_candle": "เทียนสีเขียว",
  "block.minecraft.green_candle_cake": "เค้กพร้อมเทียนสีเขียว",
  "block.minecraft.green_carpet": "พรมสีเขียว",
  "block.minecraft.green_concrete": "คอนกรีตสีเขียว",
  "block.minecraft.green_concrete_powder": "ผงคอนกรีตสีเขียว",
  "block.minecraft.green_glazed_terracotta": "ดินเผาเคลือบสีเขียว",
  "block.minecraft.green_shulker_box": "กล่องชัลเกอร์สีเขียว",
  "block.minecraft.green_stained_glass": "กระจกสีเขียว",
  "block.minecraft.green_stained_glass_pane": "แผ่นกระจกสีเขียว",
  "block.minecraft.green_terracotta": "ดินเผาสีเขียว",
  "block.minecraft.green_wool": "ขนแกะสีเขียว",
  "block.minecraft.grindstone": "หินลับมีด",
  "block.minecraft.hanging_roots": "รากห้อย",
  "block.minecraft.hay_block": "กองฟาง",
  "block.minecraft.heavy_core": "แกนหนัก",
  "block.minecraft.heavy_weighted_pressure_plate": "แป้นเหยียบถ่วงน้ำหนักแบบหนัก",
  "block.minecraft.honey_block": "บล็อกน้ำผึ้ง",
  "block.minecraft.honeycomb_block": "บล็อกรวงผึ้ง",
  "block.minecraft.hopper": "ท่อส่ง",
  "block.minecraft.horn_coral": "ปะการังเขา",
  "block.minecraft.horn_coral_block": "บล็อกปะการังเขา",
  "block.minecraft.horn_coral_fan": "ปะการังเขารูปพัด",
  "block.minecraft.horn_coral_wall_fan": "ปะการังเขารูปพัดติดผนัง",
  "block.minecraft.ice": "น้ำแข็ง",
  "block.minecraft.infested_chiseled_stone_bricks": "บล็อกอิฐหินสลักติดเชื้อ",
  "block.minecraft.infested_cobblestone": "หินหยาบติดเชื้อ",
  "block.minecraft.infested_cracked_stone_bricks": "บล็อกอิฐหินร้าวติดเชื้อ",
  "block.minecraft.infested_deepslate": "หินชนวนลึกติดเชื้อ",
  "block.minecraft.infested_mossy_stone_bricks": "บล็อกอิฐหินมอสส์ติดเชื้อ",
  "block.minecraft.infested_stone": "หินติดเชื้อ",
  "block.minecraft.infested_stone_bricks": "บล็อกอิฐหินติดเชื้อ",
  "block.minecraft.iron_bars": "ลูกกรงเหล็ก",
  "block.minecraft.iron_block": "บล็อกเหล็ก",
  "block.minecraft.iron_chain": "โซ่เหล็ก",
  "block.minecraft.iron_door": "ประตูเหล็ก",
  "block.minecraft.iron_ore": "แร่เหล็ก",
  "block.minecraft.iron_trapdoor": "ประตูกับดักเหล็ก",
  "block.minecraft.jack_o_lantern": "โคมไฟฟักทอง",
  "block.minecraft.jigsaw": "บล็อกจิ๊กซอว์",
  "block.minecraft.jukebox": "ตู้เพลง",
  "block.minecraft.jungle_button": "ปุ่มไม้ป่าดงดิบ",
  "block.minecraft.jungle_door": "ประตูไม้ป่าดงดิบ",
  "block.minecraft.jungle_fence": "รั้วไม้ป่าดงดิบ",
  "block.minecraft.jungle_fence_gate": "ประตูรั้วไม้ป่าดงดิบ",
  "block.minecraft.jungle_hanging_sign": "ป้ายแขวนไม้ป่าดงดิบ",
  "block.minecraft.jungle_leaves": "ใบไม้ป่าดงดิบ",
  "block.minecraft.jungle_log": "ท่อนไม้ป่าดงดิบ",
  "block.minecraft.jungle_planks": "ไม้กระดานป่าดงดิบ",
  "block.minecraft.jungle_pressure_plate": "แป้นเหยียบไม้ป่าดงดิบ",
  "block.minecraft.jungle_sapling": "ต้นอ่อนไม้ป่าดงดิบ",
  "block.minecraft.jungle_shelf": "ชั้นวางไม้ป่าดงดิบ",
  "block.minecraft.jungle_sign": "ป้ายไม้ป่าดงดิบ",
  "block.minecraft.jungle_slab": "แผ่นไม้ป่าดงดิบ",
  "block.minecraft.jungle_stairs": "บันไดไม้ป่าดงดิบ",
  "block.minecraft.jungle_trapdoor": "ประตูกับดักไม้ป่าดงดิบ",
  "block.minecraft.jungle_wall_hanging_sign": "ป้ายแขวนไม้ป่าดงดิบติดผนัง",
  "block.minecraft.jungle_wall_sign": "ป้ายติดผนังไม้ป่าดงดิบ",
  "block.minecraft.jungle_wood": "ไม้ป่าดงดิบ",
  "block.minecraft.kelp": "สาหร่ายทะเล",
  "block.minecraft.kelp_plant": "ต้นสาหร่ายทะเล",
  "block.minecraft.ladder": "บันไดลิง",
  "block.minecraft.lantern": "โคมไฟ",
  "block.minecraft.lapis_block": "บล็อกลาพิสลาซูลี",
  "block.minecraft.lapis_ore": "แร่ลาพิสลาซูลี",
  "block.minecraft.large_amethyst_bud": "หน่อแอเมทิสต์ขนาดใหญ่",
  "block.minecraft.large_fern": "เฟิร์นใหญ่",
  "block.minecraft.lava": "ลาวา",
  "block.minecraft.lava_cauldron": "หม้อปรุงยาบรรจุลาวา",
  "block.minecraft.leaf_litter": "เศษใบไม้แห้ง",
  "block.minecraft.lectern": "แท่นอ่านหนังสือ",
  "block.minecraft.lever": "คันโยก",
  "block.minecraft.light": "บล็อกแสง",
  "block.minecraft.light_blue_banner": "ธงสีฟ้า",
  "block.minecraft.light_blue_bed": "เตียงสีฟ้า",
  "block.minecraft.light_blue_candle": "เทียนสีฟ้า",
  "block.minecraft.light_blue_candle_cake": "เค้กพร้อมเทียนสีฟ้า",
  "block.minecraft.light_blue_carpet": "พรมสีฟ้า",
  "block.minecraft.light_blue_concrete": "คอนกรีตสีฟ้า",
  "block.minecraft.light_blue_concrete_powder": "ผงคอนกรีตสีฟ้า",
  "block.minecraft.light_blue_glazed_terracotta": "ดินเผาเคลือบสีฟ้า",
  "block.minecraft.light_blue_shulker_box": "กล่องชัลเกอร์สีฟ้า",
  "block.minecraft.light_blue_stained_glass": "กระจกสีฟ้า",
  "block.minecraft.light_blue_stained_glass_pane": "แผ่นกระจกสีฟ้า",
  "block.minecraft.light_blue_terracotta": "ดินเผาสีฟ้า",
  "block.minecraft.light_blue_wool": "ขนแกะสีฟ้า",
  "block.minecraft.light_gray_banner": "ธงสีเทาอ่อน",
  "block.minecraft.light_gray_bed": "เตียงสีเทาอ่อน",
  "block.minecraft.light_gray_candle": "เทียนสีเทาอ่อน",
  "block.minecraft.light_gray_candle_cake": "เค้กพร้อมเทียนสีเทาอ่อน",
  "block.minecraft.light_gray_carpet": "พรมสีเทาอ่อน",
  "block.minecraft.light_gray_concrete": "คอนกรีตสีเทาอ่อน",
  "block.minecraft.light_gray_concrete_powder": "ผงคอนกรีตสีเทาอ่อน",
  "block.minecraft.light_gray_glazed_terracotta": "ดินเผาเคลือบสีเทาอ่อน",
  "block.minecraft.light_gray_shulker_box": "กล่องชัลเกอร์สีเทาอ่อน",
  "block.minecraft.light_gray_stained_glass": "กระจกสีเทาอ่อน",
  "block.minecraft.light_gray_stained_glass_pane": "แผ่นกระจกสีเทาอ่อน",
  "block.minecraft.light_gray_terracotta": "ดินเผาสีเทาอ่อน",
  "block.minecraft.light_gray_wool": "ขนแกะสีเทาอ่อน",
  "block.minecraft.light_weighted_pressure_plate": "แป้นเหยียบถ่วงน้ำหนักแบบเบา",
  "block.minecraft.lightning_rod": "สายล่อฟ้า",
  "block.minecraft.lilac": "ดอกไลแล็ก",
  "block.minecraft.lily_of_the_valley": "ลิลลี่หุบเขา",
  "block.minecraft.lily_pad": "ใบบัว",
  "block.minecraft.lime_banner": "ธงสีเขียวอ่อน",
  "block.minecraft.lime_bed": "เตียงสีเขียวอ่อน",
  "block.minecraft.lime_candle": "เทียนสีเขียวอ่อน",
  "block.minecraft.lime_candle_cake": "เค้กพร้อมเทียนสีเขียวอ่อน",
  "block.minecraft.lime_carpet": "พรมสีเขียวอ่อน",
  "block.minecraft.lime_concrete": "คอนกรีตสีเขียวอ่อน",
  "block.minecraft.lime_concrete_powder": "ผงคอนกรีตสีเขียวอ่อน",
  "block.minecraft.lime_glazed_terracotta": "ดินเผาเคลือบสีเขียวอ่อน",
  "block.minecraft.lime_shulker_box": "กล่องชัลเกอร์สีเขียวอ่อน",
  "block.minecraft.lime_stained_glass": "กระจกสีเขียวอ่อน",
  "block.minecraft.lime_stained_glass_pane": "แผ่นกระจกสีเขียวอ่อน",
  "block.minecraft.lime_terracotta": "ดินเผาสีเขียวอ่อน",
  "block.minecraft.lime_wool": "ขนแกะสีเขียวอ่อน",
  "block.minecraft.lodestone": "หินนำทาง",
  "block.minecraft.loom": "เครื่องทอผ้า",
  "block.minecraft.magenta_banner": "ธงสีบานเย็น",
  "block.minecraft.magenta_bed": "เตียงสีบานเย็น",
  "block.minecraft.magenta_candle": "เทียนสีบานเย็น",
  "block.minecraft.magenta_candle_cake": "เค้กพร้อมเทียนสีบานเย็น",
  "block.minecraft.magenta_carpet": "พรมสีบานเย็น",
  "block.minecraft.magenta_concrete": "คอนกรีตสีบานเย็น",
  "block.minecraft.magenta_concrete_powder": "ผงคอนกรีตสีบานเย็น",
  "block.minecraft.magenta_glazed_terracotta": "ดินเผาเคลือบสีบานเย็น",
  "block.minecraft.magenta_shulker_box": "กล่องชัลเกอร์สีบานเย็น",
  "block.minecraft.magenta_stained_glass": "กระจกสีบานเย็น",
  "block.minecraft.magenta_stained_glass_pane": "แผ่นกระจกสีบานเย็น",
  "block.minecraft.magenta_terracotta": "ดินเผาสีบานเย็น",
  "block.minecraft.magenta_wool": "ขนแกะสีบานเย็น",
  "block.minecraft.magma_block": "บล็อกแม็กม่า",
  "block.minecraft.mangrove_button": "ปุ่มไม้โกงกาง",
  "block.minecraft.mangrove_door": "ประตูไม้โกงกาง",
  "block.minecraft.mangrove_fence": "รั้วไม้โกงกาง",
  "block.minecraft.mangrove_fence_gate": "ประตูรั้วไม้โกงกาง",
  "block.minecraft.mangrove_hanging_sign": "ป้ายแขวนไม้โกงกาง",
  "block.minecraft.mangrove_leaves": "ใบไม้โกงกาง",
  "block.minecraft.mangrove_log": "ท่อนไม้โกงกาง",
  "block.minecraft.mangrove_planks": "ไม้กระดานโกงกาง",
  "block.minecraft.mangrove_pressure_plate": "แป้นเหยียบไม้โกงกาง",
  "block.minecraft.mangrove_propagule": "ฝักพันธุ์ไม้โกงกาง",
  "block.minecraft.mangrove_roots": "รากไม้โกงกาง",
  "block.minecraft.mangrove_shelf": "ชั้นวางไม้โกงกาง",
  "block.minecraft.mangrove_sign": "ป้ายไม้โกงกาง",
  "block.minecraft.mangrove_slab": "แผ่นไม้โกงกาง",
  "block.minecraft.mangrove_stairs": "บันไดไม้โกงกาง",
  "block.minecraft.mangrove_trapdoor": "ประตูกับดักไม้โกงกาง",
  "block.minecraft.mangrove_wall_hanging_sign": "ป้ายแขวนไม้โกงกางติดผนัง",
  "block.minecraft.mangrove_wall_sign": "ป้ายติดผนังไม้โกงกาง",
  "block.minecraft.mangrove_wood": "ไม้โกงกาง",
  "block.minecraft.medium_amethyst_bud": "หน่อแอเมทิสต์ขนาดกลาง",
  "block.minecraft.melon": "แตงโม",
  "block.minecraft.melon_stem": "ลำต้นแตงโม",
  "block.minecraft.moss_block": "บล็อกมอสส์",
  "block.minecraft.moss_carpet": "พรมมอสส์",
  "block.minecraft.mossy_cobblestone": "หินหยาบมอสส์",
  "block.minecraft.mossy_cobblestone_slab": "แผ่นหินหยาบมอสส์",
  "block.minecraft.mossy_cobblestone_stairs": "บันไดหินหยาบมอสส์",
  "block.minecraft.mossy_cobblestone_wall": "กำแพงหินหยาบมอสส์",
  "block.minecraft.mossy_stone_brick_slab": "แผ่นอิฐหินมอสส์",
  "block.minecraft.mossy_stone_brick_stairs": "บันไดอิฐหินมอสส์",
  "block.minecraft.mossy_stone_brick_wall": "กำแพงอิฐหินมอสส์",
  "block.minecraft.mossy_stone_bricks": "บล็อกอิฐหินมอสส์",
  "block.minecraft.moving_piston": "ลูกสูบเคลื่อน",
  "block.minecraft.mud": "โคลน",
  "block.minecraft.mud_brick_slab": "แผ่นอิฐโคลน",
  "block.minecraft.mud_brick_stairs": "บันไดอิฐโคลน",
  "block.minecraft.mud_brick_wall": "กำแพงอิฐโคลน",
  "block.minecraft.mud_bricks": "บล็อกอิฐโคลน",
  "block.minecraft.muddy_mangrove_roots": "รากไม้โกงกางติดโคลน",
  "block.minecraft.mushroom_stem": "ลำต้นเห็ด",
  "block.minecraft.mycelium": "กลุ่มใยรา",
  "block.minecraft.nether_brick_fence": "รั้วอิฐเนเธอร์",
  "block.minecraft.nether_brick_slab": "แผ่นอิฐเนเธอร์",
  "block.minecraft.nether_brick_stairs": "บันไดอิฐเนเธอร์",
  "block.minecraft.nether_brick_wall": "กำแพงอิฐเนเธอร์",
  "block.minecraft.nether_bricks": "บล็อกอิฐเนเธอร์",
  "block.minecraft.nether_gold_ore": "แร่ทองเนเธอร์",
  "block.minecraft.nether_portal": "ประตูมิติเนเธอร์",
  "block.minecraft.nether_quartz_ore": "แร่ควอตซ์เนเธอร์",
  "block.minecraft.nether_sprouts": "ต้นอ่อนเนเธอร์",
  "block.minecraft.nether_wart": "หูดเนเธอร์",
  "block.minecraft.nether_wart_block": "บล็อกหูดเนเธอร์",
  "block.minecraft.netherite_block": "บล็อกเนเธอไรต์",
  "block.minecraft.netherrack": "หินเนเธอร์",
  "block.minecraft.note_block": "กล่องตัวโน้ต",
  "block.minecraft.oak_button": "ปุ่มไม้โอ๊ก",
  "block.minecraft.oak_door": "ประตูไม้โอ๊ก",
  "block.minecraft.oak_fence": "รั้วไม้โอ๊ก",
  "block.minecraft.oak_fence_gate": "ประตูรั้วไม้โอ๊ก",
  "block.minecraft.oak_hanging_sign": "ป้ายแขวนไม้โอ๊ก",
  "block.minecraft.oak_leaves": "ใบไม้โอ๊ก",
  "block.minecraft.oak_log": "ท่อนไม้โอ๊ก",
  "block.minecraft.oak_planks": "ไม้กระดานโอ๊ก",
  "block.minecraft.oak_pressure_plate": "แป้นเหยียบไม้โอ๊ก",
  "block.minecraft.oak_sapling": "ต้นอ่อนไม้โอ๊ก",
  "block.minecraft.oak_shelf": "ชั้นวางไม้โอ๊ก",
  "block.minecraft.oak_sign": "ป้ายไม้โอ๊ก",
  "block.minecraft.oak_slab": "แผ่นไม้โอ๊ก",
  "block.minecraft.oak_stairs": "บันไดไม้โอ๊ก",
  "block.minecraft.oak_trapdoor": "ประตูกับดักไม้โอ๊ก",
  "block.minecraft.oak_wall_hanging_sign": "ป้ายแขวนไม้โอ๊กติดผนัง",
  "block.minecraft.oak_wall_sign": "ป้ายไม้โอ๊กติดผนัง",
  "block.minecraft.oak_wood": "ไม้โอ๊ก",
  "block.minecraft.observer": "ตัวสังเกตการณ์",
  "block.minecraft.obsidian": "หินออบซิเดียน",
  "block.minecraft.ochre_froglight": "ไฟกบสีดินเหลือง",
  "block.minecraft.ominous_banner": "ธงแห่งลางร้าย",
  "block.minecraft.open_eyeblossom": "ดอกดวงตาเปิด",
  "block.minecraft.orange_banner": "ธงสีส้ม",
  "block.minecraft.orange_bed": "เตียงสีส้ม",
  "block.minecraft.orange_candle": "เทียนสีส้ม",
  "block.minecraft.orange_candle_cake": "เค้กพร้อมเทียนสีส้ม",
  "block.minecraft.orange_carpet": "พรมสีส้ม",
  "block.minecraft.orange_concrete": "คอนกรีตสีส้ม",
  "block.minecraft.orange_concrete_powder": "ผงคอนกรีตสีส้ม",
  "block.minecraft.orange_glazed_terracotta": "ดินเผาเคลือบสีส้ม",
  "block.minecraft.orange_shulker_box": "กล่องชัลเกอร์สีส้ม",
  "block.minecraft.orange_stained_glass": "กระจกสีส้ม",
  "block.minecraft.orange_stained_glass_pane": "แผ่นกระจกสีส้ม",
  "block.minecraft.orange_terracotta": "ดินเผาสีส้ม",
  "block.minecraft.orange_tulip": "ดอกทิวลิปส้ม",
  "block.minecraft.orange_wool": "ขนแกะสีส้ม",
  "block.minecraft.oxeye_daisy": "ดอกอ๊อกซายเดซี่",
  "block.minecraft.oxidized_chiseled_copper": "ทองแดงสลักขึ้นสนิม",
  "block.minecraft.oxidized_copper": "ทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_bars": "ลูกกรงทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_bulb": "หลอดไฟทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_chain": "โซ่ทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_chest": "หีบทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_door": "ประตูทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_golem_statue": "รูปปั้นโกเลมทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_grate": "ตะแกรงทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_lantern": "โคมไฟทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_copper_trapdoor": "ประตูกับดักทองแดงขึ้นสนิม",
  "block.minecraft.oxidized_cut_copper": "ทองแดงตัดขึ้นสนิม",
  "block.minecraft.oxidized_cut_copper_slab": "แผ่นทองแดงตัดขึ้นสนิม",
  "block.minecraft.oxidized_cut_copper_stairs": "บันไดทองแดงตัดขึ้นสนิม",
  "block.minecraft.oxidized_lightning_rod": "สายล่อฟ้าขึ้นสนิม",
  "block.minecraft.packed_ice": "น้ำแข็งอัดแน่น",
  "block.minecraft.packed_mud": "โคลนอัดแน่น",
  "block.minecraft.pale_hanging_moss": "มอสส์ซีดห้อย",
  "block.minecraft.pale_moss_block": "บล็อกมอสส์ซีด",
  "block.minecraft.pale_moss_carpet": "พรมมอสส์ซีด",
  "block.minecraft.pale_oak_button": "ปุ่มไม้โอ๊กซีด",
  "block.minecraft.pale_oak_door": "ประตูไม้โอ๊กซีด",
  "block.minecraft.pale_oak_fence": "รั้วไม้โอ๊กซีด",
  "block.minecraft.pale_oak_fence_gate": "ประตูรั้วไม้โอ๊กซีด",
  "block.minecraft.pale_oak_hanging_sign": "ป้ายแขวนไม้โอ๊กซีด",
  "block.minecraft.pale_oak_leaves": "ใบไม้โอ๊กซีด",
  "block.minecraft.pale_oak_log": "ท่อนไม้โอ๊กซีด",
  "block.minecraft.pale_oak_planks": "ไม้กระดานโอ๊กซีด",
  "block.minecraft.pale_oak_pressure_plate": "แป้นเหยียบไม้โอ๊กซีด",
  "block.minecraft.pale_oak_sapling": "ต้นอ่อนไม้โอ๊กซีด",
  "block.minecraft.pale_oak_shelf": "ชั้นวางไม้โอ๊กซีด",
  "block.minecraft.pale_oak_sign": "ป้ายไม้โอ๊กซีด",
  "block.minecraft.pale_oak_slab": "แผ่นไม้โอ๊กซีด",
  "block.minecraft.pale_oak_stairs": "บันไดไม้โอ๊กซีด",
  "block.minecraft.pale_oak_trapdoor": "ประตูกับดักไม้โอ๊กซีด",
  "block.minecraft.pale_oak_wall_hanging_sign": "ป้ายแขวนไม้โอ๊กซีดติดผนัง",
  "block.minecraft.pale_oak_wall_sign": "ป้ายไม้โอ๊กซีดติดผนัง",
  "block.minecraft.pale_oak_wood": "ไม้โอ๊กซีด",
  "block.minecraft.pearlescent_froglight": "ไฟกบสีเหลือบมุก",
  "block.minecraft.peony": "ดอกโบตั๋น",
  "block.minecraft.petrified_oak_slab": "แผ่นไม้โอ๊กกลายเป็นหิน",
  "block.minecraft.piglin_head": "หัวพิกลิน",
  "block.minecraft.piglin_wall_head": "หัวพิกลินติดผนัง",
  "block.minecraft.pink_banner": "ธงสีชมพู",
  "block.minecraft.pink_bed": "เตียงสีชมพู",
  "block.minecraft.pink_candle": "เทียนสีชมพู",
  "block.minecraft.pink_candle_cake": "เค้กพร้อมเทียนสีชมพู",
  "block.minecraft.pink_carpet": "พรมสีชมพู",
  "block.minecraft.pink_concrete": "คอนกรีตสีชมพู",
  "block.minecraft.pink_concrete_powder": "ผงคอนกรีตสีชมพู",
  "block.minecraft.pink_glazed_terracotta": "ดินเผาเคลือบสีชมพู",
  "block.minecraft.pink_petals": "กลีบดอกสีชมพู",
  "block.minecraft.pink_shulker_box": "กล่องชัลเกอร์สีชมพู",
  "block.minecraft.pink_stained_glass": "กระจกสีชมพู",
  "block.minecraft.pink_stained_glass_pane": "แผ่นกระจกสีชมพู",
  "block.minecraft.pink_terracotta": "ดินเผาสีชมพู",
  "block.minecraft.pink_tulip": "ดอกทิวลิปชมพู",
  "block.minecraft.pink_wool": "ขนแกะสีชมพู",
  "block.minecraft.piston": "ลูกสูบ",
  "block.minecraft.piston_head": "หัวลูกสูบ",
  "block.minecraft.pitcher_crop": "พืชผลหม้อข้าวหม้อแกงลิง",
  "block.minecraft.pitcher_plant": "ต้นหม้อข้าวหม้อแกงลิง",
  "block.minecraft.player_head": "หัวผู้เล่น",
  "block.minecraft.player_head.named": "หัวของ %s",
  "block.minecraft.player_wall_head": "หัวผู้เล่นติดผนัง",
  "block.minecraft.podzol": "ดินพอดซอล",
  "block.minecraft.pointed_dripstone": "หินหยดแหลม",
  "block.minecraft.polished_andesite": "หินแอนดีไซต์ขัด",
  "block.minecraft.polished_andesite_slab": "แผ่นหินแอนดีไซต์ขัด",
  "block.minecraft.polished_andesite_stairs": "บันไดหินแอนดีไซต์ขัด",
  "block.minecraft.polished_basalt": "หินบะซอลต์ขัด",
  "block.minecraft.polished_blackstone": "หินดำขัด",
  "block.minecraft.polished_blackstone_brick_slab": "แผ่นอิฐหินดำขัด",
  "block.minecraft.polished_blackstone_brick_stairs": "บันไดอิฐหินดำขัด",
  "block.minecraft.polished_blackstone_brick_wall": "กำแพงอิฐหินดำขัด",
  "block.minecraft.polished_blackstone_bricks": "บล็อกอิฐหินดำขัด",
  "block.minecraft.polished_blackstone_button": "ปุ่มหินดำขัด",
  "block.minecraft.polished_blackstone_pressure_plate": "แป้นเหยียบหินดำขัด",
  "block.minecraft.polished_blackstone_slab": "แผ่นหินดำขัด",
  "block.minecraft.polished_blackstone_stairs": "บันไดหินดำขัด",
  "block.minecraft.polished_blackstone_wall": "กำแพงหินดำขัด",
  "block.minecraft.polished_deepslate": "หินชนวนลึกขัด",
  "block.minecraft.polished_deepslate_slab": "แผ่นหินชนวนลึกขัด",
  "block.minecraft.polished_deepslate_stairs": "บันไดหินชนวนลึกขัด",
  "block.minecraft.polished_deepslate_wall": "กำแพงหินชนวนลึกขัด",
  "block.minecraft.polished_diorite": "หินไดออไรต์ขัด",
  "block.minecraft.polished_diorite_slab": "แผ่นหินไดออไรต์ขัด",
  "block.minecraft.polished_diorite_stairs": "บันไดหินไดออไรต์ขัด",
  "block.minecraft.polished_granite": "หินแกรนิตขัด",
  "block.minecraft.polished_granite_slab": "แผ่นหินแกรนิตขัด",
  "block.minecraft.polished_granite_stairs": "บันไดหินแกรนิตขัด",
  "block.minecraft.polished_tuff": "หินภูเขาไฟขัด",
  "block.minecraft.polished_tuff_slab": "แผ่นหินภูเขาไฟขัด",
  "block.minecraft.polished_tuff_stairs": "บันไดหินภูเขาไฟขัด",
  "block.minecraft.polished_tuff_wall": "กำแพงหินภูเขาไฟขัด",
  "block.minecraft.poppy": "ดอกป๊อปปี้",
  "block.minecraft.potatoes": "มันฝรั่ง",
  "block.minecraft.potted_acacia_sapling": "กระถางต้นอ่อนไม้อะเคเซีย",
  "block.minecraft.potted_allium": "กระถางดอกอัลเลียม",
  "block.minecraft.potted_azalea_bush": "กระถางกุหลาบพันปี",
  "block.minecraft.potted_azure_bluet": "กระถางดอกแอเชอร์บลูเอ็ต",
  "block.minecraft.potted_bamboo": "กระถางไม้ไผ่",
  "block.minecraft.potted_birch_sapling": "กระถางต้นอ่อนไม้เบิร์ช",
  "block.minecraft.potted_blue_orchid": "กระถางกล้วยไม้น้ำเงิน",
  "block.minecraft.potted_brown_mushroom": "กระถางเห็ดน้ำตาล",
  "block.minecraft.potted_cactus": "กระถางกระบองเพชร",
  "block.minecraft.potted_cherry_sapling": "กระถางต้นอ่อนไม้ซากุระ",
  "block.minecraft.potted_closed_eyeblossom": "กระถางดอกดวงตาปิด",
  "block.minecraft.potted_cornflower": "กระถางคอร์นฟลาวเวอร์",
  "block.minecraft.potted_crimson_fungus": "กระถางเห็ดราสีเลือด",
  "block.minecraft.potted_crimson_roots": "กระถางรากไม้สีเลือด",
  "block.minecraft.potted_dandelion": "กระถางดอกแดนดิไลออน",
  "block.minecraft.potted_dark_oak_sapling": "กระถางต้นอ่อนไม้โอ๊กดำ",
  "block.minecraft.potted_dead_bush": "กระถางพุ่มไม้แห้ง",
  "block.minecraft.potted_fern": "กระถางเฟิร์น",
  "block.minecraft.potted_flowering_azalea_bush": "กระถางกุหลาบพันปีมีดอก",
  "block.minecraft.potted_golden_dandelion": "กระถางดอกแดนดิไลออนทอง",
  "block.minecraft.potted_jungle_sapling": "กระถางต้นอ่อนไม้ป่าดงดิบ",
  "block.minecraft.potted_lily_of_the_valley": "กระถางลิลลี่หุบเขา",
  "block.minecraft.potted_mangrove_propagule": "กระถางฝักพันธุ์ไม้โกงกาง",
  "block.minecraft.potted_oak_sapling": "กระถางต้นอ่อนไม้โอ๊ก",
  "block.minecraft.potted_open_eyeblossom": "กระถางดอกดวงตาเปิด",
  "block.minecraft.potted_orange_tulip": "กระถางดอกทิวลิปส้ม",
  "block.minecraft.potted_oxeye_daisy": "กระถางดอกอ๊อกซายเดซี่",
  "block.minecraft.potted_pale_oak_sapling": "กระถางต้นอ่อนไม้โอ๊กซีด",
  "block.minecraft.potted_pink_tulip": "กระถางดอกทิวลิปชมพู",
  "block.minecraft.potted_poppy": "กระถางดอกป๊อปปี้",
  "block.minecraft.potted_red_mushroom": "กระถางเห็ดแดง",
  "block.minecraft.potted_red_tulip": "กระถางดอกทิวลิปแดง",
  "block.minecraft.potted_spruce_sapling": "กระถางต้นอ่อนไม้สนสปรูซ",
  "block.minecraft.potted_torchflower": "กระถางดอกคบเพลิง",
  "block.minecraft.potted_warped_fungus": "กระถางเห็ดราวิปริต",
  "block.minecraft.potted_warped_roots": "กระถางรากไม้ป่าวิปริต",
  "block.minecraft.potted_white_tulip": "กระถางดอกทิวลิปขาว",
  "block.minecraft.potted_wither_rose": "กระถางกุหลาบวิทเธอร์",
  "block.minecraft.powder_snow": "หิมะผง",
  "block.minecraft.powder_snow_cauldron": "หม้อปรุงยาบรรจุหิมะผง",
  "block.minecraft.powered_rail": "รางขับเคลื่อน",
  "block.minecraft.prismarine": "พริสมารีน",
  "block.minecraft.prismarine_brick_slab": "แผ่นอิฐพริสมารีน",
  "block.minecraft.prismarine_brick_stairs": "บันไดอิฐพริสมารีน",
  "block.minecraft.prismarine_bricks": "บล็อกอิฐพริสมารีน",
  "block.minecraft.prismarine_slab": "แผ่นพริสมารีน",
  "block.minecraft.prismarine_stairs": "บันไดพริสมารีน",
  "block.minecraft.prismarine_wall": "กำแพงพริสมารีน",
  "block.minecraft.pumpkin": "ฟักทอง",
  "block.minecraft.pumpkin_stem": "ลำต้นฟักทอง",
  "block.minecraft.purple_banner": "ธงสีม่วง",
  "block.minecraft.purple_bed": "เตียงสีม่วง",
  "block.minecraft.purple_candle": "เทียนสีม่วง",
  "block.minecraft.purple_candle_cake": "เค้กพร้อมเทียนสีม่วง",
  "block.minecraft.purple_carpet": "พรมสีม่วง",
  "block.minecraft.purple_concrete": "คอนกรีตสีม่วง",
  "block.minecraft.purple_concrete_powder": "ผงคอนกรีตสีม่วง",
  "block.minecraft.purple_glazed_terracotta": "ดินเผาเคลือบสีม่วง",
  "block.minecraft.purple_shulker_box": "กล่องชัลเกอร์สีม่วง",
  "block.minecraft.purple_stained_glass": "กระจกสีม่วง",
  "block.minecraft.purple_stained_glass_pane": "แผ่นกระจกสีม่วง",
  "block.minecraft.purple_terracotta": "ดินเผาสีม่วง",
  "block.minecraft.purple_wool": "ขนแกะสีม่วง",
  "block.minecraft.purpur_block": "บล็อกเพอร์เพอร์",
  "block.minecraft.purpur_pillar": "เสาเพอร์เพอร์",
  "block.minecraft.purpur_slab": "แผ่นเพอร์เพอร์",
  "block.minecraft.purpur_stairs": "บันไดเพอร์เพอร์",
  "block.minecraft.quartz_block": "บล็อกควอตซ์",
  "block.minecraft.quartz_bricks": "บล็อกอิฐควอตซ์",
  "block.minecraft.quartz_pillar": "เสาควอตซ์",
  "block.minecraft.quartz_slab": "แผ่นควอตซ์",
  "block.minecraft.quartz_stairs": "บันไดควอตซ์",
  "block.minecraft.rail": "ราง",
  "block.minecraft.raw_copper_block": "บล็อกทองแดงดิบ",
  "block.minecraft.raw_gold_block": "บล็อกทองดิบ",
  "block.minecraft.raw_iron_block": "บล็อกเหล็กดิบ",
  "block.minecraft.red_banner": "ธงสีแดง",
  "block.minecraft.red_bed": "เตียงสีแดง",
  "block.minecraft.red_candle": "เทียนสีแดง",
  "block.minecraft.red_candle_cake": "เค้กพร้อมเทียนสีแดง",
  "block.minecraft.red_carpet": "พรมสีแดง",
  "block.minecraft.red_concrete": "คอนกรีตสีแดง",
  "block.minecraft.red_concrete_powder": "ผงคอนกรีตสีแดง",
  "block.minecraft.red_glazed_terracotta": "ดินเผาเคลือบสีแดง",
  "block.minecraft.red_mushroom": "เห็ดแดง",
  "block.minecraft.red_mushroom_block": "บล็อกเห็ดแดง",
  "block.minecraft.red_nether_brick_slab": "แผ่นอิฐเนเธอร์แดง",
  "block.minecraft.red_nether_brick_stairs": "บันไดอิฐเนเธอร์แดง",
  "block.minecraft.red_nether_brick_wall": "กำแพงอิฐเนเธอร์แดง",
  "block.minecraft.red_nether_bricks": "บล็อกอิฐเนเธอร์แดง",
  "block.minecraft.red_sand": "ทรายแดง",
  "block.minecraft.red_sandstone": "หินทรายแดง",
  "block.minecraft.red_sandstone_slab": "แผ่นหินทรายแดง",
  "block.minecraft.red_sandstone_stairs": "บันไดหินทรายแดง",
  "block.minecraft.red_sandstone_wall": "กำแพงหินทรายแดง",
  "block.minecraft.red_shulker_box": "กล่องชัลเกอร์สีแดง",
  "block.minecraft.red_stained_glass": "กระจกสีแดง",
  "block.minecraft.red_stained_glass_pane": "แผ่นกระจกสีแดง",
  "block.minecraft.red_terracotta": "ดินเผาสีแดง",
  "block.minecraft.red_tulip": "ดอกทิวลิปแดง",
  "block.minecraft.red_wool": "ขนแกะสีแดง",
  "block.minecraft.redstone_block": "บล็อกเรดสโตน",
  "block.minecraft.redstone_lamp": "หลอดไฟเรดสโตน",
  "block.minecraft.redstone_ore": "แร่เรดสโตน",
  "block.minecraft.redstone_torch": "คบเพลิงเรดสโตน",
  "block.minecraft.redstone_wall_torch": "คบเพลิงเรดสโตนติดผนัง",
  "block.minecraft.redstone_wire": "สายไฟเรดสโตน",
  "block.minecraft.reinforced_deepslate": "หินชนวนลึกเสริมแรง",
  "block.minecraft.repeater": "ตัวทวนสัญญาณเรดสโตน",
  "block.minecraft.repeating_command_block": "บล็อกคำสั่งแบบทำซ้ำ",
  "block.minecraft.resin_block": "บล็อกยางไม้",
  "block.minecraft.resin_brick_slab": "แผ่นอิฐยางไม้",
  "block.minecraft.resin_brick_stairs": "บันไดอิฐยางไม้",
  "block.minecraft.resin_brick_wall": "กำแพงอิฐยางไม้",
  "block.minecraft.resin_bricks": "บล็อกอิฐยางไม้",
  "block.minecraft.resin_clump": "ก้อนยางไม้",
  "block.minecraft.respawn_anchor": "หลักจุดเกิด",
  "block.minecraft.rooted_dirt": "ดินฝังราก",
  "block.minecraft.rose_bush": "พุ่มกุหลาบ",
  "block.minecraft.sand": "ทราย",
  "block.minecraft.sandstone": "หินทราย",
  "block.minecraft.sandstone_slab": "แผ่นหินทราย",
  "block.minecraft.sandstone_stairs": "บันไดหินทราย",
  "block.minecraft.sandstone_wall": "กำแพงหินทราย",
  "block.minecraft.scaffolding": "นั่งร้าน",
  "block.minecraft.sculk": "สกัลก์",
  "block.minecraft.sculk_catalyst": "ตัวเร่งสกัลก์",
  "block.minecraft.sculk_sensor": "ตัวรับรู้สกัลก์",
  "block.minecraft.sculk_shrieker": "ตัวหวีดร้องสกัลก์",
  "block.minecraft.sculk_vein": "เส้นใยสกัลก์",
  "block.minecraft.sea_lantern": "โคมไฟทะเล",
  "block.minecraft.sea_pickle": "แตงกวาดองทะเล",
  "block.minecraft.seagrass": "หญ้าทะเล",
  "block.minecraft.set_spawn": "ตั้งจุดเกิดใหม่แล้ว",
  "block.minecraft.short_dry_grass": "หญ้าแห้งสั้น",
  "block.minecraft.short_grass": "หญ้าสั้น",
  "block.minecraft.shroomlight": "เห็ดเรืองแสง",
  "block.minecraft.shulker_box": "กล่องชัลเกอร์",
  "block.minecraft.skeleton_skull": "กะโหลกโครงกระดูก",
  "block.minecraft.skeleton_wall_skull": "กะโหลกโครงกระดูกติดผนัง",
  "block.minecraft.slime_block": "บล็อกสไลม์",
  "block.minecraft.small_amethyst_bud": "หน่อแอเมทิสต์ขนาดเล็ก",
  "block.minecraft.small_dripleaf": "ใบหยาดเล็ก",
  "block.minecraft.smithing_table": "โต๊ะทำอาวุธ",
  "block.minecraft.smoker": "เตารมควัน",
  "block.minecraft.smooth_basalt": "หินบะซอลต์เรียบ",
  "block.minecraft.smooth_quartz": "บล็อกควอตซ์เรียบ",
  "block.minecraft.smooth_quartz_slab": "แผ่นควอตซ์เรียบ",
  "block.minecraft.smooth_quartz_stairs": "บันไดควอตซ์เรียบ",
  "block.minecraft.smooth_red_sandstone": "หินทรายแดงเรียบ",
  "block.minecraft.smooth_red_sandstone_slab": "แผ่นหินทรายแดงเรียบ",
  "block.minecraft.smooth_red_sandstone_stairs": "บันไดหินทรายแดงเรียบ",
  "block.minecraft.smooth_sandstone": "หินทรายเรียบ",
  "block.minecraft.smooth_sandstone_slab": "แผ่นหินทรายเรียบ",
  "block.minecraft.smooth_sandstone_stairs": "บันไดหินทรายเรียบ",
  "block.minecraft.smooth_stone": "หินเรียบ",
  "block.minecraft.smooth_stone_slab": "แผ่นหินเรียบ",
  "block.minecraft.sniffer_egg": "ไข่สนิฟเฟอร์",
  "block.minecraft.snow": "หิมะ",
  "block.minecraft.snow_block": "บล็อกหิมะ",
  "block.minecraft.soul_campfire": "แคมป์ไฟวิญญาณ",
  "block.minecraft.soul_fire": "ไฟวิญญาณ",
  "block.minecraft.soul_lantern": "โคมไฟวิญญาณ",
  "block.minecraft.soul_sand": "ทรายวิญญาณ",
  "block.minecraft.soul_soil": "ดินวิญญาณ",
  "block.minecraft.soul_torch": "คบเพลิงวิญญาณ",
  "block.minecraft.soul_wall_torch": "คบเพลิงวิญญาณติดผนัง",
  "block.minecraft.spawn.not_valid": "ไม่พบเตียงหรือหลักจุดเกิดของคุณ อาจถูกทำลายหรือกีดขวาง",
  "block.minecraft.spawner": "กรงกำเนิดมอนสเตอร์",
  "block.minecraft.spawner.desc1": "ปฏิสัมพันธ์กับไข่เกิด:",
  "block.minecraft.spawner.desc2": "เลือกประเภทม็อบ",
  "block.minecraft.sponge": "ฟองน้ำ",
  "block.minecraft.spore_blossom": "ดอกสปอร์",
  "block.minecraft.spruce_button": "ปุ่มไม้สนสปรูซ",
  "block.minecraft.spruce_door": "ประตูไม้สนสปรูซ",
  "block.minecraft.spruce_fence": "รั้วไม้สนสปรูซ",
  "block.minecraft.spruce_fence_gate": "ประตูรั้วไม้สนสปรูซ",
  "block.minecraft.spruce_hanging_sign": "ป้ายแขวนไม้สนสปรูซ",
  "block.minecraft.spruce_leaves": "ใบไม้สนสปรูซ",
  "block.minecraft.spruce_log": "ท่อนไม้สนสปรูซ",
  "block.minecraft.spruce_planks": "ไม้กระดานสนสปรูซ",
  "block.minecraft.spruce_pressure_plate": "แป้นเหยียบไม้สนสปรูซ",
  "block.minecraft.spruce_sapling": "ต้นอ่อนไม้สนสปรูซ",
  "block.minecraft.spruce_shelf": "ชั้นวางไม้สนสปรูซ",
  "block.minecraft.spruce_sign": "ป้ายไม้สนสปรูซ",
  "block.minecraft.spruce_slab": "แผ่นไม้สนสปรูซ",
  "block.minecraft.spruce_stairs": "บันไดไม้สนสปรูซ",
  "block.minecraft.spruce_trapdoor": "ประตูกับดักไม้สนสปรูซ",
  "block.minecraft.spruce_wall_hanging_sign": "ป้ายแขวนไม้สนสปรูซติดผนัง",
  "block.minecraft.spruce_wall_sign": "ป้ายไม้สนสปรูซติดผนัง",
  "block.minecraft.spruce_wood": "ไม้สนสปรูซ",
  "block.minecraft.sticky_piston": "ลูกสูบเหนียว",
  "block.minecraft.stone": "หิน",
  "block.minecraft.stone_brick_slab": "แผ่นอิฐหิน",
  "block.minecraft.stone_brick_stairs": "บันไดอิฐหิน",
  "block.minecraft.stone_brick_wall": "กำแพงอิฐหิน",
  "block.minecraft.stone_bricks": "บล็อกอิฐหิน",
  "block.minecraft.stone_button": "ปุ่มหิน",
  "block.minecraft.stone_pressure_plate": "แป้นเหยียบหิน",
  "block.minecraft.stone_slab": "แผ่นหิน",
  "block.minecraft.stone_stairs": "บันไดหิน",
  "block.minecraft.stonecutter": "เครื่องตัดหิน",
  "block.minecraft.stripped_acacia_log": "ท่อนไม้อะเคเซียลอกเปลือก",
  "block.minecraft.stripped_acacia_wood": "ไม้อะเคเซียลอกเปลือก",
  "block.minecraft.stripped_bamboo_block": "บล็อกไม้ไผ่ลอกเปลือก",
  "block.minecraft.stripped_birch_log": "ท่อนไม้เบิร์ชลอกเปลือก",
  "block.minecraft.stripped_birch_wood": "ไม้เบิร์ชลอกเปลือก",
  "block.minecraft.stripped_cherry_log": "ท่อนไม้ซากุระลอกเปลือก",
  "block.minecraft.stripped_cherry_wood": "ไม้ซากุระลอกเปลือก",
  "block.minecraft.stripped_crimson_hyphae": "เส้นใยเห็ดราสีเลือดลอกเปลือก",
  "block.minecraft.stripped_crimson_stem": "ลำต้นสีเลือดลอกเปลือก",
  "block.minecraft.stripped_dark_oak_log": "ท่อนไม้โอ๊กดำลอกเปลือก",
  "block.minecraft.stripped_dark_oak_wood": "ไม้โอ๊กดำลอกเปลือก",
  "block.minecraft.stripped_jungle_log": "ท่อนไม้ป่าดงดิบลอกเปลือก",
  "block.minecraft.stripped_jungle_wood": "ไม้ป่าดงดิบลอกเปลือก",
  "block.minecraft.stripped_mangrove_log": "ท่อนไม้โกงกางลอกเปลือก",
  "block.minecraft.stripped_mangrove_wood": "ไม้โกงกางลอกเปลือก",
  "block.minecraft.stripped_oak_log": "ท่อนไม้โอ๊กลอกเปลือก",
  "block.minecraft.stripped_oak_wood": "ไม้โอ๊กลอกเปลือก",
  "block.minecraft.stripped_pale_oak_log": "ท่อนไม้โอ๊กซีดลอกเปลือก",
  "block.minecraft.stripped_pale_oak_wood": "ไม้โอ๊กซีดลอกเปลือก",
  "block.minecraft.stripped_spruce_log": "ท่อนไม้สนสปรูซลอกเปลือก",
  "block.minecraft.stripped_spruce_wood": "ไม้สนสปรูซลอกเปลือก",
  "block.minecraft.stripped_warped_hyphae": "เส้นใยเห็ดราป่าวิปริตลอกเปลือก",
  "block.minecraft.stripped_warped_stem": "ลำต้นป่าวิปริตลอกเปลือก",
  "block.minecraft.structure_block": "บล็อกโครงสร้าง",
  "block.minecraft.structure_void": "บล็อกโครงเปล่า",
  "block.minecraft.sugar_cane": "อ้อย",
  "block.minecraft.sunflower": "ดอกทานตะวัน",
  "block.minecraft.suspicious_gravel": "กรวดพิศวง",
  "block.minecraft.suspicious_sand": "ทรายพิศวง",
  "block.minecraft.sweet_berry_bush": "พุ่มเบอร์รี่หวาน",
  "block.minecraft.tall_dry_grass": "หญ้าแห้งสูง",
  "block.minecraft.tall_grass": "หญ้าสูง",
  "block.minecraft.tall_seagrass": "หญ้าทะเลสูง",
  "block.minecraft.target": "เป้ายิง",
  "block.minecraft.terracotta": "ดินเผา",
  "block.minecraft.test_block": "บล็อกทดสอบ",
  "block.minecraft.test_instance_block": "บล็อกกรณีตัวอย่างทดสอบ",
  "block.minecraft.tinted_glass": "กระจกทึบแสง",
  "block.minecraft.tnt": "ระเบิดทีเอ็นที",
  "block.minecraft.tnt.disabled": "การระเบิดของระเบิดทีเอ็นทีถูกปิดใช้งาน",
  "block.minecraft.torch": "คบเพลิง",
  "block.minecraft.torchflower": "ดอกคบเพลิง",
  "block.minecraft.torchflower_crop": "พืชผลดอกคบเพลิง",
  "block.minecraft.trapped_chest": "หีบกับดัก",
  "block.minecraft.trial_spawner": "กรงกำเนิดบททดสอบ",
  "block.minecraft.tripwire": "เชือกกับดัก",
  "block.minecraft.tripwire_hook": "ตะขอกับดักเชือก",
  "block.minecraft.tube_coral": "ปะการังหลอด",
  "block.minecraft.tube_coral_block": "บล็อกปะการังหลอด",
  "block.minecraft.tube_coral_fan": "ปะการังหลอดรูปพัด",
  "block.minecraft.tube_coral_wall_fan": "ปะการังหลอดรูปพัดติดผนัง",
  "block.minecraft.tuff": "หินภูเขาไฟ",
  "block.minecraft.tuff_brick_slab": "แผ่นอิฐหินภูเขาไฟ",
  "block.minecraft.tuff_brick_stairs": "บันไดอิฐหินภูเขาไฟ",
  "block.minecraft.tuff_brick_wall": "กำแพงอิฐหินภูเขาไฟ",
  "block.minecraft.tuff_bricks": "บล็อกอิฐหินภูเขาไฟ",
  "block.minecraft.tuff_slab": "แผ่นหินภูเขาไฟ",
  "block.minecraft.tuff_stairs": "บันไดหินภูเขาไฟ",
  "block.minecraft.tuff_wall": "กำแพงหินภูเขาไฟ",
  "block.minecraft.turtle_egg": "ไข่เต่า",
  "block.minecraft.twisting_vines": "เถาวัลย์บิดเกลียว",
  "block.minecraft.twisting_vines_plant": "ต้นเถาวัลย์บิดเกลียว",
  "block.minecraft.vault": "กรงนิรภัย",
  "block.minecraft.verdant_froglight": "ไฟกบสีเขียวขจี",
  "block.minecraft.vine": "เถาวัลย์",
  "block.minecraft.void_air": "อากาศเปล่า",
  "block.minecraft.wall_torch": "คบเพลิงติดผนัง",
  "block.minecraft.warped_button": "ปุ่มไม้ป่าวิปริต",
  "block.minecraft.warped_door": "ประตูไม้ป่าวิปริต",
  "block.minecraft.warped_fence": "รั้วไม้ป่าวิปริต",
  "block.minecraft.warped_fence_gate": "ประตูรั้วไม้ป่าวิปริต",
  "block.minecraft.warped_fungus": "เห็ดราป่าวิปริต",
  "block.minecraft.warped_hanging_sign": "ป้ายแขวนไม้ป่าวิปริต",
  "block.minecraft.warped_hyphae": "เส้นใยเห็ดราป่าวิปริต",
  "block.minecraft.warped_nylium": "กลุ่มใยราเนเธอร์ป่าวิปริต",
  "block.minecraft.warped_planks": "ไม้กระดานป่าวิปริต",
  "block.minecraft.warped_pressure_plate": "แป้นเหยียบไม้ป่าวิปริต",
  "block.minecraft.warped_roots": "รากไม้ป่าวิปริต",
  "block.minecraft.warped_shelf": "ชั้นวางไม้ป่าวิปริต",
  "block.minecraft.warped_sign": "ป้ายไม้ป่าวิปริต",
  "block.minecraft.warped_slab": "แผ่นไม้ป่าวิปริต",
  "block.minecraft.warped_stairs": "บันไดไม้ป่าวิปริต",
  "block.minecraft.warped_stem": "ลำต้นป่าวิปริต",
  "block.minecraft.warped_trapdoor": "ประตูกับดักไม้ป่าวิปริต",
  "block.minecraft.warped_wall_hanging_sign": "ป้ายแขวนไม้ป่าวิปริตติดผนัง",
  "block.minecraft.warped_wall_sign": "ป้ายไม้ป่าวิปริตติดผนัง",
  "block.minecraft.warped_wart_block": "บล็อกหูดป่าวิปริต",
  "block.minecraft.water": "น้ำ",
  "block.minecraft.water_cauldron": "หม้อปรุงยาบรรจุน้ำ",
  "block.minecraft.waxed_chiseled_copper": "ทองแดงสลักเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_bars": "ลูกกรงทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_block": "บล็อกทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_bulb": "หลอดไฟทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_chain": "โซ่ทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_chest": "หีบทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_door": "ประตูทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_golem_statue": "รูปปั้นโกเลมทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_grate": "ตะแกรงทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_lantern": "โคมไฟทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_copper_trapdoor": "ประตูกับดักทองแดงเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_cut_copper": "ทองแดงตัดเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_cut_copper_slab": "แผ่นทองแดงตัดเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_cut_copper_stairs": "บันไดทองแดงตัดเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_chiseled_copper": "ทองแดงสลักลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper": "ทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_bars": "ลูกกรงทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_bulb": "หลอดไฟทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_chain": "โซ่ทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_chest": "หีบทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_door": "ประตูทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_golem_statue": "รูปปั้นโกเลมทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_grate": "ตะแกรงทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_lantern": "โคมไฟทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_copper_trapdoor": "ประตูกับดับทองแดงลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_cut_copper": "ทองแดงตัดลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_cut_copper_slab": "แผ่นทองแดงตัดลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "บันไดทองแดงตัดลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_exposed_lightning_rod": "สายล่อฟ้าลอกเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_lightning_rod": "สายล่อฟ้าเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_chiseled_copper": "ทองแดงสลักขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper": "ทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_bars": "ลูกกรงทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_bulb": "หลอดไฟทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_chain": "โซ่ทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_chest": "หีบทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_door": "ประตูทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "รูปปั้นโกเลมทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_grate": "ตะแกรงทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_lantern": "โคมไฟทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "ประตูกับดักทองแดงขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_cut_copper": "ทองแดงตัดขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "แผ่นทองแดงตัดขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "บันไดทองแดงตัดขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_oxidized_lightning_rod": "สายล่อฟ้าขึ้นสนิมเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_chiseled_copper": "ทองแดงสลักผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper": "ทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_bars": "ลูกกรงทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_bulb": "หลอดไฟทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_chain": "โซ่ทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_chest": "หีบทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_door": "ประตูทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_golem_statue": "รูปปั้นโกเลมทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_grate": "ตะแกรงทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_lantern": "โคมไฟทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_copper_trapdoor": "ประตูกับดักทองแดงผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_cut_copper": "ทองแดงตัดผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_cut_copper_slab": "แผ่นทองแดงตัดผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "บันไดทองแดงตัดผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.waxed_weathered_lightning_rod": "สายล่อฟ้าผุกร่อนเคลือบขี้ผึ้ง",
  "block.minecraft.weathered_chiseled_copper": "ทองแดงสลักผุกร่อน",
  "block.minecraft.weathered_copper": "ทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_bars": "ลูกกรงทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_bulb": "หลอดไฟทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_chain": "โซ่ทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_chest": "หีบทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_door": "ประตูทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_golem_statue": "รูปปั้นโกเลมทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_grate": "ตะแกรงทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_lantern": "โคมไฟทองแดงผุกร่อน",
  "block.minecraft.weathered_copper_trapdoor": "ประตูกับดักทองแดงผุกร่อน",
  "block.minecraft.weathered_cut_copper": "ทองแดงตัดผุกร่อน",
  "block.minecraft.weathered_cut_copper_slab": "แผ่นทองแดงตัดผุกร่อน",
  "block.minecraft.weathered_cut_copper_stairs": "บันไดทองแดงตัดผุกร่อน",
  "block.minecraft.weathered_lightning_rod": "สายล่อฟ้าผุกร่อน",
  "block.minecraft.weeping_vines": "เถาวัลย์โศก",
  "block.minecraft.weeping_vines_plant": "ต้นเถาวัลย์โศก",
  "block.minecraft.wet_sponge": "ฟองน้ำเปียก",
  "block.minecraft.wheat": "พืชข้าวสาลี",
  "block.minecraft.white_banner": "ธงสีขาว",
  "block.minecraft.white_bed": "เตียงสีขาว",
  "block.minecraft.white_candle": "เทียนสีขาว",
  "block.minecraft.white_candle_cake": "เค้กพร้อมเทียนสีขาว",
  "block.minecraft.white_carpet": "พรมสีขาว",
  "block.minecraft.white_concrete": "คอนกรีตสีขาว",
  "block.minecraft.white_concrete_powder": "ผงคอนกรีตสีขาว",
  "block.minecraft.white_glazed_terracotta": "ดินเผาเคลือบสีขาว",
  "block.minecraft.white_shulker_box": "กล่องชัลเกอร์สีขาว",
  "block.minecraft.white_stained_glass": "กระจกสีขาว",
  "block.minecraft.white_stained_glass_pane": "แผ่นกระจกสีขาว",
  "block.minecraft.white_terracotta": "ดินเผาสีขาว",
  "block.minecraft.white_tulip": "ดอกทิวลิปขาว",
  "block.minecraft.white_wool": "ขนแกะสีขาว",
  "block.minecraft.wildflowers": "ดอกไม้ป่า",
  "block.minecraft.wither_rose": "กุหลาบวิทเธอร์",
  "block.minecraft.wither_skeleton_skull": "กะโหลกโครงกระดูกวิทเธอร์",
  "block.minecraft.wither_skeleton_wall_skull": "กะโหลกวิทเธอร์ติดผนัง",
  "block.minecraft.yellow_banner": "ธงสีเหลือง",
  "block.minecraft.yellow_bed": "เตียงสีเหลือง",
  "block.minecraft.yellow_candle": "เทียนสีเหลือง",
  "block.minecraft.yellow_candle_cake": "เค้กพร้อมเทียนสีเหลือง",
  "block.minecraft.yellow_carpet": "พรมสีเหลือง",
  "block.minecraft.yellow_concrete": "คอนกรีตสีเหลือง",
  "block.minecraft.yellow_concrete_powder": "ผงคอนกรีตสีเหลือง",
  "block.minecraft.yellow_glazed_terracotta": "ดินเผาเคลือบสีเหลือง",
  "block.minecraft.yellow_shulker_box": "กล่องชัลเกอร์สีเหลือง",
  "block.minecraft.yellow_stained_glass": "กระจกสีเหลือง",
  "block.minecraft.yellow_stained_glass_pane": "แผ่นกระจกสีเหลือง",
  "block.minecraft.yellow_terracotta": "ดินเผาสีเหลือง",
  "block.minecraft.yellow_wool": "ขนแกะสีเหลือง",
  "block.minecraft.zombie_head": "หัวซอมบี้",
  "block.minecraft.zombie_wall_head": "หัวซอมบี้ติดผนัง",
  "item.minecraft.acacia_boat": "เรือไม้อะเคเซีย",
  "item.minecraft.acacia_chest_boat": "เรือไม้อะเคเซียพร้อมหีบ",
  "item.minecraft.allay_spawn_egg": "ไข่เกิดอัลเลย์",
  "item.minecraft.amethyst_shard": "เศษแอเมทิสต์",
  "item.minecraft.angler_pottery_shard": "เศษเครื่องปั้นดินเผาลายปลาติดเบ็ด",
  "item.minecraft.angler_pottery_sherd": "เศษเครื่องปั้นดินเผาลายปลาติดเบ็ด",
  "item.minecraft.apple": "แอปเปิ้ล",
  "item.minecraft.archer_pottery_shard": "เศษเครื่องปั้นดินเผาลายธนู",
  "item.minecraft.archer_pottery_sherd": "เศษเครื่องปั้นดินเผาลายธนู",
  "item.minecraft.armadillo_scute": "เกล็ดอาร์มาดิลโล",
  "item.minecraft.armadillo_spawn_egg": "ไข่เกิดอาร์มาดิลโล",
  "item.minecraft.armor_stand": "แท่นวางชุดเกราะ",
  "item.minecraft.arms_up_pottery_shard": "เศษเครื่องปั้นดินเผาลายคนยกแขน",
  "item.minecraft.arms_up_pottery_sherd": "เศษเครื่องปั้นดินเผาลายคนยกแขน",
  "item.minecraft.arrow": "ลูกธนู",
  "item.minecraft.axolotl_bucket": "ถังแอกโซลอเติล",
  "item.minecraft.axolotl_spawn_egg": "ไข่เกิดแอกโซลอเติล",
  "item.minecraft.baked_potato": "มันฝรั่งอบ",
  "item.minecraft.bamboo_chest_raft": "แพไม้ไผ่พร้อมหีบ",
  "item.minecraft.bamboo_raft": "แพไม้ไผ่",
  "item.minecraft.bat_spawn_egg": "ไข่เกิดค้างคาว",
  "item.minecraft.bee_spawn_egg": "ไข่เกิดผึ้ง",
  "item.minecraft.beef": "เนื้อวัวดิบ",
  "item.minecraft.beetroot": "บีตรูต",
  "item.minecraft.beetroot_seeds": "เมล็ดบีตรูต",
  "item.minecraft.beetroot_soup": "ซุปบีตรูต",
  "item.minecraft.birch_boat": "เรือไม้เบิร์ช",
  "item.minecraft.birch_chest_boat": "เรือไม้เบิร์ชพร้อมหีบ",
  "item.minecraft.black_bundle": "ถุงหนังสีดำ",
  "item.minecraft.black_dye": "สีย้อมสีดำ",
  "item.minecraft.black_harness": "บังเหียนสีดำ",
  "item.minecraft.blade_pottery_shard": "เศษเครื่องปั้นดินเผาลายดาบ",
  "item.minecraft.blade_pottery_sherd": "เศษเครื่องปั้นดินเผาลายดาบ",
  "item.minecraft.blaze_powder": "ผงเบลซ",
  "item.minecraft.blaze_rod": "แท่งเบลช",
  "item.minecraft.blaze_spawn_egg": "ไข่เกิดเบลซ",
  "item.minecraft.blue_bundle": "ถุงหนังสีน้ำเงิน",
  "item.minecraft.blue_dye": "สีย้อมสีน้ำเงิน",
  "item.minecraft.blue_egg": "ไข่สีน้ำเงิน",
  "item.minecraft.blue_harness": "บังเหียนสีน้ำเงิน",
  "item.minecraft.bogged_spawn_egg": "ไข่เกิดโครงกระดูกพรุ",
  "item.minecraft.bolt_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "ลายแต่งเกราะสลักเกลียว",
  "item.minecraft.bone": "กระดูก",
  "item.minecraft.bone_meal": "ผงกระดูก",
  "item.minecraft.book": "หนังสือ",
  "item.minecraft.bordure_indented_banner_pattern": "แบบลายธงขอบหยิก",
  "item.minecraft.bow": "คันธนู",
  "item.minecraft.bowl": "ชาม",
  "item.minecraft.bread": "ขนมปัง",
  "item.minecraft.breeze_rod": "แท่งบรีซ",
  "item.minecraft.breeze_spawn_egg": "ไข่เกิดบรีซ",
  "item.minecraft.brewer_pottery_shard": "เศษเครื่องปั้นดินเผาลายหม้อปรุงยา",
  "item.minecraft.brewer_pottery_sherd": "เศษเครื่องปั้นดินเผาลายหม้อปรุงยา",
  "item.minecraft.brewing_stand": "แท่นปรุงยา",
  "item.minecraft.brick": "อิฐ",
  "item.minecraft.brown_bundle": "ถุงหนังสีน้ำตาล",
  "item.minecraft.brown_dye": "สีย้อมสีน้ำตาล",
  "item.minecraft.brown_egg": "ไข่สีน้ำตาล",
  "item.minecraft.brown_harness": "บังเหียนสีน้ำตาล",
  "item.minecraft.brush": "แปรง",
  "item.minecraft.bucket": "ถัง",
  "item.minecraft.bundle": "ถุงหนัง",
  "item.minecraft.bundle.empty": "ว่างเปล่า",
  "item.minecraft.bundle.empty.description": "สามารถใส่ไอเทมผสมรวมกันได้ 1 กอง",
  "item.minecraft.bundle.full": "เต็ม",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "เศษเครื่องปั้นดินเผาลายไฟ",
  "item.minecraft.burn_pottery_sherd": "เศษเครื่องปั้นดินเผาลายไฟ",
  "item.minecraft.camel_husk_spawn_egg": "ไข่เกิดอูฐซอมบี้ทะเลทราย",
  "item.minecraft.camel_spawn_egg": "ไข่เกิดอูฐ",
  "item.minecraft.carrot": "แคร์รอต",
  "item.minecraft.carrot_on_a_stick": "แคร์รอตติดเบ็ด",
  "item.minecraft.cat_spawn_egg": "ไข่เกิดแมว",
  "item.minecraft.cauldron": "หม้อปรุงยา",
  "item.minecraft.cave_spider_spawn_egg": "ไข่เกิดแมงมุมถ้ำ",
  "item.minecraft.chainmail_boots": "รองเท้าโซ่",
  "item.minecraft.chainmail_chestplate": "เสื้อเกราะโซ่",
  "item.minecraft.chainmail_helmet": "หมวกโซ่",
  "item.minecraft.chainmail_leggings": "กางเกงโซ่",
  "item.minecraft.charcoal": "ถ่านไม้",
  "item.minecraft.cherry_boat": "เรือไม้ซากุระ",
  "item.minecraft.cherry_chest_boat": "เรือไม้ซากุระพร้อมหีบ",
  "item.minecraft.chest_minecart": "รถรางพร้อมหีบ",
  "item.minecraft.chicken": "เนื้อไก่ดิบ",
  "item.minecraft.chicken_spawn_egg": "ไข่เกิดไก่",
  "item.minecraft.chorus_fruit": "ผลคอรัส",
  "item.minecraft.clay_ball": "ก้อนดินเหนียว",
  "item.minecraft.clock": "นาฬิกา",
  "item.minecraft.coal": "ถ่านหิน",
  "item.minecraft.coast_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.coast_armor_trim_smithing_template.new": "ลายแต่งเกราะชายฝั่ง",
  "item.minecraft.cocoa_beans": "เมล็ดโกโก้",
  "item.minecraft.cod": "ปลาค็อดดิบ",
  "item.minecraft.cod_bucket": "ถังปลาค็อด",
  "item.minecraft.cod_spawn_egg": "ไข่เกิดปลาค็อด",
  "item.minecraft.command_block_minecart": "รถรางพร้อมบล็อกคำสั่ง",
  "item.minecraft.compass": "เข็มทิศ",
  "item.minecraft.cooked_beef": "สเต๊ก",
  "item.minecraft.cooked_chicken": "เนื้อไก่ปรุงสุก",
  "item.minecraft.cooked_cod": "ปลาค็อดปรุงสุก",
  "item.minecraft.cooked_mutton": "เนื้อแกะปรุงสุก",
  "item.minecraft.cooked_porkchop": "เนื้อหมูปรุงสุก",
  "item.minecraft.cooked_rabbit": "เนื้อกระต่ายปรุงสุก",
  "item.minecraft.cooked_salmon": "ปลาแซลมอนปรุงสุก",
  "item.minecraft.cookie": "คุกกี้",
  "item.minecraft.copper_axe": "ขวานทองแดง",
  "item.minecraft.copper_boots": "รองเท้าทองแดง",
  "item.minecraft.copper_chestplate": "เสื้อเกราะทองแดง",
  "item.minecraft.copper_golem_spawn_egg": "ไข่เกิดโกเลมทองแดง",
  "item.minecraft.copper_helmet": "หมวกทองแดง",
  "item.minecraft.copper_hoe": "จอบทองแดง",
  "item.minecraft.copper_horse_armor": "เกราะม้าทองแดง",
  "item.minecraft.copper_ingot": "แท่งทองแดง",
  "item.minecraft.copper_leggings": "กางเกงทองแดง",
  "item.minecraft.copper_nautilus_armor": "เกราะหอยงวงช้างทองแดง",
  "item.minecraft.copper_nugget": "เศษทองแดง",
  "item.minecraft.copper_pickaxe": "อีเต้อทองแดง",
  "item.minecraft.copper_shovel": "พลั่วทองแดง",
  "item.minecraft.copper_spear": "หอกทองแดง",
  "item.minecraft.copper_sword": "ดาบทองแดง",
  "item.minecraft.cow_spawn_egg": "ไข่เกิดวัว",
  "item.minecraft.creaking_spawn_egg": "ไข่เกิดครีกกิ้ง",
  "item.minecraft.creeper_banner_pattern": "แบบลายธง",
  "item.minecraft.creeper_banner_pattern.desc": "ตราสัญลักษณ์ครีปเปอร์",
  "item.minecraft.creeper_banner_pattern.new": "แบบลายธงตราสัญลักษณ์ครีปเปอร์",
  "item.minecraft.creeper_spawn_egg": "ไข่เกิดครีปเปอร์",
  "item.minecraft.crossbow": "หน้าไม้",
  "item.minecraft.crossbow.projectile": "วัตถุพุ่ง:",
  "item.minecraft.crossbow.projectile.multiple": "วัตถุพุ่ง: %s x %s",
  "item.minecraft.crossbow.projectile.single": "วัตถุพุ่ง: %s",
  "item.minecraft.cyan_bundle": "ถุงหนังสีฟ้าคราม",
  "item.minecraft.cyan_dye": "สีย้อมสีฟ้าคราม",
  "item.minecraft.cyan_harness": "บังเหียนสีฟ้าคราม",
  "item.minecraft.danger_pottery_shard": "เศษเครื่องปั้นดินเผาลายครีปเปอร์",
  "item.minecraft.danger_pottery_sherd": "เศษเครื่องปั้นดินเผาลายครีปเปอร์",
  "item.minecraft.dark_oak_boat": "เรือไม้โอ๊กดำ",
  "item.minecraft.dark_oak_chest_boat": "เรือไม้โอ๊กดำพร้อมหีบ",
  "item.minecraft.debug_stick": "แท่งไม้ดีบั๊ก",
  "item.minecraft.debug_stick.empty": "%s ไม่มีคุณสมบัติ",
  "item.minecraft.debug_stick.select": "เลือก \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ไปยัง %s",
  "item.minecraft.diamond": "เพชร",
  "item.minecraft.diamond_axe": "ขวานเพชร",
  "item.minecraft.diamond_boots": "รองเท้าเพชร",
  "item.minecraft.diamond_chestplate": "เสื้อเกราะเพชร",
  "item.minecraft.diamond_helmet": "หมวกเพชร",
  "item.minecraft.diamond_hoe": "จอบเพชร",
  "item.minecraft.diamond_horse_armor": "เกราะม้าเพชร",
  "item.minecraft.diamond_leggings": "กางเกงเพชร",
  "item.minecraft.diamond_nautilus_armor": "เกราะหอยงวงช้างเพชร",
  "item.minecraft.diamond_pickaxe": "อีเต้อเพชร",
  "item.minecraft.diamond_shovel": "พลั่วเพชร",
  "item.minecraft.diamond_spear": "หอกเพชร",
  "item.minecraft.diamond_sword": "ดาบเพชร",
  "item.minecraft.disc_fragment_5": "ชิ้นส่วนแผ่นเสียง",
  "item.minecraft.disc_fragment_5.desc": "แผ่นเสียง - 5",
  "item.minecraft.dolphin_spawn_egg": "ไข่เกิดโลมา",
  "item.minecraft.donkey_spawn_egg": "ไข่เกิดลา",
  "item.minecraft.dragon_breath": "ลมหายใจมังกร",
  "item.minecraft.dried_kelp": "สาหร่ายทะเลแห้ง",
  "item.minecraft.drowned_spawn_egg": "ไข่เกิดซอมบี้ใต้น้ำ",
  "item.minecraft.dune_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.dune_armor_trim_smithing_template.new": "ลายแต่งเกราะเนินทราย",
  "item.minecraft.echo_shard": "เศษเอ็กโค",
  "item.minecraft.egg": "ไข่",
  "item.minecraft.elder_guardian_spawn_egg": "ไข่เกิดพญาการ์เดี้ยน",
  "item.minecraft.elytra": "ปีก",
  "item.minecraft.emerald": "มรกต",
  "item.minecraft.enchanted_book": "หนังสือร่ายมนตร์",
  "item.minecraft.enchanted_golden_apple": "แอปเปิ้ลทองร่ายมนตร์",
  "item.minecraft.end_crystal": "ผลึกเอนด์",
  "item.minecraft.ender_dragon_spawn_egg": "ไข่เกิดมังกรเอนเดอร์",
  "item.minecraft.ender_eye": "ดวงตาแห่งเอนเดอร์",
  "item.minecraft.ender_pearl": "ไข่มุกเอนเดอร์",
  "item.minecraft.enderman_spawn_egg": "ไข่เกิดเอนเดอร์แมน",
  "item.minecraft.endermite_spawn_egg": "ไข่เกิดเอนเดอร์ไมต์",
  "item.minecraft.evoker_spawn_egg": "ไข่เกิดอีโวกเกอร์",
  "item.minecraft.experience_bottle": "ขวดแห่งเวทมนตร์",
  "item.minecraft.explorer_pottery_shard": "เศษเครื่องปั้นดินเผาลายนักสำรวจ",
  "item.minecraft.explorer_pottery_sherd": "เศษเครื่องปั้นดินเผาลายนักสำรวจ",
  "item.minecraft.eye_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.eye_armor_trim_smithing_template.new": "ลายแต่งเกราะดวงตา",
  "item.minecraft.feather": "ขนนก",
  "item.minecraft.fermented_spider_eye": "ตาแมงมุมดอง",
  "item.minecraft.field_masoned_banner_pattern": "แบบลายธงลายอิฐ",
  "item.minecraft.filled_map": "แผนที่",
  "item.minecraft.fire_charge": "ลูกไฟ",
  "item.minecraft.firework_rocket": "จรวดพลุ",
  "item.minecraft.firework_rocket.flight": "ระยะเวลาบิน:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "ดาวดอกไม้ไฟ",
  "item.minecraft.firework_star.black": "สีดำ",
  "item.minecraft.firework_star.blue": "สีน้ำเงิน",
  "item.minecraft.firework_star.brown": "สีน้ำตาล",
  "item.minecraft.firework_star.custom_color": "กำหนดเอง",
  "item.minecraft.firework_star.cyan": "สีฟ้าคราม",
  "item.minecraft.firework_star.fade_to": "จางลงเป็น",
  "item.minecraft.firework_star.flicker": "ระยิบระยับ",
  "item.minecraft.firework_star.gray": "สีเทา",
  "item.minecraft.firework_star.green": "สีเขียว",
  "item.minecraft.firework_star.light_blue": "สีฟ้า",
  "item.minecraft.firework_star.light_gray": "สีเทาอ่อน",
  "item.minecraft.firework_star.lime": "สีเขียวอ่อน",
  "item.minecraft.firework_star.magenta": "สีบานเย็น",
  "item.minecraft.firework_star.orange": "สีส้ม",
  "item.minecraft.firework_star.pink": "สีชมพู",
  "item.minecraft.firework_star.purple": "สีม่วง",
  "item.minecraft.firework_star.red": "สีแดง",
  "item.minecraft.firework_star.shape": "ไม่ทราบรูปร่าง",
  "item.minecraft.firework_star.shape.burst": "ระเบิด",
  "item.minecraft.firework_star.shape.creeper": "รูปครีปเปอร์",
  "item.minecraft.firework_star.shape.large_ball": "ก้อนใหญ่",
  "item.minecraft.firework_star.shape.small_ball": "ก้อนเล็ก",
  "item.minecraft.firework_star.shape.star": "รูปดาว",
  "item.minecraft.firework_star.trail": "หาง",
  "item.minecraft.firework_star.white": "สีขาว",
  "item.minecraft.firework_star.yellow": "สีเหลือง",
  "item.minecraft.fishing_rod": "คันเบ็ดตกปลา",
  "item.minecraft.flint": "หินเหล็กไฟ",
  "item.minecraft.flint_and_steel": "หินเหล็กไฟกับเหล็กกล้า",
  "item.minecraft.flow_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.flow_armor_trim_smithing_template.new": "ลายแต่งเกราะไหลวน",
  "item.minecraft.flow_banner_pattern": "แบบลายธง",
  "item.minecraft.flow_banner_pattern.desc": "ไหลวน",
  "item.minecraft.flow_banner_pattern.new": "แบบลายธงไหลวน",
  "item.minecraft.flow_pottery_sherd": "เศษเครื่องปั้นดินเผาลายไหลวน",
  "item.minecraft.flower_banner_pattern": "แบบลายธง",
  "item.minecraft.flower_banner_pattern.desc": "ตราสัญลักษณ์ดอกไม้",
  "item.minecraft.flower_banner_pattern.new": "แบบลายธงตราสัญลักษณ์ดอกไม้",
  "item.minecraft.flower_pot": "กระถางดอกไม้",
  "item.minecraft.fox_spawn_egg": "ไข่เกิดหมาจิ้งจอก",
  "item.minecraft.friend_pottery_shard": "เศษเครื่องปั้นดินเผาลายเพื่อน",
  "item.minecraft.friend_pottery_sherd": "เศษเครื่องปั้นดินเผาลายเพื่อน",
  "item.minecraft.frog_spawn_egg": "ไข่เกิดกบ",
  "item.minecraft.furnace_minecart": "รถรางพร้อมเตาเผา",
  "item.minecraft.ghast_spawn_egg": "ไข่เกิดแก๊สต์",
  "item.minecraft.ghast_tear": "น้ำตาแก๊สต์",
  "item.minecraft.glass_bottle": "ขวดแก้ว",
  "item.minecraft.glistering_melon_slice": "ชิ้นแตงโมทอง",
  "item.minecraft.globe_banner_pattern": "แบบลายธง",
  "item.minecraft.globe_banner_pattern.desc": "ลูกโลก",
  "item.minecraft.globe_banner_pattern.new": "แบบลายธงลูกโลก",
  "item.minecraft.glow_berries": "เบอร์รี่เรืองแสง",
  "item.minecraft.glow_ink_sac": "ถุงหมึกเรืองแสง",
  "item.minecraft.glow_item_frame": "กรอบไอเทมเรืองแสง",
  "item.minecraft.glow_squid_spawn_egg": "ไข่เกิดหมึกเรืองแสง",
  "item.minecraft.glowstone_dust": "ผงหินเรืองแสง",
  "item.minecraft.goat_horn": "เขาแพะ",
  "item.minecraft.goat_spawn_egg": "ไข่เกิดแพะ",
  "item.minecraft.gold_ingot": "แท่งทอง",
  "item.minecraft.gold_nugget": "เศษทอง",
  "item.minecraft.golden_apple": "แอปเปิ้ลทอง",
  "item.minecraft.golden_axe": "ขวานทอง",
  "item.minecraft.golden_boots": "รองเท้าทอง",
  "item.minecraft.golden_carrot": "แคร์รอตทอง",
  "item.minecraft.golden_chestplate": "เสื้อเกราะทอง",
  "item.minecraft.golden_helmet": "หมวกทอง",
  "item.minecraft.golden_hoe": "จอบทอง",
  "item.minecraft.golden_horse_armor": "เกราะม้าทอง",
  "item.minecraft.golden_leggings": "กางเกงทอง",
  "item.minecraft.golden_nautilus_armor": "เกราะหอยงวงช้างทอง",
  "item.minecraft.golden_pickaxe": "อีเต้อทอง",
  "item.minecraft.golden_shovel": "พลั่วทอง",
  "item.minecraft.golden_spear": "หอกทอง",
  "item.minecraft.golden_sword": "ดาบทอง",
  "item.minecraft.gray_bundle": "ถุงหนังสีเทา",
  "item.minecraft.gray_dye": "สีย้อมสีเทา",
  "item.minecraft.gray_harness": "บังเหียนสีเทา",
  "item.minecraft.green_bundle": "ถุงหนังสีเขียว",
  "item.minecraft.green_dye": "สีย้อมสีเขียว",
  "item.minecraft.green_harness": "บังเหียนสีเขียว",
  "item.minecraft.guardian_spawn_egg": "ไข่เกิดการ์เดี้ยน",
  "item.minecraft.gunpowder": "ดินปืน",
  "item.minecraft.guster_banner_pattern": "แบบลายธง",
  "item.minecraft.guster_banner_pattern.desc": "ลมกระโชก",
  "item.minecraft.guster_banner_pattern.new": "แบบลายธงลมกระโชก",
  "item.minecraft.guster_pottery_sherd": "เศษเครื่องปั้นดินเผาลายลมกระโชก",
  "item.minecraft.happy_ghast_spawn_egg": "ไข่เกิดแฮปปี้แก๊สต์",
  "item.minecraft.harness": "บังเหียน",
  "item.minecraft.heart_of_the_sea": "หัวใจแห่งท้องทะเล",
  "item.minecraft.heart_pottery_shard": "เศษเครื่องปั้นดินเผาลายหัวใจ",
  "item.minecraft.heart_pottery_sherd": "เศษเครื่องปั้นดินเผาลายหัวใจ",
  "item.minecraft.heartbreak_pottery_shard": "เศษเครื่องปั้นดินเผาลายหัวใจสลาย",
  "item.minecraft.heartbreak_pottery_sherd": "เศษเครื่องปั้นดินเผาลายหัวใจสลาย",
  "item.minecraft.hoglin_spawn_egg": "ไข่เกิดฮอกลิน",
  "item.minecraft.honey_bottle": "ขวดน้ำผึ้ง",
  "item.minecraft.honeycomb": "รวงผึ้ง",
  "item.minecraft.hopper_minecart": "รถรางพร้อมท่อส่ง",
  "item.minecraft.horse_spawn_egg": "ไข่เกิดม้า",
  "item.minecraft.host_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.host_armor_trim_smithing_template.new": "ลายแต่งเกราะเจ้าบ้าน",
  "item.minecraft.howl_pottery_shard": "เศษเครื่องปั้นดินเผาลายหมาป่า",
  "item.minecraft.howl_pottery_sherd": "เศษเครื่องปั้นดินเผาลายหมาป่า",
  "item.minecraft.husk_spawn_egg": "ไข่เกิดซอมบี้ทะเลทราย",
  "item.minecraft.ink_sac": "ถุงหมึก",
  "item.minecraft.iron_axe": "ขวานเหล็ก",
  "item.minecraft.iron_boots": "รองเท้าเหล็ก",
  "item.minecraft.iron_chestplate": "เสื้อเกราะเหล็ก",
  "item.minecraft.iron_golem_spawn_egg": "ไข่เกิดโกเลมเหล็ก",
  "item.minecraft.iron_helmet": "หมวกเหล็ก",
  "item.minecraft.iron_hoe": "จอบเหล็ก",
  "item.minecraft.iron_horse_armor": "เกราะม้าเหล็ก",
  "item.minecraft.iron_ingot": "แท่งเหล็ก",
  "item.minecraft.iron_leggings": "กางเกงเหล็ก",
  "item.minecraft.iron_nautilus_armor": "เกราะหอยงวงช้างเหล็ก",
  "item.minecraft.iron_nugget": "เศษเหล็ก",
  "item.minecraft.iron_pickaxe": "อีเต้อเหล็ก",
  "item.minecraft.iron_shovel": "พลั่วเหล็ก",
  "item.minecraft.iron_spear": "หอกเหล็ก",
  "item.minecraft.iron_sword": "ดาบเหล็ก",
  "item.minecraft.item_frame": "กรอบไอเทม",
  "item.minecraft.jungle_boat": "เรือไม้ป่าดงดิบ",
  "item.minecraft.jungle_chest_boat": "เรือไม้ป่าดงดิบพร้อมหีบ",
  "item.minecraft.knowledge_book": "หนังสือความรู้",
  "item.minecraft.lapis_lazuli": "ลาพิสลาซูลี",
  "item.minecraft.lava_bucket": "ถังลาวา",
  "item.minecraft.lead": "เชือกจูง",
  "item.minecraft.leather": "หนังสัตว์",
  "item.minecraft.leather_boots": "รองเท้าหนัง",
  "item.minecraft.leather_chestplate": "เสื้อคลุมหนัง",
  "item.minecraft.leather_helmet": "หมวกหนัง",
  "item.minecraft.leather_horse_armor": "เกราะม้าหนัง",
  "item.minecraft.leather_leggings": "กางเกงหนัง",
  "item.minecraft.light_blue_bundle": "ถุงหนังสีฟ้า",
  "item.minecraft.light_blue_dye": "สีย้อมสีฟ้า",
  "item.minecraft.light_blue_harness": "บังเหียนสีฟ้า",
  "item.minecraft.light_gray_bundle": "ถุงหนังสีเทาอ่อน",
  "item.minecraft.light_gray_dye": "สีย้อมสีเทาอ่อน",
  "item.minecraft.light_gray_harness": "บังเหียนสีเทาอ่อน",
  "item.minecraft.lime_bundle": "ถุงหนังสีเขียวอ่อน",
  "item.minecraft.lime_dye": "สีย้อมสีเขียวอ่อน",
  "item.minecraft.lime_harness": "บังเหียนสีเขียวอ่อน",
  "item.minecraft.lingering_potion": "น้ำยาแบบระเหย",
  "item.minecraft.lingering_potion.effect.awkward": "น้ำยาเจื่อนแบบระเหย",
  "item.minecraft.lingering_potion.effect.empty": "น้ำยาแบบระเหยที่ไม่สามารถปรุงได้",
  "item.minecraft.lingering_potion.effect.fire_resistance": "น้ำยากันไฟแบบระเหย",
  "item.minecraft.lingering_potion.effect.harming": "น้ำยาเสียเลือดแบบระเหย",
  "item.minecraft.lingering_potion.effect.healing": "น้ำยาฟื้นฟูทันทีแบบระเหย",
  "item.minecraft.lingering_potion.effect.infested": "น้ำยาติดเชื้อแบบระเหย",
  "item.minecraft.lingering_potion.effect.invisibility": "น้ำยาล่องหนแบบระเหย",
  "item.minecraft.lingering_potion.effect.leaping": "น้ำยากระโดดสูงแบบระเหย",
  "item.minecraft.lingering_potion.effect.levitation": "น้ำยาลอยตัวแบบระเหย",
  "item.minecraft.lingering_potion.effect.luck": "น้ำยาโชคดีแบบระเหย",
  "item.minecraft.lingering_potion.effect.mundane": "น้ำยาปกติแบบระเหย",
  "item.minecraft.lingering_potion.effect.night_vision": "น้ำยามองกลางคืนแบบระเหย",
  "item.minecraft.lingering_potion.effect.oozing": "น้ำยาไหลซึมแบบระเหย",
  "item.minecraft.lingering_potion.effect.poison": "น้ำยาพิษแบบระเหย",
  "item.minecraft.lingering_potion.effect.regeneration": "น้ำยาฟื้นฟูต่อเนื่องแบบระเหย",
  "item.minecraft.lingering_potion.effect.slow_falling": "น้ำยาตกนุ่มนวลแบบระเหย",
  "item.minecraft.lingering_potion.effect.slowness": "น้ำยาเชื่องช้าแบบระเหย",
  "item.minecraft.lingering_potion.effect.strength": "น้ำยาโจมตีแรงแบบระเหย",
  "item.minecraft.lingering_potion.effect.swiftness": "น้ำยาคล่องแคล่วแบบระเหย",
  "item.minecraft.lingering_potion.effect.thick": "น้ำยาเข้มข้นแบบระเหย",
  "item.minecraft.lingering_potion.effect.turtle_master": "น้ำยาเทพเต่าแบบระเหย",
  "item.minecraft.lingering_potion.effect.water": "ขวดน้ำแบบระเหย",
  "item.minecraft.lingering_potion.effect.water_breathing": "น้ำยาหายใจใต้น้ำแบบระเหย",
  "item.minecraft.lingering_potion.effect.weakness": "น้ำยาโจมตีเบาแบบระเหย",
  "item.minecraft.lingering_potion.effect.weaving": "น้ำยาถักทอแบบระเหย",
  "item.minecraft.lingering_potion.effect.wind_charged": "น้ำยาติดประจุลมแบบระเหย",
  "item.minecraft.llama_spawn_egg": "ไข่เกิดลามะ",
  "item.minecraft.lodestone_compass": "เข็มทิศหาหินนำทาง",
  "item.minecraft.mace": "คทา",
  "item.minecraft.magenta_bundle": "ถุงหนังสีบานเย็น",
  "item.minecraft.magenta_dye": "สีย้อมสีบานเย็น",
  "item.minecraft.magenta_harness": "บังเหียนสีบานเย็น",
  "item.minecraft.magma_cream": "ครีมแม็กม่า",
  "item.minecraft.magma_cube_spawn_egg": "ไข่เกิดสไลม์ไฟ",
  "item.minecraft.mangrove_boat": "เรือไม้โกงกาง",
  "item.minecraft.mangrove_chest_boat": "เรือไม้โกงกางพร้อมหีบ",
  "item.minecraft.map": "แผนที่เปล่า",
  "item.minecraft.melon_seeds": "เมล็ดแตงโม",
  "item.minecraft.melon_slice": "ชิ้นแตงโม",
  "item.minecraft.milk_bucket": "ถังนม",
  "item.minecraft.minecart": "รถราง",
  "item.minecraft.miner_pottery_shard": "เศษเครื่องปั้นดินเผาลายนักขุดเหมือง",
  "item.minecraft.miner_pottery_sherd": "เศษเครื่องปั้นดินเผาลายนักขุดเหมือง",
  "item.minecraft.mojang_banner_pattern": "แบบลายธง",
  "item.minecraft.mojang_banner_pattern.desc": "สิ่ง",
  "item.minecraft.mojang_banner_pattern.new": "แบบลายธงสิ่ง",
  "item.minecraft.mooshroom_spawn_egg": "ไข่เกิดมูชรูม",
  "item.minecraft.mourner_pottery_shard": "เศษเครื่องปั้นดินเผาลายวอร์เดน",
  "item.minecraft.mourner_pottery_sherd": "เศษเครื่องปั้นดินเผาลายวอร์เดน",
  "item.minecraft.mule_spawn_egg": "ไข่เกิดล่อ",
  "item.minecraft.mushroom_stew": "สตูเห็ด",
  "item.minecraft.music_disc_11": "แผ่นเสียง",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "แผ่นเสียง",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "แผ่นเสียง",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "แผ่นเสียง",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "แผ่นเสียง",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "แผ่นเสียง",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "แผ่นเสียง",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "แผ่นเสียง",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (กล่องดนตรี)",
  "item.minecraft.music_disc_far": "แผ่นเสียง",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "แผ่นเสียง",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "แผ่นเสียง",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "แผ่นเสียง",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "แผ่นเสียง",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "แผ่นเสียง",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "แผ่นเสียง",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "แผ่นเสียง",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "แผ่นเสียง",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "แผ่นเสียง",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "แผ่นเสียง",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "แผ่นเสียง",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "แผ่นเสียง",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "เนื้อแกะดิบ",
  "item.minecraft.name_tag": "ป้ายชื่อ",
  "item.minecraft.nautilus_shell": "เปลือกหอยงวงช้าง",
  "item.minecraft.nautilus_spawn_egg": "ไข่เกิดหอยงวงช้าง",
  "item.minecraft.nether_brick": "อิฐเนเธอร์",
  "item.minecraft.nether_star": "ดาวเนเธอร์",
  "item.minecraft.nether_wart": "หูดเนเธอร์",
  "item.minecraft.netherite_axe": "ขวานเนเธอไรต์",
  "item.minecraft.netherite_boots": "รองเท้าเนเธอไรต์",
  "item.minecraft.netherite_chestplate": "เสื้อเกราะเนเธอไรต์",
  "item.minecraft.netherite_helmet": "หมวกเนเธอไรต์",
  "item.minecraft.netherite_hoe": "จอบเนเธอไรต์",
  "item.minecraft.netherite_horse_armor": "เกราะม้าเนเธอไรต์",
  "item.minecraft.netherite_ingot": "แท่งเนเธอไรต์",
  "item.minecraft.netherite_leggings": "กางเกงเนเธอไรต์",
  "item.minecraft.netherite_nautilus_armor": "เกราะหอยงวงช้างเนเธอไรต์",
  "item.minecraft.netherite_pickaxe": "อีเต้อเนเธอไรต์",
  "item.minecraft.netherite_scrap": "เศษเนเธอไรต์",
  "item.minecraft.netherite_shovel": "พลั่วเนเธอไรต์",
  "item.minecraft.netherite_spear": "หอกเนเธอไรต์",
  "item.minecraft.netherite_sword": "ดาบเนเธอไรต์",
  "item.minecraft.netherite_upgrade_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.netherite_upgrade_smithing_template.new": "อัปเกรดเนเธอไรต์",
  "item.minecraft.oak_boat": "เรือไม้โอ๊ก",
  "item.minecraft.oak_chest_boat": "เรือไม้โอ๊กพร้อมหีบ",
  "item.minecraft.ocelot_spawn_egg": "ไข่เกิดแมวป่า",
  "item.minecraft.ominous_bottle": "ขวดแห่งลางร้าย",
  "item.minecraft.ominous_trial_key": "กุญแจบททดสอบแห่งลางร้าย",
  "item.minecraft.orange_bundle": "ถุงหนังสีส้ม",
  "item.minecraft.orange_dye": "สีย้อมสีส้ม",
  "item.minecraft.orange_harness": "บังเหียนสีส้ม",
  "item.minecraft.painting": "ภาพวาด",
  "item.minecraft.pale_oak_boat": "เรือไม้โอ๊กซีด",
  "item.minecraft.pale_oak_chest_boat": "เรือไม้โอ๊กซีดพร้อมหีบ",
  "item.minecraft.panda_spawn_egg": "ไข่เกิดหมีแพนด้า",
  "item.minecraft.paper": "กระดาษ",
  "item.minecraft.parched_spawn_egg": "ไข่เกิดโครงกระดูกทะเลทราย",
  "item.minecraft.parrot_spawn_egg": "ไข่เกิดนกแก้ว",
  "item.minecraft.phantom_membrane": "เยื่อแฟนท่อม",
  "item.minecraft.phantom_spawn_egg": "ไข่เกิดแฟนท่อม",
  "item.minecraft.pig_spawn_egg": "ไข่เกิดหมู",
  "item.minecraft.piglin_banner_pattern": "แบบลายธง",
  "item.minecraft.piglin_banner_pattern.desc": "จมูกหมู",
  "item.minecraft.piglin_banner_pattern.new": "แบบลายธงจมูกหมู",
  "item.minecraft.piglin_brute_spawn_egg": "ไข่เกิดพิกลินขาโหด",
  "item.minecraft.piglin_spawn_egg": "ไข่เกิดพิกลิน",
  "item.minecraft.pillager_spawn_egg": "ไข่เกิดกองโจร",
  "item.minecraft.pink_bundle": "ถุงหนังสีชมพู",
  "item.minecraft.pink_dye": "สีย้อมสีชมพู",
  "item.minecraft.pink_harness": "บังเหียนสีชมพู",
  "item.minecraft.pitcher_plant": "ต้นหม้อข้าวหม้อแกงลิง",
  "item.minecraft.pitcher_pod": "เมล็ดหม้อข้าวหม้อแกงลิง",
  "item.minecraft.plenty_pottery_shard": "เศษเครื่องปั้นดินเผาลายหีบ",
  "item.minecraft.plenty_pottery_sherd": "เศษเครื่องปั้นดินเผาลายหีบ",
  "item.minecraft.poisonous_potato": "มันฝรั่งพิษ",
  "item.minecraft.polar_bear_spawn_egg": "ไข่เกิดหมีขั้วโลก",
  "item.minecraft.popped_chorus_fruit": "ผลคอรัสสุก",
  "item.minecraft.porkchop": "เนื้อหมูดิบ",
  "item.minecraft.potato": "มันฝรั่ง",
  "item.minecraft.potion": "น้ำยา",
  "item.minecraft.potion.effect.awkward": "น้ำยาเจื่อน",
  "item.minecraft.potion.effect.empty": "น้ำยาที่ไม่สามารถปรุงได้",
  "item.minecraft.potion.effect.fire_resistance": "น้ำยากันไฟ",
  "item.minecraft.potion.effect.harming": "น้ำยาเสียเลือด",
  "item.minecraft.potion.effect.healing": "น้ำยาฟื้นฟูทันที",
  "item.minecraft.potion.effect.infested": "น้ำยาติดเชื้อ",
  "item.minecraft.potion.effect.invisibility": "น้ำยาล่องหน",
  "item.minecraft.potion.effect.leaping": "น้ำยากระโดดสูง",
  "item.minecraft.potion.effect.levitation": "น้ำยาลอยตัว",
  "item.minecraft.potion.effect.luck": "น้ำยาโชคดี",
  "item.minecraft.potion.effect.mundane": "น้ำยาปกติ",
  "item.minecraft.potion.effect.night_vision": "น้ำยามองกลางคืน",
  "item.minecraft.potion.effect.oozing": "น้ำยาไหลซึม",
  "item.minecraft.potion.effect.poison": "น้ำยาพิษ",
  "item.minecraft.potion.effect.regeneration": "น้ำยาฟื้นฟูต่อเนื่อง",
  "item.minecraft.potion.effect.slow_falling": "น้ำยาตกนุ่มนวล",
  "item.minecraft.potion.effect.slowness": "น้ำยาเชื่องช้า",
  "item.minecraft.potion.effect.strength": "น้ำยาโจมตีแรง",
  "item.minecraft.potion.effect.swiftness": "น้ำยาคล่องแคล่ว",
  "item.minecraft.potion.effect.thick": "น้ำยาเข้มข้น",
  "item.minecraft.potion.effect.turtle_master": "น้ำยาเทพเต่า",
  "item.minecraft.potion.effect.water": "ขวดน้ำ",
  "item.minecraft.potion.effect.water_breathing": "น้ำยาหายใจใต้น้ำ",
  "item.minecraft.potion.effect.weakness": "น้ำยาโจมตีเบา",
  "item.minecraft.potion.effect.weaving": "น้ำยาถักทอ",
  "item.minecraft.potion.effect.wind_charged": "น้ำยาติดประจุลม",
  "item.minecraft.pottery_shard_archer": "เศษเครื่องปั้นดินเผาลายธนู",
  "item.minecraft.pottery_shard_arms_up": "เศษเครื่องปั้นดินเผาลายคนยกแขน",
  "item.minecraft.pottery_shard_prize": "เศษเครื่องปั้นดินเผาลายเพชร",
  "item.minecraft.pottery_shard_skull": "เศษเครื่องปั้นดินเผาลายกะโหลก",
  "item.minecraft.powder_snow_bucket": "ถังหิมะผง",
  "item.minecraft.prismarine_crystals": "ผลึกพริสมารีน",
  "item.minecraft.prismarine_shard": "เศษพริสมารีน",
  "item.minecraft.prize_pottery_shard": "เศษเครื่องปั้นดินเผาลายเพชร",
  "item.minecraft.prize_pottery_sherd": "เศษเครื่องปั้นดินเผาลายเพชร",
  "item.minecraft.pufferfish": "ปลาปักเป้า",
  "item.minecraft.pufferfish_bucket": "ถังปลาปักเป้า",
  "item.minecraft.pufferfish_spawn_egg": "ไข่เกิดปลาปักเป้า",
  "item.minecraft.pumpkin_pie": "พายฟักทอง",
  "item.minecraft.pumpkin_seeds": "เมล็ดฟักทอง",
  "item.minecraft.purple_bundle": "ถุงหนังสีม่วง",
  "item.minecraft.purple_dye": "สีย้อมสีม่วง",
  "item.minecraft.purple_harness": "บังเหียนสีม่วง",
  "item.minecraft.quartz": "ควอตซ์เนเธอร์",
  "item.minecraft.rabbit": "เนื้อกระต่ายดิบ",
  "item.minecraft.rabbit_foot": "เท้ากระต่าย",
  "item.minecraft.rabbit_hide": "หนังกระต่าย",
  "item.minecraft.rabbit_spawn_egg": "ไข่เกิดกระต่าย",
  "item.minecraft.rabbit_stew": "สตูกระต่าย",
  "item.minecraft.raiser_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "ลายแต่งเกราะคนเลี้ยงสัตว์",
  "item.minecraft.ravager_spawn_egg": "ไข่เกิดปีศาจปล้นสะดม",
  "item.minecraft.raw_copper": "ทองแดงดิบ",
  "item.minecraft.raw_gold": "ทองดิบ",
  "item.minecraft.raw_iron": "เหล็กดิบ",
  "item.minecraft.recovery_compass": "เข็มทิศหวนคืน",
  "item.minecraft.red_bundle": "ถุงหนังสีแดง",
  "item.minecraft.red_dye": "สีย้อมสีแดง",
  "item.minecraft.red_harness": "บังเหียนสีแดง",
  "item.minecraft.redstone": "ผงเรดสโตน",
  "item.minecraft.resin_brick": "อิฐยางไม้",
  "item.minecraft.resin_clump": "ก้อนยางไม้",
  "item.minecraft.rib_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.rib_armor_trim_smithing_template.new": "ลายแต่งเกราะซี่โครง",
  "item.minecraft.rotten_flesh": "เนื้อเน่า",
  "item.minecraft.saddle": "อาน",
  "item.minecraft.salmon": "ปลาแซลมอนดิบ",
  "item.minecraft.salmon_bucket": "ถังปลาแซลมอน",
  "item.minecraft.salmon_spawn_egg": "ไข่เกิดปลาแซลมอน",
  "item.minecraft.scrape_pottery_sherd": "เศษเครื่องปั้นดินเผาลายขวาน",
  "item.minecraft.scute": "เกล็ด",
  "item.minecraft.sentry_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "ลายแต่งเกราะทหารยาม",
  "item.minecraft.shaper_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "ลายแต่งเกราะรูปร่าง",
  "item.minecraft.sheaf_pottery_shard": "เศษเครื่องปั้นดินเผาลายมัดข้าว",
  "item.minecraft.sheaf_pottery_sherd": "เศษเครื่องปั้นดินเผาลายมัดข้าว",
  "item.minecraft.shears": "กรรไกร",
  "item.minecraft.sheep_spawn_egg": "ไข่เกิดแกะ",
  "item.minecraft.shelter_pottery_shard": "เศษเครื่องปั้นดินเผาลายร่มไม้ชายคา",
  "item.minecraft.shelter_pottery_sherd": "เศษเครื่องปั้นดินเผาลายร่มไม้ชายคา",
  "item.minecraft.shield": "โล่",
  "item.minecraft.shield.black": "โล่สีดำ",
  "item.minecraft.shield.blue": "โล่สีน้ำเงิน",
  "item.minecraft.shield.brown": "โล่สีน้ำตาล",
  "item.minecraft.shield.cyan": "โล่สีฟ้าคราม",
  "item.minecraft.shield.gray": "โล่สีเทา",
  "item.minecraft.shield.green": "โล่สีเขียว",
  "item.minecraft.shield.light_blue": "โล่สีฟ้า",
  "item.minecraft.shield.light_gray": "โล่สีเทาอ่อน",
  "item.minecraft.shield.lime": "โล่สีเขียวอ่อน",
  "item.minecraft.shield.magenta": "โล่สีบานเย็น",
  "item.minecraft.shield.orange": "โล่สีส้ม",
  "item.minecraft.shield.pink": "โล่สีชมพู",
  "item.minecraft.shield.purple": "โล่สีม่วง",
  "item.minecraft.shield.red": "โล่สีแดง",
  "item.minecraft.shield.white": "โล่สีขาว",
  "item.minecraft.shield.yellow": "โล่สีเหลือง",
  "item.minecraft.shulker_shell": "เปลือกชัลเกอร์",
  "item.minecraft.shulker_spawn_egg": "ไข่เกิดชัลเกอร์",
  "item.minecraft.sign": "ป้าย",
  "item.minecraft.silence_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.silence_armor_trim_smithing_template.new": "ลายแต่งเกราะเงียบสงัด",
  "item.minecraft.silverfish_spawn_egg": "ไข่เกิดแมลงสามง่าม",
  "item.minecraft.skeleton_horse_spawn_egg": "ไข่เกิดม้าโครงกระดูก",
  "item.minecraft.skeleton_spawn_egg": "ไข่เกิดโครงกระดูก",
  "item.minecraft.skull_banner_pattern": "แบบลายธง",
  "item.minecraft.skull_banner_pattern.desc": "ตราสัญลักษณ์กะโหลก",
  "item.minecraft.skull_banner_pattern.new": "แบบลายธงตราสัญลักษณ์กะโหลก",
  "item.minecraft.skull_pottery_shard": "เศษเครื่องปั้นดินเผาลายกะโหลก",
  "item.minecraft.skull_pottery_sherd": "เศษเครื่องปั้นดินเผาลายกะโหลก",
  "item.minecraft.slime_ball": "ก้อนสไลม์",
  "item.minecraft.slime_spawn_egg": "ไข่เกิดสไลม์",
  "item.minecraft.smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.smithing_template.applies_to": "ใช้กับ:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "เพิ่มแท่งแร่หรือผลึก",
  "item.minecraft.smithing_template.armor_trim.applies_to": "เกราะ",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "เพิ่มส่วนชุดเกราะ",
  "item.minecraft.smithing_template.armor_trim.ingredients": "แท่งแร่และผลึก",
  "item.minecraft.smithing_template.ingredients": "วัตถุดิบ:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "เพิ่มแท่งเนเธอไรต์",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "อุปกรณ์เพชร",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "เพิ่มเกราะ อาวุธ หรืออุปกรณ์เพชร",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "แท่งเนเธอไรต์",
  "item.minecraft.smithing_template.upgrade": "อัปเกรด: ",
  "item.minecraft.sniffer_spawn_egg": "ไข่เกิดสนิฟเฟอร์",
  "item.minecraft.snort_pottery_shard": "เศษเครื่องปั้นดินเผาลายสนิฟเฟอร์",
  "item.minecraft.snort_pottery_sherd": "เศษเครื่องปั้นดินเผาลายสนิฟเฟอร์",
  "item.minecraft.snout_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.snout_armor_trim_smithing_template.new": "ลายแต่งเกราะจมูกหมู",
  "item.minecraft.snow_golem_spawn_egg": "ไข่เกิดโกเลมหิมะ",
  "item.minecraft.snowball": "ก้อนหิมะ",
  "item.minecraft.spectral_arrow": "ลูกธนูเรืองแสง",
  "item.minecraft.spider_eye": "ตาแมงมุม",
  "item.minecraft.spider_spawn_egg": "ไข่เกิดแมงมุม",
  "item.minecraft.spire_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.spire_armor_trim_smithing_template.new": "ลายแต่งเกราะยอดแหลม",
  "item.minecraft.splash_potion": "น้ำยาแบบปา",
  "item.minecraft.splash_potion.effect.awkward": "น้ำยาเจื่อนแบบปา",
  "item.minecraft.splash_potion.effect.empty": "น้ำยาแบบปาที่ไม่สามารถปรุงได้",
  "item.minecraft.splash_potion.effect.fire_resistance": "น้ำยากันไฟแบบปา",
  "item.minecraft.splash_potion.effect.harming": "น้ำยาเสียเลือดแบบปา",
  "item.minecraft.splash_potion.effect.healing": "น้ำยาฟื้นฟูทันทีแบบปา",
  "item.minecraft.splash_potion.effect.infested": "น้ำยาติดเชื้อแบบปา",
  "item.minecraft.splash_potion.effect.invisibility": "น้ำยาล่องหนแบบปา",
  "item.minecraft.splash_potion.effect.leaping": "น้ำยากระโดดสูงแบบปา",
  "item.minecraft.splash_potion.effect.levitation": "น้ำยาลอยตัวแบบปา",
  "item.minecraft.splash_potion.effect.luck": "น้ำยาโชคดีแบบปา",
  "item.minecraft.splash_potion.effect.mundane": "น้ำยาปกติแบบปา",
  "item.minecraft.splash_potion.effect.night_vision": "น้ำยามองกลางคืนแบบปา",
  "item.minecraft.splash_potion.effect.oozing": "น้ำยาไหลซึมแบบปา",
  "item.minecraft.splash_potion.effect.poison": "น้ำยาพิษแบบปา",
  "item.minecraft.splash_potion.effect.regeneration": "น้ำยาฟื้นฟูต่อเนื่องแบบปา",
  "item.minecraft.splash_potion.effect.slow_falling": "น้ำยาตกนุ่มนวลแบบปา",
  "item.minecraft.splash_potion.effect.slowness": "น้ำยาเชื่องช้าแบบปา",
  "item.minecraft.splash_potion.effect.strength": "น้ำยาโจมตีแรงแบบปา",
  "item.minecraft.splash_potion.effect.swiftness": "น้ำยาคล่องแคล่วแบบปา",
  "item.minecraft.splash_potion.effect.thick": "น้ำยาเข้มข้นแบบปา",
  "item.minecraft.splash_potion.effect.turtle_master": "น้ำยาเทพเต่าแบบปา",
  "item.minecraft.splash_potion.effect.water": "ขวดน้ำแบบปา",
  "item.minecraft.splash_potion.effect.water_breathing": "น้ำยาหายใจใต้น้ำแบบปา",
  "item.minecraft.splash_potion.effect.weakness": "น้ำยาโจมตีเบาแบบปา",
  "item.minecraft.splash_potion.effect.weaving": "น้ำยาถักทอแบบปา",
  "item.minecraft.splash_potion.effect.wind_charged": "น้ำยาติดประจุลมแบบปา",
  "item.minecraft.spruce_boat": "เรือไม้สนสปรูซ",
  "item.minecraft.spruce_chest_boat": "เรือไม้สนสปรูซพร้อมหีบ",
  "item.minecraft.spyglass": "กล้องส่องทางไกล",
  "item.minecraft.squid_spawn_egg": "ไข่เกิดหมึก",
  "item.minecraft.stick": "แท่งไม้",
  "item.minecraft.stone_axe": "ขวานหิน",
  "item.minecraft.stone_hoe": "จอบหิน",
  "item.minecraft.stone_pickaxe": "อีเต้อหิน",
  "item.minecraft.stone_shovel": "พลั่วหิน",
  "item.minecraft.stone_spear": "หอกหิน",
  "item.minecraft.stone_sword": "ดาบหิน",
  "item.minecraft.stray_spawn_egg": "ไข่เกิดโครงกระดูกน้ำแข็ง",
  "item.minecraft.strider_spawn_egg": "ไข่เกิดสไตรเดอร์",
  "item.minecraft.string": "เส้นใย",
  "item.minecraft.sugar": "น้ำตาล",
  "item.minecraft.suspicious_stew": "สตูพิศวง",
  "item.minecraft.sweet_berries": "เบอร์รี่หวาน",
  "item.minecraft.tadpole_bucket": "ถังลูกอ๊อด",
  "item.minecraft.tadpole_spawn_egg": "ไข่เกิดลูกอ๊อด",
  "item.minecraft.tide_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.tide_armor_trim_smithing_template.new": "ลายแต่งเกราะน้ำขึ้นน้ำลง",
  "item.minecraft.tipped_arrow": "ลูกธนูอาบยา",
  "item.minecraft.tipped_arrow.effect.awkward": "ลูกธนูอาบยา",
  "item.minecraft.tipped_arrow.effect.empty": "ลูกธนูอาบยาที่ไม่สามารถปรุงได้",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "ลูกธนูอาบยากันไฟ",
  "item.minecraft.tipped_arrow.effect.harming": "ลูกธนูอาบยาเสียเลือด",
  "item.minecraft.tipped_arrow.effect.healing": "ลูกธนูอาบยาฟื้นฟูทันที",
  "item.minecraft.tipped_arrow.effect.infested": "ลูกธนูอาบยาติดเชื้อ",
  "item.minecraft.tipped_arrow.effect.invisibility": "ลูกธนูอาบยาล่องหน",
  "item.minecraft.tipped_arrow.effect.leaping": "ลูกธนูอาบยากระโดดสูง",
  "item.minecraft.tipped_arrow.effect.levitation": "ลูกธนูอาบยาลอยตัว",
  "item.minecraft.tipped_arrow.effect.luck": "ลูกธนูอาบยาโชคดี",
  "item.minecraft.tipped_arrow.effect.mundane": "ลูกธนูอาบยา",
  "item.minecraft.tipped_arrow.effect.night_vision": "ลูกธนูอาบยามองกลางคืน",
  "item.minecraft.tipped_arrow.effect.oozing": "ลูกธนูอาบยาไหลซึม",
  "item.minecraft.tipped_arrow.effect.poison": "ลูกธนูอาบยาพิษ",
  "item.minecraft.tipped_arrow.effect.regeneration": "ลูกธนูอาบยาฟื้นฟูต่อเนื่อง",
  "item.minecraft.tipped_arrow.effect.slow_falling": "ลูกธนูอาบยาตกนุ่มนวล",
  "item.minecraft.tipped_arrow.effect.slowness": "ลูกธนูอาบยาเชื่องช้า",
  "item.minecraft.tipped_arrow.effect.strength": "ลูกธนูอาบยาโจมตีแรง",
  "item.minecraft.tipped_arrow.effect.swiftness": "ลูกธนูอาบยาคล่องแคล่ว",
  "item.minecraft.tipped_arrow.effect.thick": "ลูกธนูอาบยา",
  "item.minecraft.tipped_arrow.effect.turtle_master": "ลูกธนูอาบยาเทพเต่า",
  "item.minecraft.tipped_arrow.effect.water": "ลูกธนูอาบน้ำ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "ลูกธนูอาบยาหายใจใต้น้ำ",
  "item.minecraft.tipped_arrow.effect.weakness": "ลูกธนูอาบยาโจมตีเบา",
  "item.minecraft.tipped_arrow.effect.weaving": "ลูกธนูอาบยาถักทอ",
  "item.minecraft.tipped_arrow.effect.wind_charged": "ลูกธนูอาบยาติดประจุลม",
  "item.minecraft.tnt_minecart": "รถรางพร้อมระเบิดทีเอ็นที",
  "item.minecraft.torchflower_seeds": "เมล็ดดอกคบเพลิง",
  "item.minecraft.totem_of_undying": "เครื่องรางคลาดแคล้ว",
  "item.minecraft.trader_llama_spawn_egg": "ไข่เกิดลามาพ่อค้า",
  "item.minecraft.trial_key": "กุญแจบททดสอบ",
  "item.minecraft.trident": "ตรีศูล",
  "item.minecraft.tropical_fish": "ปลาเขตร้อน",
  "item.minecraft.tropical_fish_bucket": "ถังปลาเขตร้อน",
  "item.minecraft.tropical_fish_spawn_egg": "ไข่เกิดปลาเขตร้อน",
  "item.minecraft.turtle_helmet": "กระดองเต่า",
  "item.minecraft.turtle_scute": "เกล็ดเต่า",
  "item.minecraft.turtle_spawn_egg": "ไข่เกิดเต่า",
  "item.minecraft.vex_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.vex_armor_trim_smithing_template.new": "ลายแต่งเกราะเวกซ์",
  "item.minecraft.vex_spawn_egg": "ไข่เกิดเวกซ์",
  "item.minecraft.villager_spawn_egg": "ไข่เกิดชาวบ้าน",
  "item.minecraft.vindicator_spawn_egg": "ไข่เกิดวินดิเคเตอร์",
  "item.minecraft.wandering_trader_spawn_egg": "ไข่เกิดพ่อค้าเร่ร่อน",
  "item.minecraft.ward_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.ward_armor_trim_smithing_template.new": "ลายแต่งเกราะผู้คุม",
  "item.minecraft.warden_spawn_egg": "ไข่เกิดวอร์เดน",
  "item.minecraft.warped_fungus_on_a_stick": "เห็ดราป่าวิปริตติดเบ็ด",
  "item.minecraft.water_bucket": "ถังน้ำ",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "ลายแต่งเกราะผู้นำทาง",
  "item.minecraft.wheat": "ข้าวสาลี",
  "item.minecraft.wheat_seeds": "เมล็ดข้าวสาลี",
  "item.minecraft.white_bundle": "ถุงหนังสีขาว",
  "item.minecraft.white_dye": "สีย้อมสีขาว",
  "item.minecraft.white_harness": "บังเหียนสีขาว",
  "item.minecraft.wild_armor_trim_smithing_template": "แม่พิมพ์หล่อ",
  "item.minecraft.wild_armor_trim_smithing_template.new": "ลายแต่งเกราะป่าดง",
  "item.minecraft.wind_charge": "ประจุลม",
  "item.minecraft.witch_spawn_egg": "ไข่เกิดแม่มด",
  "item.minecraft.wither_skeleton_spawn_egg": "ไข่เกิดโครงกระดูกวิทเธอร์",
  "item.minecraft.wither_spawn_egg": "ไข่เกิดวิทเธอร์",
  "item.minecraft.wolf_armor": "เกราะหมา",
  "item.minecraft.wolf_spawn_egg": "ไข่เกิดหมาป่า",
  "item.minecraft.wooden_axe": "ขวานไม้",
  "item.minecraft.wooden_hoe": "จอบไม้",
  "item.minecraft.wooden_pickaxe": "อีเต้อไม้",
  "item.minecraft.wooden_shovel": "พลั่วไม้",
  "item.minecraft.wooden_spear": "หอกไม้",
  "item.minecraft.wooden_sword": "ดาบไม้",
  "item.minecraft.writable_book": "หนังสือกับปากกาขนนก",
  "item.minecraft.written_book": "หนังสือเขียนแล้ว",
  "item.minecraft.yellow_bundle": "ถุงหนังสีเหลือง",
  "item.minecraft.yellow_dye": "สีย้อมสีเหลือง",
  "item.minecraft.yellow_harness": "บังเหียนสีเหลือง",
  "item.minecraft.zoglin_spawn_egg": "ไข่เกิดซอกลิน",
  "item.minecraft.zombie_horse_spawn_egg": "ไข่เกิดม้าซอมบี้",
  "item.minecraft.zombie_nautilus_spawn_egg": "ไข่เกิดหอยงวงช้างซอมบี้",
  "item.minecraft.zombie_spawn_egg": "ไข่เกิดซอมบี้",
  "item.minecraft.zombie_villager_spawn_egg": "ไข่เกิดชาวบ้านซอมบี้",
  "item.minecraft.zombified_piglin_spawn_egg": "ไข่เกิดพิกลินซอมบี้"
}
export const th_th = items; 
